webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularCookies = __webpack_require__(3);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularResource = __webpack_require__(5);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _angularSanitize = __webpack_require__(7);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _angularAnimate = __webpack_require__(9);
	
	var _angularAnimate2 = _interopRequireDefault(_angularAnimate);
	
	var _app = __webpack_require__(11);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _usuarioRoute = __webpack_require__(22);
	
	var _usuarioRoute2 = _interopRequireDefault(_usuarioRoute);
	
	var _articuloRoute = __webpack_require__(30);
	
	var _articuloRoute2 = _interopRequireDefault(_articuloRoute);
	
	var _buscarArticuloRoute = __webpack_require__(39);
	
	var _buscarArticuloRoute2 = _interopRequireDefault(_buscarArticuloRoute);
	
	var _carritoRoute = __webpack_require__(42);
	
	var _carritoRoute2 = _interopRequireDefault(_carritoRoute);
	
	var _contactoRoute = __webpack_require__(46);
	
	var _contactoRoute2 = _interopRequireDefault(_contactoRoute);
	
	var _descargasRoute = __webpack_require__(50);
	
	var _descargasRoute2 = _interopRequireDefault(_descargasRoute);
	
	var _configuracionRoute = __webpack_require__(58);
	
	var _configuracionRoute2 = _interopRequireDefault(_configuracionRoute);
	
	var _ordenesRoute = __webpack_require__(66);
	
	var _ordenesRoute2 = _interopRequireDefault(_ordenesRoute);
	
	var _historialRoute = __webpack_require__(72);
	
	var _historialRoute2 = _interopRequireDefault(_historialRoute);
	
	var _categoriasRoute = __webpack_require__(78);
	
	var _categoriasRoute2 = _interopRequireDefault(_categoriasRoute);
	
	var _mainRoute = __webpack_require__(84);
	
	var _mainRoute2 = _interopRequireDefault(_mainRoute);
	
	var _auth = __webpack_require__(88);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _navbar = __webpack_require__(100);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _mainHeader = __webpack_require__(102);
	
	var _mainHeader2 = _interopRequireDefault(_mainHeader);
	
	var _articulo = __webpack_require__(104);
	
	var _articulo2 = _interopRequireDefault(_articulo);
	
	var _carousel = __webpack_require__(110);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	var _footer = __webpack_require__(113);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _util = __webpack_require__(91);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _linkEditar = __webpack_require__(115);
	
	var _linkEditar2 = _interopRequireDefault(_linkEditar);
	
	var _articulosPagination = __webpack_require__(118);
	
	var _articulosPagination2 = _interopRequireDefault(_articulosPagination);
	
	var _app2 = __webpack_require__(89);
	
	var _app3 = _interopRequireDefault(_app2);
	
	var _angularjsToaster = __webpack_require__(121);
	
	var _angularjsToaster2 = _interopRequireDefault(_angularjsToaster);
	
	var _ngFileUpload = __webpack_require__(123);
	
	var _ngFileUpload2 = _interopRequireDefault(_ngFileUpload);
	
	__webpack_require__(125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ngRoute = __webpack_require__(20);
	
	_angular2.default.module('pizzutoAutopartesApp', [_angularCookies2.default, _angularResource2.default, _angularSanitize2.default, ngRoute, _angularAnimate2.default, _account2.default, _usuarioRoute2.default, _articuloRoute2.default, _buscarArticuloRoute2.default, _carritoRoute2.default, _contactoRoute2.default, _descargasRoute2.default, _configuracionRoute2.default, _mainRoute2.default, _ordenesRoute2.default, _historialRoute2.default, _categoriasRoute2.default, _auth2.default, _articulo2.default, _navbar2.default, _carousel2.default, _mainHeader2.default, _footer2.default, _app3.default, _util2.default, _linkEditar2.default, _articulosPagination2.default, _ngFileUpload2.default, _angularjsToaster2.default]).config(_app.routeConfig).run(['$rootScope', '$location', 'Auth', function ($rootScope, $location, Auth) {
	    'ngInject';
	
	    $rootScope.$on('$routeChangeStart', function (event, next) {
	        Auth.isLoggedIn(function (loggedIn) {
	            if (next.authenticate && !loggedIn || next.administrator && loggedIn !== 'admin') {
	                event.preventDefault();
	                $location.path('/');
	            }
	        });
	    });
	}]);
	
	_angular2.default.element(document).ready(function () {
	    _angular2.default.bootstrap(document, ['pizzutoAutopartesApp'], {
	        strictDi: true
	    });
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports) {

	'use strict';
	
	routeConfig.$inject = ['$routeProvider', '$locationProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.routeConfig = routeConfig;
	function routeConfig($routeProvider, $locationProvider) {
	    'ngInject';
	
	    $routeProvider.otherwise({
	        redirectTo: '/'
	    });
	
	    $locationProvider.html5Mode(true);
	}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _account = __webpack_require__(13);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _login = __webpack_require__(16);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _settings = __webpack_require__(18);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ngRoute = __webpack_require__(20);
	
	exports.default = _angular2.default.module('pizzutoAutopartesApp.account', [ngRoute, _login2.default, _settings2.default]).config(_account2.default).run(['$rootScope', function ($rootScope) {
	    'ngInject';
	
	    $rootScope.$on('$routeChangeStart', function (event, next, current) {
	        if (next.name === 'logout' && current && current.originalPath && !current.authenticate) {
	            next.referrer = current.originalPath;
	        }
	    });
	}]).name;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	routes.$inject = ['$routeProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	function routes($routeProvider) {
	    'ngInject';
	
	    $routeProvider.when('/login', {
	        template: __webpack_require__(14),
	        controller: 'LoginController',
	        controllerAs: 'vm'
	    }).when('/logout', {
	        name: 'logout',
	        referrer: '/',
	        template: '',
	        controller: ['$location', '$route', 'Auth', function controller($location, $route, Auth) {
	            var referrer = $route.current.params.referrer || $route.current.referrer || '/';
	            Auth.logout();
	            $location.path('/');
	        }]
	    }).when('/settings', {
	        template: __webpack_require__(15),
	        controller: 'SettingsController',
	        controllerAs: 'vm',
	        authenticate: true
	    });
	}

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <br>\n    <div class=\"row\">\n        <div class=\"col-12 col-lg-8 offset-0 offset-lg-2\" style=\"margin-bottom: -20px;\">\n            <h1 class=\"text-center\">\n                <p class=\"alert alert-info\"> Iniciar sesion</p>\n            </h1>\n            <!--<p>Accounts are reset on server restart from <code>server/config/seed.js</code>. Default account is <code>test@example.com</code> / <code>test</code></p>-->\n            <!--<p>Admin account is <code>admin@example.com</code> / <code>admin</code></p>-->\n        </div>\n        <div class=\"col-12 col-lg-8 offset-0 offset-lg-2\">\n            <form class=\"formulario-background\" name=\"form\" ng-submit=\"vm.login(form)\" novalidate>\n\n                <div class=\"form-group\">\n                    <label>Email / Usuario</label>\n\n                    <input type=\"text\" name=\"email\" class=\"form-control\" ng-model=\"vm.user.email\" required>\n                </div>\n\n                <div class=\"form-group\">\n                    <label>Clave</label>\n\n                    <input type=\"password\" name=\"password\" class=\"form-control\" ng-model=\"vm.user.password\" required>\n                </div>\n\n                <div class=\"form-group has-error\">\n                    <p class=\"help-block\" ng-show=\"form.email.$error.required && form.password.$error.required && vm.submitted\">\n                        Por favor ingrese un email y clave.\n                    </p>\n                    <p class=\"help-block\" ng-show=\"form.email.$error.email && vm.submitted\">\n                        Por favor ingrese un email valido.\n                    </p>\n\n                    <p class=\"help-block\">{{ vm.errors.login }}</p>\n                </div>\n\n                <div>\n                    <div class=\"row\">\n                        <div class=\"col-12\">\n                            <button class=\"btn btn-outline-info btn-lg pull-right\" type=\"submit\">\n                                Entrar\n                                <span class=\"fa fa-sign-in\"></span>\n                            </button>\n                        </div>\n                    </div>\n                    <!--<a class=\"btn btn-default btn-lg btn-register\" href=\"/signup\">-->\n                    <!--Register-->\n                    <!--</a>-->\n\n                </div>\n\n            </form>\n        </div>\n    </div>\n</div>\n<br>\n"

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <br>\n    <div class=\"row\">\n        <div class=\"col-12 col-lg-8 offset-0 offset-lg-2\" style=\"margin-bottom: -20px;\">\n            <h1 class=\"text-center\"><p class=\"alert alert-info\">Cambiar Clave</p></h1>\n        </div>\n        <div class=\"col-12 col-lg-8 offset-0 offset-lg-2\">\n            <form class=\"formulario-background\" name=\"form\" ng-submit=\"vm.changePassword(form)\" novalidate autocomplete=\"off\">\n\n                <div class=\"form-group\">\n                    <label for=\"formClaveActual\">Clave actual</label>\n\n                    <input type=\"password\" name=\"password\" class=\"form-control\" ng-model=\"vm.user.oldPassword\" id=\"formClaveActual\"\n                           mongoose-error/>\n                    <p class=\"help-block\" ng-show=\"form.password.$error.mongoose\">\n                        {{ vm.errors.other }}\n                    </p>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"formNuevaClave\">Nueva clave</label>\n\n                    <input type=\"password\" name=\"newPassword\" class=\"form-control\" ng-model=\"vm.user.newPassword\" id=\"formNuevaClave\"\n                           ng-minlength=\"3\"\n                           required/>\n                    <p class=\"help-block\"\n                       ng-show=\"(form.newPassword.$error.minlength || form.newPassword.$error.required) && (form.newPassword.$dirty || vm.submitted)\">\n                        La clave debe tener al menos 3 caracteres.\n                    </p>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"formConfirmarNuevaClave\">Confirme Nueva clave</label>\n\n                    <input type=\"password\" name=\"confirmPassword\" class=\"form-control\" ng-model=\"vm.user.confirmPassword\" id=\"formConfirmarNuevaClave\"\n                           match=\"vm.user.newPassword\"\n                           ng-minlength=\"3\"\n                           required=\"\"/>\n                    <p class=\"help-block\"\n                       ng-show=\"form.confirmPassword.$error.match && vm.submitted\">\n                        La clave debe coincidir\n                    </p>\n\n                </div>\n\n                <p class=\"help-block\"> {{ vm.message }} </p>\n                <div class=\"row\">\n                    <div class=\"col-12\">\n                        <button class=\"btn btn-lg btn-outline-info pull-right\" type=\"submit\">Cambiar\n                            <span class=\"fa fa-edit\"></span>\n                        </button>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n<br>\n"

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _login = __webpack_require__(17);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('pizzutoAutopartesApp.login', []).controller('LoginController', _login2.default).name;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoginController = function () {
	
	    /*@ngInject*/
	    LoginController.$inject = ['Auth', '$location'];
	    function LoginController(Auth, $location) {
	        _classCallCheck(this, LoginController);
	
	        this.user = {
	            name: '',
	            email: '',
	            password: ''
	        };
	        this.errors = {
	            login: undefined
	        };
	        this.submitted = false;
	
	        this.Auth = Auth;
	        this.$location = $location;
	    }
	
	    _createClass(LoginController, [{
	        key: 'login',
	        value: function login(form) {
	            var _this = this;
	
	            this.submitted = true;
	
	            if (form.$valid) {
	                this.Auth.login({
	                    email: this.user.email,
	                    password: this.user.password
	                }).then(function () {
	                    _this.$location.path('/');
	                }).catch(function (err) {
	                    _this.errors.login = err.message;
	                });
	            }
	        }
	    }]);
	
	    return LoginController;
	}();
	
	exports.default = LoginController;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _settings = __webpack_require__(19);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('pizzutoAutopartesApp.settings', []).controller('SettingsController', _settings2.default).name;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SettingsController = function () {
	
	    /*@ngInject*/
	    SettingsController.$inject = ['Auth'];
	    function SettingsController(Auth) {
	        _classCallCheck(this, SettingsController);
	
	        this.user = {
	            oldPassword: '',
	            newPassword: '',
	            confirmPassword: ''
	        };
	        this.errors = {
	            other: undefined
	        };
	        this.message = '';
	        this.submitted = false;
	
	        this.Auth = Auth;
	    }
	
	    _createClass(SettingsController, [{
	        key: 'changePassword',
	        value: function changePassword(form) {
	            var _this = this;
	
	            this.submitted = true;
	
	            if (form.$valid) {
	                this.Auth.changePassword(this.user.oldPassword, this.user.newPassword).then(function () {
	                    _this.message = 'Password successfully changed.';
	                }).catch(function () {
	                    form.password.$setValidity('mongoose', false);
	                    _this.errors.other = 'Incorrect password';
	                    _this.message = '';
	                });
	            }
	        }
	    }]);
	
	    return SettingsController;
	}();
	
	exports.default = SettingsController;

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _usuarioRouteComponent = __webpack_require__(23);
	
	var _crearUsuario = __webpack_require__(25);
	
	var _editarUsuario = __webpack_require__(27);
	
	var _usuario = __webpack_require__(29);
	
	var _usuario2 = _interopRequireDefault(_usuario);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	var routes = function routes($routeProvider) {
	    getUsuarioPorId.$inject = ['$route', 'UsuarioService'];
	    $routeProvider.when('/usuarios', {
	        template: '<usuario-route></usuario-route>',
	        authenticate: true,
	        administrator: true
	    }).when('/usuarios/crear', {
	        template: '<crear-usuario></crear-usuario>',
	        authenticate: true,
	        administrator: true
	    }).when('/usuarios/editar/:id', {
	        template: '<editar-usuario usuario="$resolve.usuario.data"></editar-usuario>',
	        authenticate: true,
	        administrator: true,
	        resolve: {
	            usuario: getUsuarioPorId
	        }
	    });
	
	    function getUsuarioPorId($route, UsuarioService) {
	        return UsuarioService.getUsuarioPorId($route.current.params.id);
	    }
	};
	routes.$inject = ['$routeProvider'];
	
	exports.default = _angular2.default.module('pizzutoAutopartesApp.usuario', ['pizzutoAutopartesApp.auth', 'ngRoute']).component(_usuarioRouteComponent.UsuariosComponentRoute.selector, _usuarioRouteComponent.UsuariosComponentRoute).component(_crearUsuario.CrearUsuarioComponent.selector, _crearUsuario.CrearUsuarioComponent).component(_editarUsuario.EditarUsuarioComponent.selector, _editarUsuario.EditarUsuarioComponent).service('UsuarioService', _usuario2.default).config(routes).name;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UsuariosComponentRoute = exports.UsuariosComponentRoute = {
	    selector: 'usuarioRoute',
	    template: __webpack_require__(24),
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['User'];
	        function controller(User) {
	            _classCallCheck(this, controller);
	
	            this.listadoUsuarios = User.query();
	        }
	
	        _createClass(controller, [{
	            key: 'delete',
	            value: function _delete(user) {
	                user.$remove();
	                this.listadoUsuarios.splice(this.listadoUsuarios.indexOf(user), 1);
	            }
	        }, {
	            key: 'toggleUsuario',
	            value: function toggleUsuario(item, status) {
	                item.active = status;
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports = "<br>\n<div class=\"container\">\n    <div class=\"row\">\n        <div class=\"col-12\">\n            <input type=\"text\" class=\"form-control\" placeholder=\"Buscar usuario...\" ng-model=\"$ctrl.filtrarUsuario\">\n        </div>\n    </div>\n    <br>\n    <div class=\"row\">\n        <div class=\"col-12\">\n            <div class=\"card\">\n                <div class=\"card-block\">\n\n                    <div class=\"table-responsive\">\n                        <table class=\"table table-hover\">\n                            <thead>\n                                <tr>\n                                    <th>#</th>\n                                    <th>Usuario</th>\n                                    <th>Nombre</th>\n                                    <th>EMail</th>\n                                    <th>Estado</th>\n                                    <th class=\"text-center\">\n                                        <span class=\"fa fa-gear\"></span>\n                                    </th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr ng-repeat=\"item in $ctrl.listadoUsuarios | filter: $ctrl.filtrarUsuario\">\n                                    <td>{{$index + 1}}</td>\n                                    <td>{{item.datos.codigo}} - {{item.usuario}}</td>\n                                    <td>{{item.name}}</td>\n                                    <td>{{item.email}}</td>\n                                    <td class=\"text-center\">\n                                        <span class=\"badge badge-info\" ng-show=\"item.active\">ACTIVO</span>\n                                        <span class=\"badge badge-danger\" ng-show=\"!item.active\">NO ACTIVO</span>\n                                        <!--<div class=\"btn-group\">-->\n                                        <!--<button type=\"button\" class=\"btn\" ng-class=\"{'btn-outline-info': !item.active, 'btn-info': item.active}\" ng-click=\"$ctrl.toggleUsuario(item, true)\">SI</button>-->\n                                        <!--<button type=\"button\" class=\"btn\" ng-class=\"{'btn-outline-info': item.active, 'btn-info': !item.active}\" ng-click=\"$ctrl.toggleUsuario(item, false)\">NO</button>-->\n                                        <!--</div>-->\n                                    </td>\n                                    <td class=\"text-center\">\n                                        <a ng-href=\"/usuarios/editar/{{item._id}}\" class=\"btn btn-success btn-sm\">\n                                            <span class=\"fa fa-pencil\"></span>\n                                        </a>\n                                    </td>\n                                </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <br>\n</div>\n"

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CrearUsuarioComponent = exports.CrearUsuarioComponent = {
	    selector: 'crearUsuario',
	    template: __webpack_require__(26),
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['UsuarioService', '$location', 'ToasterService'];
	        function controller(UsuarioService, $location, ToasterService) {
	            _classCallCheck(this, controller);
	
	            Object.assign(this, { UsuarioService: UsuarioService, $location: $location, ToasterService: ToasterService });
	            this.usuario = {};
	        }
	
	        _createClass(controller, [{
	            key: 'crearUsuario',
	            value: function crearUsuario(form) {
	                var _this = this;
	
	                if (form.$valid) {
	                    this.UsuarioService.crearUsuario(this.usuario).then(function () {
	                        _this.ToasterService.popUp('success', 'Usuario', 'Se ha creado con éxito.');
	                        _this.$location.path('/usuarios');
	                    }).catch(function (error) {
	                        var err = error.data;
	                        if (err.errors.email) {
	                            _this.ToasterService.popUp('error', 'Usuario', err.errors.email.message);
	                        } else if (err.errors.usuario) {
	                            _this.ToasterService.popUp('error', 'Usuario', err.errors.usuario.message);
	                        } else {
	                            _this.ToasterService.popUp('error', 'Usuario', 'Error al crear el usuario.');
	                        }
	                    });
	                }
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <br>\n    <div class=\"row\">\n        <div class=\"col-12\">\n            <div class=\"card c-celeste\">\n                <div class=\"card-header\">\n                    <h1 class=\"text-center\">Crear Nuevo Usuario</h1>\n                </div>\n                <div class=\"card-block\">\n                    <div class=\"col-12\">\n                        <br>\n                        <form ng-submit=\"$ctrl.crearUsuario(formNuevoUsuario)\" name=\"formNuevoUsuario\" class=\"\"\n                              autocomplete=\"off\">\n                            <div class=\"row\">\n                                <div class=\"col-6 col-md-2\">\n                                    <div class=\"form-group\">\n                                        <label for=\"nuevoUsuarioCodigo\">Codigo</label>\n                                        <input type=\"text\" id=\"nuevoUsuarioCodigo\" class=\"form-control\"\n                                               ng-model=\"$ctrl.usuario.datos.codigo\" required>\n                                    </div>\n                                </div>\n                                <div class=\"col-6 col-md-4\">\n                                    <div class=\"form-group\">\n                                        <label for=\"nuevoUsuarioUsuario\">Usuario</label>\n                                        <input type=\"text\" id=\"nuevoUsuarioUsuario\" class=\"form-control\"\n                                               ng-model=\"$ctrl.usuario.usuario\" required>\n                                    </div>\n                                </div>\n                                <div class=\"col-12 col-md-6\">\n                                    <div class=\"form-group\">\n                                        <label for=\"nuevoUsuarioName\">Nombre completo</label>\n                                        <input type=\"text\" id=\"nuevoUsuarioName\" class=\"form-control\"\n                                               ng-model=\"$ctrl.usuario.name\" required>\n                                    </div>\n                                </div>\n\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-12 col-md-6\">\n                                    <div class=\"form-group\">\n                                        <label for=\"nuevoUsuarioEmail\" class=\"\">E-Mail</label>\n                                        <input type=\"email\" id=\"nuevoUsuarioEmail\" class=\"form-control\"\n                                               ng-model=\"$ctrl.usuario.email\" required>\n                                    </div>\n                                </div>\n                                <div class=\"col-12 col-md-6\">\n                                    <div class=\"form-group\">\n                                        <label for=\"nuevoUsuarioPassword\">Clave</label>\n                                        <input type=\"text\" id=\"nuevoUsuarioPassword\" class=\"form-control\"\n                                               ng-model=\"$ctrl.usuario.password\" required>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-12 col-md-6\">\n                                    <div class=\"form-group\">\n                                        <label for=\"nuevoUsuarioCiudad\">Ciudad</label>\n                                        <input type=\"text\" id=\"nuevoUsuarioCiudad\" class=\"form-control\"\n                                               ng-model=\"$ctrl.usuario.datos.ciudad\">\n                                    </div>\n                                </div>\n                                <div class=\"col-12 col-md-6\">\n                                    <div class=\"form-group\">\n                                        <label for=\"nuevoUsuarioDireccion\">Direccion</label>\n                                        <input type=\"text\" id=\"nuevoUsuarioDireccion\" class=\"form-control\"\n                                               ng-model=\"$ctrl.usuario.datos.direccion\">\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-12 col-md-6\">\n                                    <div class=\"form-group\">\n                                        <label for=\"nuevoUsuarioProvincia\">Provincia</label>\n                                        <input type=\"text\" id=\"nuevoUsuarioProvincia\" class=\"form-control\"\n                                               ng-model=\"$ctrl.usuario.datos.provincia\">\n                                    </div>\n                                </div>\n                                <div class=\"col-6 col-md-3\">\n                                    <div class=\"form-group\">\n                                        <label for=\"nuevoUsuarioCP\">CP</label>\n                                        <input type=\"text\" id=\"nuevoUsuarioCP\" class=\"form-control\"\n                                               ng-model=\"$ctrl.usuario.datos.cp\">\n                                    </div>\n                                </div>\n                                <div class=\"col-6 col-md-3\">\n                                    <div class=\"form-group\">\n                                        <label for=\"nuevoUsuarioTelefono\">Telefono</label>\n                                        <input type=\"text\" id=\"nuevoUsuarioTelefono\" class=\"form-control\"\n                                               ng-model=\"$ctrl.usuario.datos.telefono\">\n                                    </div>\n                                </div>\n\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-12\">\n                                    <button type=\"submit\" class=\"btn btn-outline-info pull-right btn-lg\">Crear Usuario\n                                        <span class=\"fa fa-plus\"></span>\n                                    </button>\n                                </div>\n                            </div>\n                            <br>\n                        </form>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<br>\n"

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditarUsuarioComponent = exports.EditarUsuarioComponent = {
	    selector: 'editarUsuario',
	    template: __webpack_require__(28),
	    bindings: {
	        usuario: '<'
	    },
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['UsuarioService', '$location', 'ToasterService'];
	        function controller(UsuarioService, $location, ToasterService) {
	            _classCallCheck(this, controller);
	
	            Object.assign(this, { UsuarioService: UsuarioService, $location: $location, ToasterService: ToasterService });
	        }
	
	        _createClass(controller, [{
	            key: 'editarUsuario',
	            value: function editarUsuario(form) {
	                var _this = this;
	
	                if (form.$valid) {
	                    if (!this.isNuevoPassword) {
	                        delete this.usuario.password;
	                    }
	                    this.UsuarioService.editarUsuario(this.usuario).then(function (data) {
	                        _this.ToasterService.popUp('success', 'Usuario', 'Se ha actualizado con éxito.');
	                        _this.$location.path('/usuarios');
	                    });
	                }
	            }
	        }, {
	            key: 'toggleActivo',
	            value: function toggleActivo(value) {
	                this.usuario.active = value;
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <br>\n    <div class=\"row\">\n        <div class=\"col-12\">\n            <div class=\"card c-celeste\">\n                <div class=\"card-header\">\n                    <h1 class=\"text-center mb-0\">Editar Usuario</h1>\n                </div>\n                <div class=\"card-block\">\n                    <div class=\"col-12\">\n                        <br>\n                    <form ng-submit=\"$ctrl.editarUsuario(formEditarUsuario)\" name=\"formEditarUsuario\" class=\"\" autocomplete=\"off\">\n\n\n                        <div class=\"row\">\n                            <div class=\"col-6 col-md-2\">\n                                <div class=\"form-group\">\n                                    <label for=\"nuevoUsuarioCodigo\">Codigo</label>\n                                    <input type=\"text\" id=\"nuevoUsuarioCodigo\" class=\"form-control\" ng-model=\"$ctrl.usuario.datos.codigo\" required>\n                                </div>\n                            </div>\n                            <div class=\"col-6 col-md-4\">\n                                <div class=\"form-group\">\n                                    <label for=\"nuevoUsuarioUsuario\">Usuario</label>\n                                    <input type=\"text\" id=\"nuevoUsuarioUsuario\" class=\"form-control\" ng-model=\"$ctrl.usuario.usuario\" required>\n                                </div>\n                            </div>\n                            <div class=\"col-12 col-md-6\">\n                                <div class=\"form-group\">\n                                    <label for=\"nuevoUsuarioName\">Nombre completo</label>\n                                    <input type=\"text\" id=\"nuevoUsuarioName\" class=\"form-control\" ng-model=\"$ctrl.usuario.name\" required>\n                                </div>\n                            </div>\n\n                        </div>\n                        <div class=\"row\">\n\n                            <div class=\"col-12 col-md-6\">\n                                <div class=\"form-group\">\n                                    <label for=\"nuevoUsuarioEmail\" class=\"\">E-Mail</label>\n                                    <input type=\"email\" id=\"nuevoUsuarioEmail\" class=\"form-control\" ng-model=\"$ctrl.usuario.email\" required>\n                                </div>\n                            </div>\n                            <div class=\"col-12 col-md-6\">\n                                <div class=\"form-group\">\n                                    <label for=\"nuevoUsuarioPassword\">Clave</label>\n                                    <div class=\"input-group input-group\">\n                                        <input type=\"text\" id=\"nuevoUsuarioPassword\" class=\"form-control\" ng-model=\"$ctrl.usuario.password\" ng-disabled=\"!$ctrl.isNuevoPassword\" ng-required=\"$ctrl.isNuevoPassword\">\n                                        <div class=\"input-group-append\">\n                                            <div class=\"input-group-text\">\n                                            <label for=\"chkPassword\" class=\"mb-0\"><input type=\"checkbox\" id=\"chkPassword\" ng-model=\"$ctrl.isNuevoPassword\"> Cambiar Clave</label>\n                                        </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n\n                        <div class=\"row\">\n                            <div class=\"col-12 col-md-6\">\n                                <div class=\"form-group\">\n                                    <label for=\"nuevoUsuarioCiudad\">Ciudad</label>\n                                    <input type=\"text\" id=\"nuevoUsuarioCiudad\" class=\"form-control\" ng-model=\"$ctrl.usuario.datos.ciudad\">\n                                </div>\n                            </div>\n                            <div class=\"col-12 col-md-6\">\n                                <div class=\"form-group\">\n                                    <label for=\"nuevoUsuarioDireccion\">Direccion</label>\n                                    <input type=\"text\" id=\"nuevoUsuarioDireccion\" class=\"form-control\" ng-model=\"$ctrl.usuario.datos.direccion\">\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"row\">\n                            <div class=\"col-12 col-md-6\">\n                                <div class=\"form-group\">\n                                    <label for=\"nuevoUsuarioProvincia\">Provincia</label>\n                                    <input type=\"text\" id=\"nuevoUsuarioProvincia\" class=\"form-control\" ng-model=\"$ctrl.usuario.datos.provincia\">\n                                </div>\n                            </div>\n                            <div class=\"col-6 col-md-3\">\n                                <div class=\"form-group\">\n                                    <label for=\"nuevoUsuarioCP\">CP</label>\n                                    <input type=\"text\" id=\"nuevoUsuarioCP\" class=\"form-control\" ng-model=\"$ctrl.usuario.datos.cp\">\n                                </div>\n                            </div>\n                            <div class=\"col-6 col-md-3\">\n                                <div class=\"form-group\">\n                                    <label for=\"nuevoUsuarioTelefono\">Telefono</label>\n                                    <input type=\"text\" id=\"nuevoUsuarioTelefono\" class=\"form-control\" ng-model=\"$ctrl.usuario.datos.telefono\">\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"row\">\n                            <div class=\"col-12 col-md-6\">\n                                <div class=\"form-group\">\n                                    <label>Usuario activo &nbsp;&nbsp;&nbsp;</label>\n                                    <div class=\"btn-group\">\n                                        <button type=\"button\" class=\"btn btn-sm\" ng-class=\"{'btn-outline-info': !$ctrl.usuario.active, 'btn-info': $ctrl.usuario.active}\" ng-click=\"$ctrl.toggleActivo(true)\">SI</button>\n                                        <button type=\"button\" class=\"btn btn-sm\" ng-class=\"{'btn-outline-info': $ctrl.usuario.active, 'btn-info': !$ctrl.usuario.active}\" ng-click=\"$ctrl.toggleActivo(false)\">No</button>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"col-12 col-md-6\">\n<!--                                <div class=\"form-group\">-->\n                                    <button type=\"submit\" class=\"btn btn-outline-info pull-right btn-lg\">Guardar Cambios\n                                        <span class=\"fa fa-save\"></span>\n                                    </button>\n<!--                                </div>-->\n                            </div>\n                        </div>\n                        <br>\n                    </form>\n                </div>\n            </div>\n            </div>\n        </div>\n    </div>\n</div>\n<br><br>\n"

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
	
	    /*@ngInject*/
	    _class.$inject = ['$http', 'USUARIOS_URL'];
	    function _class($http, USUARIOS_URL) {
	        _classCallCheck(this, _class);
	
	        Object.assign(this, { $http: $http, USUARIOS_URL: USUARIOS_URL });
	    }
	
	    _createClass(_class, [{
	        key: 'editarUsuario',
	        value: function editarUsuario(usuario) {
	            return this.$http.patch(this.USUARIOS_URL + '/update/' + usuario._id, usuario);
	        }
	    }, {
	        key: 'getUsuarioPorId',
	        value: function getUsuarioPorId(id) {
	            return this.$http.get(this.USUARIOS_URL + '/' + id);
	        }
	    }, {
	        key: 'crearUsuario',
	        value: function crearUsuario(usuario) {
	            return this.$http.post(this.USUARIOS_URL, usuario);
	        }
	    }]);
	
	    return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _articuloRouteComponent = __webpack_require__(31);
	
	var _crearArticulo = __webpack_require__(33);
	
	var _actualizarArticulo = __webpack_require__(35);
	
	var _editarArticulo = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ngRoute = __webpack_require__(20);
	
	/*@ngInject*/
	var routeArticulo = function routeArticulo($routeProvider) {
	    getArticuloPorCodigo.$inject = ['$route', 'ArticuloService'];
	    getArticuloCategorias.$inject = ['ArticuloService'];
	    $routeProvider.when('/articulo/ver/:codigo', {
	        template: '<articulo-route articulo="$resolve.articulo.data"></articulo-route>',
	        resolve: {
	            articulo: getArticuloPorCodigo
	        },
	        authenticate: true
	    }).when('/articulo/crear', {
	        template: '<crear-articulo-route categorias="$resolve.categorias.data.categorias"></crear-articulo-route>',
	        resolve: {
	            categorias: getArticuloCategorias
	        },
	        authenticate: true,
	        administrator: true
	    }).when('/articulo/editar/:codigo', {
	        template: '<editar-articulo-route articulo="$resolve.articulo.data" categorias="$resolve.categorias.data.categorias"></editar-articulo-route>',
	        resolve: {
	            articulo: getArticuloPorCodigo,
	            categorias: getArticuloCategorias
	        },
	        authenticate: true,
	        administrator: true
	    }).when('/articulo/actualizar', {
	        template: '<actualizar-articulos-route></actualizar-articulos-route>',
	        authenticate: true,
	        administrator: true
	    });
	
	    function getArticuloPorCodigo($route, ArticuloService) {
	        return ArticuloService.getArticuloPorCodigo($route.current.params.codigo);
	    }
	
	    function getArticuloCategorias(ArticuloService) {
	        return ArticuloService.getArticuloCategorias();
	    }
	};
	routeArticulo.$inject = ['$routeProvider'];
	
	exports.default = _angular2.default.module('pizzutoAutopartesApp.articulo', [ngRoute]).component(_articuloRouteComponent.ArticuloRouteComponent.selector, _articuloRouteComponent.ArticuloRouteComponent).component(_crearArticulo.CrearArticuloRouteComponent.selector, _crearArticulo.CrearArticuloRouteComponent).component(_editarArticulo.EditarArticuloRouteComponent.selector, _editarArticulo.EditarArticuloRouteComponent).component(_actualizarArticulo.ActualizarArticuloRouteComponent.selector, _actualizarArticulo.ActualizarArticuloRouteComponent).config(routeArticulo).name;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArticuloRouteComponent = exports.ArticuloRouteComponent = {
	    selector: 'articuloRoute',
	    template: __webpack_require__(32),
	    bindings: {
	        articulo: '='
	    },
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['CarritoService', '$location', '$window', 'Auth'];
	        function controller(CarritoService, $location, $window, Auth) {
	            _classCallCheck(this, controller);
	
	            Object.assign(this, { CarritoService: CarritoService, $location: $location, $window: $window });
	            this.isAdmin = Auth.isAdminSync;
	        }
	
	        _createClass(controller, [{
	            key: '$onInit',
	            value: function $onInit() {
	                this.articulo.cantidad = 1;
	                this.$window.scrollTo(0, 0);
	            }
	        }, {
	            key: 'agregarArticuloAlCarrito',
	            value: function agregarArticuloAlCarrito() {
	                this.CarritoService.agregarArticulo(this.articulo);
	                this.$location.path('/carrito');
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	module.exports = "<br>\n<div class=\"container\" id=\"articulo-route\">\n    <div class=\"row\">\n        <div class=\"col-12 pl-0 pr-0\">\n            <ol class=\"breadcrumb\">\n                <li class=\"breadcrumb-item\"><a ng-href=\"/\">INICIO</a></li>\n                <li class=\"breadcrumb-item\"><a ng-href=\"/articulo/categoria/{{$ctrl.articulo.categoria}}\">{{$ctrl.articulo.categoria}}</a></li>\n                <li class=\"breadcrumb-item\"><a ng-href=\"/articulo/categoria/{{$ctrl.articulo.categoria}}/{{$ctrl.articulo.subcategoria}}\">{{$ctrl.articulo.subcategoria}}</a></li>\n                <li class=\"breadcrumb-item active\">{{$ctrl.articulo.descripcion}}</li>\n            </ol>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-12 col-lg-6 pl-lg-0\">\n            <div class=\"card card-articulo imagebox-shadow\">\n                <figure class=\"text-center mb-0\">\n                    <img class=\"img-articulo\" ng-src=\"{{$ctrl.articulo.imagenUrl}}\" alt=\"{{$ctrl.articulo.descripcion}}\">\n                </figure>\n            </div>\n        </div>\n        <div class=\"col-12 col-lg-6 pr-lg-0\">\n            <div class=\"row\">\n                <div class=\"col-12\">\n                    <div class=\"alert alert-info pr-0\">\n                        <h3 class=\"mb-0\">Codigo del articulo:\n                            <span class=\"c-rojo\">{{$ctrl.articulo.codigo}}</span>\n                        </h3>\n                        <link-editar link=\"/articulo/editar/{{$ctrl.articulo._id}}\"></link-editar>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-12\">\n                    <p class=\"articulo-descripcion\">{{$ctrl.articulo.descripcion}}</p>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-12\">\n                    <p>Unidad:\n                        <span class=\"c-rojo\">{{$ctrl.articulo.unidad}}</span>\n                    </p>\n                </div>\n                <div class=\"col-12\" ng-if=\"$ctrl.articulo.precioVisible\">\n                    <p>Precio:\n                        <span class=\"c-celeste articulo-destacado-texto\">{{$ctrl.articulo.precio | currency}}</span>\n                    </p>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-6\">\n                    <label class=\"\" style=\"display: inline\" for=\"articulo-cantidad\">Cantidad</label><input type=\"number\" id=\"articulo-cantidad\" min=\"1\" class=\"form-control\" ng-model=\"$ctrl.articulo.cantidad\">\n                </div>\n                <div class=\"col-3\">\n\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-sm-12 col-md-6 col-lg-6 col-xl-6 pt-3\" ng-if=\"$ctrl.articulo.precioVisible\">\n                    <p>Monto total:\n                        <span class=\"c-celeste\">{{$ctrl.articulo.precio * $ctrl.articulo.cantidad | currency}}</span>\n                    </p>\n                </div>\n                <div class=\"col-sm-12 col-md-6 col-lg-6 col-xl-6 pt-3\" ng-if=\"!$ctrl.articulo.precioVisible\">\n                </div>\n                <div class=\"col-sm-12 col-md-6 col-lg-6 col-xl-6\">\n                    <button type=\"button\" class=\"btn btn-outline-info btn-lg pull-right\" ng-click=\"$ctrl.agregarArticuloAlCarrito()\" ng-disabled=\"!$ctrl.articulo.activo\" ng-if=\"!$ctrl.isAdmin()\">\n                        <span ng-if=\"$ctrl.articulo.activo\">Agregar al carrito</span><span ng-if=\"!$ctrl.articulo.activo\">Sin stock</span>\n                        <span class=\"fa fa-shopping-cart\"></span>\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row\" ng-show=\"::(($ctrl.articulo.equivalencia && $ctrl.articulo.equivalencia.activo) || ($ctrl.articulo.equivalencia2 && $ctrl.articulo.equivalencia2.activo))\">\n        <div class=\"col-12 p-0\">\n            <hr>\n            <h3>EQUIVALENCIA</h3>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-12 col-lg-6 mb-3\" ng-show=\"::$ctrl.articulo.equivalencia && $ctrl.articulo.equivalencia.activo\">\n            <div class=\"card imagebox-shadow\">\n                <div class=\"card-block p-0\">\n                    <div class=\"row\">\n                        <div class=\"col-6\">\n                            <figure class=\"text-center mb-0\">\n                                <img class=\"img-fluid\" ng-src=\"{{$ctrl.articulo.equivalencia.imagenUrl}}\" alt=\"{{$ctrl.articulo.equivalencia.descripcion}}\">\n                            </figure>\n                        </div>\n                        <div class=\"col-6 borde-articulo-equivalente\">\n\n                            <div class=\"row\">\n                                <div class=\"col-12\">\n                                    <h4 class=\"mt-2 mb-3\">Codigo del articulo <br>\n                                        <a ng-href=\"/articulo/ver/{{$ctrl.articulo.equivalencia._id}}\"><span class=\"c-rojo\">{{$ctrl.articulo.equivalencia.codigo}}</span></a>\n                                    </h4>\n                                </div>\n                            </div>\n\n                            <div class=\"row\">\n                                <div class=\"col-12\">\n                                    <p>\n                                        <a ng-href=\"/articulo/ver/{{$ctrl.articulo.equivalencia._id}}\">{{$ctrl.articulo.equivalencia.descripcion}}</a>\n                                    </p>\n                                </div>\n                            </div>\n\n                            <div class=\"row\">\n                                <div class=\"col-12\">\n                                    <p>Unidad:\n                                        <span class=\"c-rojo\">{{$ctrl.articulo.equivalencia.unidad}}</span>\n                                    </p>\n                                </div>\n                            </div>\n\n                            <div class=\"row\" ng-if=\"$ctrl.articulo.equivalencia.precioVisible\">\n                                <div class=\"col-12\">\n                                    <p>\n                                        Precio:\n                                        <span class=\"c-celeste precio-equivalencia\">{{$ctrl.articulo.equivalencia.precio | currency}}</span>\n                                    </p>\n                                </div>\n                            </div>\n\n                        </div>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n\n        <div class=\"col-12 col-lg-6\" ng-show=\"::$ctrl.articulo.equivalencia2 && $ctrl.articulo.equivalencia2.activo\">\n            <div class=\"card imagebox-shadow\">\n                <div class=\"card-block p-0\">\n                    <div class=\"row\">\n                        <div class=\"col-6\">\n                            <figure class=\"text-center mb-0\">\n                                <img class=\"img-fluid\" ng-src=\"{{$ctrl.articulo.equivalencia2.imagenUrl}}\" alt=\"{{$ctrl.articulo.equivalencia2.descripcion}}\">\n                            </figure>\n                        </div>\n                        <div class=\"col-6 borde-articulo-equivalente\">\n\n                            <div class=\"row\">\n                                <div class=\"col-12\">\n                                    <h4 class=\"mt-2 mb-3\">Codigo del articulo <br>\n                                        <a ng-href=\"/articulo/ver/{{$ctrl.articulo.equivalencia2._id}}\"><span class=\"c-rojo\">{{$ctrl.articulo.equivalencia2.codigo}}</span></a>\n                                    </h4>\n                                </div>\n                            </div>\n\n                            <div class=\"row\">\n                                <div class=\"col-12\">\n                                    <p>\n                                        <a ng-href=\"/articulo/ver/{{$ctrl.articulo.equivalencia2._id}}\">{{$ctrl.articulo.equivalencia2.descripcion}}</a>\n                                    </p>\n                                </div>\n                            </div>\n\n                            <div class=\"row\">\n                                <div class=\"col-12\">\n                                    <p>Unidad:\n                                        <span class=\"c-rojo\">{{$ctrl.articulo.equivalencia2.unidad}}</span>\n                                    </p>\n                                </div>\n                            </div>\n\n                            <div class=\"row\" ng-if=\"$ctrl.articulo.equivalencia2.precioVisible\">\n                                <div class=\"col-12\">\n                                    <p>\n                                        Precio:\n                                        <span class=\"c-celeste precio-equivalencia\">{{$ctrl.articulo.equivalencia2.precio | currency}}</span>\n                                    </p>\n                                </div>\n                            </div>\n\n                        </div>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<br>\n<br>\n"

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CrearArticuloRouteComponent = exports.CrearArticuloRouteComponent = {
	    selector: 'crearArticuloRoute',
	    template: __webpack_require__(34),
	    bindings: {
	        categorias: '<'
	    },
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['ArticuloService', '$location', 'Upload', 'IMAGE_UPLOAD_URL', 'ToasterService'];
	        function controller(ArticuloService, $location, Upload, IMAGE_UPLOAD_URL, ToasterService) {
	            _classCallCheck(this, controller);
	
	            Object.assign(this, { ArticuloService: ArticuloService, $location: $location, Upload: Upload, IMAGE_UPLOAD_URL: IMAGE_UPLOAD_URL, ToasterService: ToasterService });
	            this.articulo = { unidad: 'C/U' };
	        }
	
	        _createClass(controller, [{
	            key: 'crearArticulo',
	            value: function crearArticulo(form) {
	                var _this = this;
	
	                if (form.$valid) {
	                    if (this.categoriaSeleccionada && this.subcategoriaSeleccionada) {
	
	                        this.articulo.categoria = this.categoriaSeleccionada.categoria.toUpperCase();
	                        this.articulo.subcategoria = this.subcategoriaSeleccionada.subcategoria.toUpperCase();
	
	                        if (this.file) {
	                            this.Upload.upload({
	                                url: this.IMAGE_UPLOAD_URL,
	                                data: {
	                                    file: this.file
	                                }
	                            }).then(function (img) {
	                                _this.articulo.imagenUrl = img.data.secure_url;
	                                _this.ArticuloService.crearArticulo(_this.articulo).then(function (art) {
	                                    _this.ToasterService.popUp('success', 'Articulo', 'Se ha creado con éxito.');
	                                    _this.$location.path('/articulo/ver/' + art.data._id);
	                                }, function (error) {
	                                    _this.ToasterService.popUp('danger', 'Error en articulo', error.data);
	                                });
	                            });
	                        } else {
	                            this.ArticuloService.crearArticulo(this.articulo).then(function (art) {
	                                _this.ToasterService.popUp('success', 'Articulo', 'Se ha creado con éxito.');
	                                _this.$location.path('/articulo/ver/' + art.data._id);
	                            }, function (error) {
	                                _this.ToasterService.popUp('danger', 'Error en articulo', error.data);
	                            });
	                        }
	                    } else {
	                        this.ToasterService.popUp('info', 'Categoria', 'Seleccione una categoria y subcategoria.');
	                    }
	                }
	            }
	        }, {
	            key: 'uploadFiles',
	            value: function uploadFiles(file, error) {
	                this.file = file;
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <br>\n    <div class=\"row\">\n        <div class=\"col-12\">\n            <div class=\"card c-celeste\">\n                <div class=\"card-header\">\n                    <h1 class=\"text-center\">Crear Articulo</h1>\n                </div>\n                <div class=\"card-block\">\n                    <div class=\"col-12\" style=\"padding: 20px;\">\n\n                    <form ng-submit=\"$ctrl.crearArticulo(formCrearArticulo)\" class=\"\" name=\"formCrearArticulo\" autocomplete=\"off\">\n                        <div class=\"row\">\n                            <div class=\"col-12 col-md-6\">\n                                <div class=\"form-group\">\n                                    <label for=\"codigoArticulo\">Codigo</label>\n                                    <input type=\"text\" class=\"form-control\" id=\"codigoArticulo\" ng-model=\"$ctrl.articulo.codigo\" required capitalize>\n                                </div>\n                            </div>\n                            <div class=\"col-6 col-md-3\">\n                                <div class=\"form-group\">\n                                    <label for=\"codigoEquicalenteArticulo\">Equivalente</label>\n                                    <input type=\"text\" class=\"form-control\" id=\"codigoEquicalenteArticulo\" ng-model=\"$ctrl.articulo.equivalencia\" placeholder=\"codigo\" capitalize>\n                                </div>\n                            </div>\n                            <div class=\"col-6 col-md-3\">\n                                <div class=\"form-group\">\n                                    <label for=\"codigoEquicalenteArticulo2\">Equivalente 2</label>\n                                    <input type=\"text\" class=\"form-control\" id=\"codigoEquicalenteArticulo2\" ng-model=\"$ctrl.articulo.equivalencia2\" placeholder=\"codigo\" capitalize>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"row\">\n                            <div class=\"col-12 col-md-6\">\n                                <div class=\"form-group\">\n                                    <label for=\"descArticulo\">Descripcion</label>\n                                    <input type=\"text\" class=\"form-control\" id=\"descArticulo\" ng-model=\"$ctrl.articulo.descripcion\" required capitalize>\n                                </div>\n                            </div>\n                            <div class=\"col-6 col-md-3\">\n                                <div class=\"form-group\">\n                                    <label for=\"precioArticulo\">Precio</label>\n                                    <input type=\"number\" class=\"form-control\" id=\"precioArticulo\" step=\"0.01\" ng-model=\"$ctrl.articulo.precio\" required>\n                                </div>\n                            </div>\n                            <div class=\"col-6 col-md-3\">\n                                <div class=\"form-group\">\n                                    <label for=\"unidadArticulo\">Unidad</label>\n                                    <input type=\"text\" class=\"form-control\" id=\"unidadArticulo\" ng-model=\"$ctrl.articulo.unidad\" required capitalize>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"row\">\n                            <div class=\"col-12 col-md-6\">\n                                <div class=\"form-group\">\n                                    <label>Categoria</label>\n                                    <select name=\"singleSelect\" class=\"form-control\" ng-model=\"$ctrl.categoriaSeleccionada\" ng-options=\"item.categoria for item in $ctrl.categorias | orderBy: 'categoria'\">\n                                        <option value=\"\">--Seleccionar Categoria--</option>\n                                    </select><br>\n                                </div>\n                            </div>\n                            <div class=\"col-12 col-md-6\">\n                                <div class=\"form-group\">\n                                    <label>Subcategoria</label>\n                                    <select name=\"singleSelect\" class=\"form-control\" ng-disabled=\"!$ctrl.categoriaSeleccionada\" ng-model=\"$ctrl.subcategoriaSeleccionada\" ng-options=\"item.subcategoria for item in $ctrl.categoriaSeleccionada.subcategorias | orderBy: 'subcategoria'\">\n                                        <option value=\"\">--Seleccionar Subcategoria--</option>\n                                    </select><br>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"row\">\n                            <div class=\"col-12 col-md-6\">\n                                <input type=\"file\" ngf-select=\"$ctrl.uploadFiles($file, $invalidFiles)\"\n                                       accept=\"image/*\" ngf-max-height=\"1000\" ngf-max-size=\"1MB\">\n                            </div>\n                            <div class=\"col-12 col-md-6\">\n                                <button type=\"submit\" class=\"btn btn-outline-info pull-right btn-lg\">Crear Articulo <span class=\"fa fa-plus\"></span></button>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<br>\n"

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ActualizarArticuloRouteComponent = exports.ActualizarArticuloRouteComponent = {
	    selector: 'actualizarArticulosRoute',
	    template: __webpack_require__(36),
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['ArticuloService', '$location', 'ToasterService'];
	        function controller(ArticuloService, $location, ToasterService) {
	            _classCallCheck(this, controller);
	
	            Object.assign(this, { ArticuloService: ArticuloService, $location: $location, ToasterService: ToasterService });
	            this.listaArticulos = '';
	            this.actualizandoArticulos = false;
	        }
	
	        _createClass(controller, [{
	            key: 'actualizarActiculos',
	            value: function actualizarActiculos() {
	                var _this = this;
	
	                if (this.listaArticulos) {
	                    this.actualizandoArticulos = true;
	                    this.ArticuloService.actualizarArticulos({ data: this.listaArticulos }).then(function () {
	                        _this.actualizandoArticulos = false;
	                        _this.ToasterService.popUp('success', 'Articulos', 'Se han actualizado con éxito.');
	                        _this.$location.path('/');
	                    });
	                } else {
	                    this.ToasterService.popUp('info', 'Informacion', 'Agregue un nuevo listado.');
	                }
	            }
	        }, {
	            key: 'ocultarPrecios',
	            value: function ocultarPrecios() {
	                var _this2 = this;
	
	                this.actualizandoArticulos = true;
	                this.ArticuloService.ocultarPrecios().then(function () {
	                    _this2.actualizandoArticulos = false;
	                    _this2.ToasterService.popUp('success', 'Articulos', 'Se han actualizado con éxito.');
	                    _this2.$location.path('/');
	                });
	            }
	        }, {
	            key: 'mostrarPrecios',
	            value: function mostrarPrecios() {
	                var _this3 = this;
	
	                this.actualizandoArticulos = true;
	                this.ArticuloService.mostrarPrecios().then(function () {
	                    _this3.actualizandoArticulos = false;
	                    _this3.ToasterService.popUp('success', 'Articulos', 'Se han actualizado con éxito.');
	                    _this3.$location.path('/');
	                });
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	module.exports = "<br>\n<div class=\"container\">\n    <div class=\"row\">\n        <div class=\"col-8\">\n            <h1 class=\"c-celeste\">Actualizar listado de Articulos</h1>\n        </div>\n        <div class=\"col-4 text-right\" style=\"line-height: 50px;\">\n            <button class=\"btn btn-outline-info btn-sm\" ng-disabled=\"$ctrl.actualizandoArticulos\" ng-click=\"$ctrl.mostrarPrecios()\">Mostrar precios</button>\n            <button class=\"btn btn-outline-info btn-sm\" ng-disabled=\"$ctrl.actualizandoArticulos\" ng-click=\"$ctrl.ocultarPrecios()\">Ocultar precios</button>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-12\">\n            <textarea cols=\"30\" name=\"\" rows=\"25\" class=\"form-control\" id=\"textarea-actualizar-articulo\" ng-model=\"$ctrl.listaArticulos\" placeholder=\"Codigo ; Descripcion ; Categoria/Subrubro ; Precio ; Unidad ; Equivalencia ; Activo\"></textarea>\n            <button class=\"btn btn-outline-info btn-lg\" id=\"btn-actualizar\" ng-click=\"$ctrl.actualizarActiculos()\" ng-disabled=\"$ctrl.actualizandoArticulos\">Actualizar Articulos\n                <span class=\"fa fa-upload\" ng-show=\"!$ctrl.actualizandoArticulos\"></span>\n                <span class=\"fa fa-spin fa-circle-o-notch\" ng-show=\"$ctrl.actualizandoArticulos\"></span>\n            </button>\n        </div>\n    </div>\n</div>\n<br>\n"

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditarArticuloRouteComponent = exports.EditarArticuloRouteComponent = {
	    selector: 'editarArticuloRoute',
	    template: __webpack_require__(38),
	    bindings: {
	        categorias: '<',
	        articulo: '<'
	    },
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['ArticuloService', '$location', 'Upload', 'IMAGE_UPLOAD_URL', 'ToasterService'];
	        function controller(ArticuloService, $location, Upload, IMAGE_UPLOAD_URL, ToasterService) {
	            _classCallCheck(this, controller);
	
	            Object.assign(this, { ArticuloService: ArticuloService, $location: $location, Upload: Upload, IMAGE_UPLOAD_URL: IMAGE_UPLOAD_URL, ToasterService: ToasterService });
	        }
	
	        _createClass(controller, [{
	            key: '$onInit',
	            value: function $onInit() {
	                var _this = this;
	
	                this.categoriaSeleccionada = this.categorias.find(function (item) {
	                    return item.categoria.toUpperCase() === _this.articulo.categoria;
	                });
	                this.subcategoriaSeleccionada = this.categoriaSeleccionada.subcategorias.find(function (item) {
	                    return item.subcategoria.toUpperCase() === _this.articulo.subcategoria;
	                });
	
	                if (this.articulo.equivalencia && this.articulo.equivalencia.codigo) {
	                    this.articulo.equivalencia = this.articulo.equivalencia.codigo;
	                }
	                if (this.articulo.equivalencia2 && this.articulo.equivalencia2.codigo) {
	                    this.articulo.equivalencia2 = this.articulo.equivalencia2.codigo;
	                }
	            }
	        }, {
	            key: 'editarArticulo',
	            value: function editarArticulo(form) {
	                var _this2 = this;
	
	                if (form.$valid) {
	
	                    this.articulo.categoria = this.categoriaSeleccionada.categoria.toUpperCase();
	                    this.articulo.subcategoria = this.subcategoriaSeleccionada.subcategoria.toUpperCase();
	
	                    if (this.file) {
	                        this.Upload.upload({
	                            url: this.IMAGE_UPLOAD_URL,
	                            data: {
	                                file: this.file
	                            }
	                        }).then(function (img) {
	                            _this2.articulo.imagenUrl = img.data.secure_url;
	                            _this2.ArticuloService.editarArticulo(_this2.articulo).then(function (art) {
	                                _this2.ToasterService.popUp('success', 'Articulo', 'Se ha actualizado con éxito.');
	                                _this2.$location.path('/articulo/ver/' + art.data._id);
	                            }, function (error) {
	                                _this2.ToasterService.popUp('danger', 'Error en articulo', error.data);
	                            });
	                        });
	                    } else {
	                        this.ArticuloService.editarArticulo(this.articulo).then(function (art) {
	                            _this2.ToasterService.popUp('success', 'Articulo', 'Se ha actualizado con éxito.');
	                            _this2.$location.path('/articulo/ver/' + art.data._id);
	                        }, function (error) {
	                            _this2.ToasterService.popUp('danger', 'Error en articulo', error.data);
	                        });
	                    }
	                } else {
	                    this.ToasterService.popUp('info', 'Formulario', 'Esta incompleto o no es válido.');
	                }
	            }
	        }, {
	            key: 'toggleActivo',
	            value: function toggleActivo(value) {
	                this.articulo.activo = value;
	            }
	        }, {
	            key: 'uploadFiles',
	            value: function uploadFiles(file, error) {
	                this.file = file;
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <br>\n    <div class=\"row\">\n        <div class=\"col-12\">\n            <div class=\"card c-celeste\">\n                <div class=\"card-header\">\n                    <h1 class=\"text-center mb-0\">Editar Articulo</h1>\n                </div>\n                <div class=\"card-block\">\n                    <div class=\"col-12\" style=\"padding: 20px;\">\n                        <form ng-submit=\"$ctrl.crearArticulo(formCrearArticulo)\" class=\"\" name=\"formEditarArticulo\"\n                              autocomplete=\"off\">\n                            <div class=\"row\">\n                                <div class=\"col-12 col-md-6\">\n                                    <div class=\"form-group\">\n                                        <label for=\"codigoArticulo\">Codigo</label>\n                                        <input type=\"text\" class=\"form-control\" id=\"codigoArticulo\"\n                                               ng-model=\"$ctrl.articulo.codigo\" required capitalize>\n                                    </div>\n                                </div>\n                                <div class=\"col-6 col-md-3\">\n                                    <div class=\"form-group\">\n                                        <label for=\"codigoEquicalenteArticulo\">Equivalente</label>\n                                        <input type=\"text\" class=\"form-control\" id=\"codigoEquicalenteArticulo\"\n                                               ng-model=\"$ctrl.articulo.equivalencia\" placeholder=\"codigo\" capitalize>\n                                    </div>\n                                </div>\n                                <div class=\"col-6 col-md-3\">\n                                    <div class=\"form-group\">\n                                        <label for=\"codigoEquicalenteArticulo2\">Equivalente 2</label>\n                                        <input type=\"text\" class=\"form-control\" id=\"codigoEquicalenteArticulo2\"\n                                               ng-model=\"$ctrl.articulo.equivalencia2\" placeholder=\"codigo\" capitalize>\n                                    </div>\n                                </div>\n\n                            </div>\n\n                            <div class=\"row\">\n                                <div class=\"col-12 col-md-6\">\n                                    <div class=\"form-group\">\n                                        <label for=\"descArticulo\">Descripcion</label>\n                                        <input type=\"text\" class=\"form-control\" id=\"descArticulo\"\n                                               ng-model=\"$ctrl.articulo.descripcion\" required capitalize>\n                                    </div>\n                                </div>\n                                <div class=\"col-6 col-md-3\">\n                                    <div class=\"form-group\">\n                                        <label for=\"precioArticulo\">Precio</label>\n                                        <input type=\"number\" class=\"form-control\" step=\"0.01\" id=\"precioArticulo\"\n                                               ng-model=\"$ctrl.articulo.precio\" required>\n                                    </div>\n                                </div>\n                                <div class=\"col-6 col-md-3\">\n                                    <div class=\"form-group\">\n                                        <label for=\"unidadArticulo\">Unidad</label>\n                                        <input type=\"text\" class=\"form-control\" id=\"unidadArticulo\"\n                                               ng-model=\"$ctrl.articulo.unidad\" required capitalize>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-12 col-md-6\">\n                                    <div class=\"form-group\">\n                                        <label>Categoria</label>\n                                        <select name=\"singleSelect\" class=\"form-control\"\n                                                ng-model=\"$ctrl.categoriaSeleccionada\"\n                                                ng-options=\"item.categoria for item in $ctrl.categorias\" required>\n                                            <option value=\"\">--Seleccionar Categoria--</option>\n                                        </select><br>\n                                    </div>\n                                </div>\n                                <div class=\"col-12 col-md-6\">\n                                    <div class=\"form-group\">\n                                        <label>Subcategoria</label>\n                                        <select name=\"singleSelect\" class=\"form-control\"\n                                                ng-disabled=\"!$ctrl.categoriaSeleccionada\"\n                                                ng-model=\"$ctrl.subcategoriaSeleccionada\"\n                                                ng-options=\"item.subcategoria for item in $ctrl.categoriaSeleccionada.subcategorias | orderBy: 'subcategoria'\"\n                                                required>\n                                            <option value=\"\">--Seleccionar Subcategoria--</option>\n                                        </select><br>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-12 col-md-6\">\n                                    <input type=\"file\" ngf-select=\"$ctrl.uploadFiles($file, $invalidFiles)\"\n                                           accept=\"image/*\" ngf-max-height=\"1000\" ngf-max-size=\"1MB\">\n                                </div>\n                                <div class=\"col-12 col-md-6\">\n                                    <!--<label>Activo: </label>&nbsp;&nbsp;&nbsp;&nbsp;-->\n                                    <div class=\"btn-group\">\n                                        <button type=\"button\" class=\"btn\"\n                                                ng-class=\"{'btn-outline-info': !$ctrl.articulo.activo, 'btn-info': $ctrl.articulo.activo}\"\n                                                ng-click=\"$ctrl.toggleActivo(true)\">ACTIVO\n                                        </button>\n                                        <button type=\"button\" class=\"btn\"\n                                                ng-class=\"{'btn-outline-info': $ctrl.articulo.activo, 'btn-info': !$ctrl.articulo.activo}\"\n                                                ng-click=\"$ctrl.toggleActivo(false)\">NO ACTIVO\n                                        </button>\n                                    </div>\n                                    <button type=\"submit\" class=\"btn btn-outline-info pull-right btn-lg\"\n                                            ng-click=\"$ctrl.editarArticulo(formEditarArticulo)\">Guardar Articulo <span\n                                            class=\"fa fa-save\"></span></button>\n                                </div>\n                            </div>\n                        </form>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<br>\n"

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _buscarArticuloRouteComponent = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ngRoute = __webpack_require__(20);
	
	/*@ngInject*/
	var routeArticulos = function routeArticulos($routeProvider) {
	    getArticulosPorCategoria.$inject = ['ArticuloService', '$route'];
	    getSubcategoriasPorCategoria.$inject = ['ArticuloService', '$route'];
	    getArticulosPorSubcategoria.$inject = ['ArticuloService', '$route'];
	    getArticulosPorCodigo.$inject = ['ArticuloService', '$route'];
	    getArticulosPalabraClave.$inject = ['ArticuloService', '$route', '$window'];
	    $routeProvider.when('/articulo/categoria/:categoria', {
	        template: '<buscar-articulo-route articulos="$resolve.articulos.data" subcategorias="$resolve.subcategorias.data"></buscar-articulo-route>',
	        resolve: {
	            articulos: getArticulosPorCategoria,
	            subcategorias: getSubcategoriasPorCategoria
	        },
	        authenticate: true
	    }).when('/articulo/categoria/:categoria/:subcategoria', {
	        template: '<buscar-articulo-route articulos="$resolve.articulos.data" subcategorias="$resolve.subcategorias.data"></buscar-articulo-route>',
	        resolve: {
	            articulos: getArticulosPorSubcategoria,
	            subcategorias: getSubcategoriasPorCategoria
	        },
	        authenticate: true
	    }).when('/articulo/codigo/:codigo', {
	        template: '<buscar-articulo-route articulos="$resolve.articulos.data"></buscar-articulo-route>',
	        resolve: {
	            articulos: getArticulosPorCodigo
	        },
	        authenticate: true
	    }).when('/articulo/palabra-clave/:palabra', {
	        template: '<buscar-articulo-route articulos="$resolve.articulos.data"></buscar-articulo-route>',
	        resolve: {
	            articulos: getArticulosPalabraClave
	        },
	        authenticate: true
	    });
	
	    function getArticulosPorCategoria(ArticuloService, $route) {
	        return ArticuloService.getArticulosPorCategoria($route.current.params.categoria);
	    }
	
	    function getArticulosPorSubcategoria(ArticuloService, $route) {
	        return ArticuloService.getArticulosPorSubcategoria($route.current.params.categoria, $route.current.params.subcategoria);
	    }
	
	    function getSubcategoriasPorCategoria(ArticuloService, $route) {
	        return ArticuloService.getSubcategoriasPorCategoria($route.current.params.categoria);
	    }
	
	    function getArticulosPorCodigo(ArticuloService, $route) {
	        return ArticuloService.getArticulosPorCodigo($route.current.params.codigo);
	    }
	
	    function getArticulosPalabraClave(ArticuloService, $route, $window) {
	
	        var palabra = $route.current.params.palabra = $route.current.params.palabra.replace(/%2F/g, '/');
	
	        return ArticuloService.getArticulosPorPalabraClave($window.encodeURIComponent(palabra));
	    }
	};
	routeArticulos.$inject = ['$routeProvider'];
	
	exports.default = _angular2.default.module('pizzutoAutopartesApp.buscar-articulo', [ngRoute]).component(_buscarArticuloRouteComponent.BuscarArticuloRouteComponent.selector, _buscarArticuloRouteComponent.BuscarArticuloRouteComponent).config(routeArticulos).name;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BuscarArticuloRouteComponent = exports.BuscarArticuloRouteComponent = {
	    selector: 'buscarArticuloRoute', template: __webpack_require__(41), bindings: {
	        articulos: '<', subcategorias: '<'
	    }, controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['$route', '$scope', '$window', '$location'];
	        function controller($route, $scope, $window, $location) {
	            var _this = this;
	
	            _classCallCheck(this, controller);
	
	            this.subcategoriaSeleccionada = null;
	
	            Object.assign(this, { $route: $route, $scope: $scope, $window: $window, $location: $location });
	
	            $scope.$on('setPageTo', function (ev, page) {
	                _this.currentPage = page;
	                _this.pageReload();
	            });
	        }
	
	        _createClass(controller, [{
	            key: '$onInit',
	            value: function $onInit() {
	                var _this2 = this;
	
	                if (this.$route.current.params.categoria) {
	                    this.subItem = this.$route.current.params.categoria + ' / ' + this.$route.current.params.subcategoria;
	                    this.subcategorias.forEach(function (item) {
	                        if (item.subcategoria.toUpperCase() === _this2.$route.current.params.subcategoria) {
	                            _this2.subcategoriaSeleccionada = item;
	                        }
	                    });
	                } else if (this.$route.current.params.codigo) {
	                    this.subItem = this.$route.current.params.codigo;
	                } else if (this.$route.current.params.palabra) {
	                    this.subItem = this.$route.current.params.palabra;
	                }
	
	                this.currentPage = 1;
	                this.perPage = 20;
	                this.totalPages = Math.ceil(this.articulos.length / this.perPage);
	                this.pageReload();
	                this.$window.scrollTo(0, 0);
	            }
	        }, {
	            key: 'pageReload',
	            value: function pageReload() {
	
	                var inicio = this.currentPage * this.perPage - this.perPage;
	                var fin = this.currentPage * this.perPage;
	                this.articulosPaginados = this.articulos.slice(inicio, fin);
	                this.$window.scrollTo(0, 0);
	            }
	        }, {
	            key: 'buscarPorCategoria',
	            value: function buscarPorCategoria() {
	                if (!this.subcategoriaSeleccionada) return;
	                if (this.$route.current.params.subcategoria) {
	                    var arr = this.$location.path().split('/');
	                    arr[arr.length - 1] = this.subcategoriaSeleccionada.subcategoria.toUpperCase();
	                    this.$location.path(arr.join('/'));
	                } else {
	                    this.$location.path(this.$location.path() + '/' + this.subcategoriaSeleccionada.subcategoria.toUpperCase());
	                }
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	module.exports = "<br>\n<div class=\"container\">\n    <div class=\"row\">\n        <div class=\"col-12 pl-0 pr-0\">\n            <ol class=\"breadcrumb\">\n                <li class=\"breadcrumb-item\"><a ng-href=\"/\">INICIO</a></li>\n                <li class=\"breadcrumb-item active\" ng-if=\"$ctrl.$route.current.params.codigo\">{{$ctrl.$route.current.params.codigo}}</li>\n                <li class=\"breadcrumb-item active\" ng-if=\"$ctrl.$route.current.params.palabra\">{{$ctrl.$route.current.params.palabra}}</li>\n                <li class=\"breadcrumb-item\" ng-if=\"$ctrl.$route.current.params.categoria\" ng-class=\"{'active': !$ctrl.$route.current.params.subcategoria}\"><a ng-href=\"/articulo/categoria/{{$ctrl.$route.current.params.categoria}}\">{{$ctrl.$route.current.params.categoria}}</a></li>\n                <li class=\"breadcrumb-item active\" ng-if=\"$ctrl.$route.current.params.subcategoria\">{{$ctrl.$route.current.params.subcategoria}}</li>\n                <li style=\"position: absolute;top: 5px;right: 5px;\" ng-if=\"$ctrl.$route.current.params.categoria\">\n                    <select name=\"singleSelect\" class=\"form-control\" ng-model=\"$ctrl.subcategoriaSeleccionada\" ng-change=\"$ctrl.buscarPorCategoria()\" ng-options=\"item.subcategoria for item in $ctrl.subcategorias | orderBy: 'subcategoria'\">\n                        <option value=\"\" class=\"text-center\">--Cambiar Subcategoria--</option>\n                    </select>\n                </li>\n            </ol>\n\n        </div>\n<!--        <div class=\"col-4 pr-0 pull-right\">-->\n<!--            test-->\n<!--        </div>-->\n    </div>\n    <articulo-list articulos=\"$ctrl.articulosPaginados\" columna=\"col-12 col-sm-4 col-md-3\"></articulo-list>\n\n    <div class=\"row\">\n        <div class=\"col-12\">\n            <articulos-pagination current-page=\"$ctrl.currentPage\" total-pages=\"$ctrl.totalPages\"></articulos-pagination>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angularRoute = __webpack_require__(20);
	
	var _angularRoute2 = _interopRequireDefault(_angularRoute);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _carritoRouteComponent = __webpack_require__(43);
	
	var _carritoRouteService = __webpack_require__(45);
	
	var _carritoRouteService2 = _interopRequireDefault(_carritoRouteService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	var routes = function routes($routeProvider) {
	    $routeProvider.when('/carrito', {
	        template: '<carrito-route></carrito-route>',
	        authenticate: true
	    });
	};
	routes.$inject = ['$routeProvider'];
	
	exports.default = _angular2.default.module('pizzutoAutopartesApp.carrito', [_angularRoute2.default]).config(routes).component(_carritoRouteComponent.CarritoRouteComponent.selector, _carritoRouteComponent.CarritoRouteComponent).service('CarritoService', _carritoRouteService2.default).name;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CarritoRouteComponent = exports.CarritoRouteComponent = {
	
	    selector: 'carritoRoute',
	    template: __webpack_require__(44),
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['CarritoService', '$location', 'ToasterService'];
	        function controller(CarritoService, $location, ToasterService) {
	            _classCallCheck(this, controller);
	
	            this.tipoEnvio = ['RETIRA', 'MENSAJERO', 'COLECTIVO', 'EMPRESA DE TRANSPORTE', 'OTROS'];
	            this.tipoEnvioSeleccionado = this.tipoEnvio[0];
	            this.detalleEnvio = '';
	
	            Object.assign(this, { CarritoService: CarritoService, $location: $location, ToasterService: ToasterService });
	
	            this.mensaje = '';
	            this.enviardoOrder = false;
	        }
	
	        _createClass(controller, [{
	            key: 'getArticulosCarrito',
	            value: function getArticulosCarrito() {
	                return this.CarritoService.getArticulosCarrito();
	            }
	        }, {
	            key: 'getMontoTotalCarrito',
	            value: function getMontoTotalCarrito() {
	                return this.CarritoService.getMontoTotalCarrito();
	            }
	        }, {
	            key: 'actualizarArticuloCarrito',
	            value: function actualizarArticuloCarrito() {
	                return this.CarritoService.actualizarArticuloCarrito();
	            }
	        }, {
	            key: 'quitarArticuloCarrito',
	            value: function quitarArticuloCarrito(articulo) {
	                this.CarritoService.quitarArticuloCarrito(articulo);
	            }
	        }, {
	            key: 'vaciarCarrito',
	            value: function vaciarCarrito() {
	                this.CarritoService.vaciarCarrito();
	            }
	        }, {
	            key: 'generarOrder',
	            value: function generarOrder() {
	                var _this = this;
	
	                if (this.CarritoService.getCantidadArticulos() > 0) {
	                    this.enviardoOrder = true;
	                    this.CarritoService.generarOrder({ mensaje: this.mensaje, envio: { tipo: this.tipoEnvioSeleccionado, mensaje: this.detalleEnvio } }).then(function () {
	                        _this.CarritoService.vaciarCarrito();
	                        _this.$location.path('/');
	                        _this.ToasterService.popUp('success', 'Nueva Orden', 'Se ha generado con éxito.');
	                    }).catch(function (err) {
	                        _this.enviardoOrder = true;
	                        _this.ToasterService.error();
	                    });
	                }
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	module.exports = "<br>\n<div class=\"container\" id=\"carrito-container\">\n    <fieldset ng-disabled=\"$ctrl.enviardoOrder\">\n        <div class=\"row\">\n            <div class=\"col-12 text-center\">\n                <h2>Listado de articulos en el Carrito\n                    <button type=\"button\" class=\"btn btn-danger btn-sm pull-right\" ng-click=\"$ctrl.vaciarCarrito()\">\n                        Vaciar carrito\n                        <span class=\"fa fa-trash-o\"></span>\n                    </button>\n                </h2>\n            </div>\n        </div>\n        <br>\n        <div class=\"row\">\n            <div class=\"col-12\">\n                <div class=\"card p-0\">\n                    <div class=\"table-responsive\">\n                        <table class=\"table table-hover mb-0\">\n                            <thead>\n                                <tr>\n                                    <th>#</th>\n                                    <th>Codigo</th>\n                                    <th>Articulo</th>\n                                    <th>Cantidad</th>\n                                    <th>\n                                        <span class=\"pull-right\">Precio Unidad</span>\n                                    </th>\n                                    <th>\n                                        <span class=\"pull-right\">Precio Total</span>\n                                    </th>\n                                    <th>\n                                        <span class=\"text-center\"><i class=\"fa fa-gear\"></i></span>\n                                    </th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr ng-repeat=\"item in $ctrl.getArticulosCarrito()\">\n                                    <td>{{$index + 1}}</td>\n                                    <td><a ng-href=\"/articulo/ver/{{item._id}}\">{{item.codigo}}</a></td>\n                                    <td>{{item.descripcion}}</td>\n                                    <td width=\"150px\"><input type=\"number\" min=\"1\" ng-model=\"item.cantidad\" ng-change=\"$ctrl.actualizarArticuloCarrito()\"\n                                                             class=\"form-control\"></td>\n                                    <td>\n                                        <span class=\"pull-right\" ng-if=\"item.precioVisible\">{{item.precio | currency}}</span>\n                                        <span class=\"pull-right\" ng-if=\"!item.precioVisible\">-</span>\n                                    </td>\n                                    <td>\n                                        <span class=\"pull-right\" ng-if=\"item.precioVisible\">{{item.precio * item.cantidad | currency}}</span>\n                                        <span class=\"pull-right\" ng-if=\"!item.precioVisible\">-</span>\n                                    </td>\n                                    <td class=\"text-center\">\n                                        <a href=\"#\" ng-click=\"$ctrl.quitarArticuloCarrito(item)\">\n                                            <span class=\"fa fa-minus-circle c-rojo\"></span>\n                                        </a>\n                                    </td>\n                                </tr>\n                            </tbody>\n                            <tfoot ng-if=\"$ctrl.getMontoTotalCarrito() > 0\">\n                                <tr>\n                                    <td class=\"text-right\" colspan=\"7\">Monto del pedido:\n                                        <span class=\"badge badge-danger\" id=\"carrito-monto-total\">{{$ctrl.getMontoTotalCarrito() | currency}}</span>\n                                    </td>\n                                </tr>\n                            </tfoot>\n                        </table>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <br>\n        <div class=\"row\">\n\n            <div class=\"col-12 col-lg-3\">\n                <div class=\"alert alert-info p-2\"><label for=\"metodoEnvio\" class=\"mb-0 font-weight-bold\"> &nbsp; &nbsp;\n                    Metodo de envio</label></div>\n            </div>\n            <div class=\"col-6 col-lg-4\">\n                <select name=\"\" id=\"metodoEnvio\" class=\"form-control\" ng-model=\"$ctrl.tipoEnvioSeleccionado\"\n                        ng-options=\"item for item in $ctrl.tipoEnvio\"></select>\n            </div>\n            <div class=\"col-6 col-lg-5\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"Informacion del envio...\"\n                       ng-model=\"$ctrl.detalleEnvio\">\n            </div>\n        </div>\n        <br>\n        <div class=\"row\">\n            <div class=\"col-12\">\n                <div class=\"input-group input-group-lg\">\n                    <input type=\"text\" class=\"form-control\" placeholder=\"Adjuntar mensaje a la orden...\"\n                           ng-model=\"$ctrl.mensaje\">\n                    <div class=\"input-group-btn\">\n                        <button type=\"button\" class=\"btn btn-outline-info btn-lg pull-right\"\n                                ng-click=\"$ctrl.generarOrder()\"\n                                ng-disabled=\"!$ctrl.CarritoService.getCantidadArticulos()\">Generar Orden de Compra\n                            <span class=\"fa fa-shopping-cart\" ng-show=\"!$ctrl.enviardoOrder\"></span>\n                            <span class=\"fa fa-spin fa-circle-o-notch\" ng-show=\"$ctrl.enviardoOrder\"></span>\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </fieldset>\n</div>\n<br>\n"

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _Articulo = function _Articulo(item) {
	    _classCallCheck(this, _Articulo);
	
	    this._id = item._id;
	    this.codigo = item.codigo;
	    this.descripcion = item.descripcion;
	    this.imagenUrl = item.imagenUrl;
	    this.categoria = item.categoria;
	    this.cantidad = item.cantidad;
	    this.precio = item.precio;
	    this.precioVisible = item.precioVisible;
	};
	
	var _class = function () {
	
	    /*@ngInject*/
	    _class.$inject = ['$cookies', '$http', 'ORDENES_URL'];
	    function _class($cookies, $http, ORDENES_URL) {
	        _classCallCheck(this, _class);
	
	        Object.assign(this, { $cookies: $cookies, $http: $http, ORDENES_URL: ORDENES_URL });
	        this.listadoArticulos = [];
	        var carritoConItems = this.$cookies.getObject('carrito');
	        if (carritoConItems && carritoConItems.articulos) {
	            this.listadoArticulos = carritoConItems.articulos;
	        }
	    }
	
	    _createClass(_class, [{
	        key: 'agregarArticulo',
	        value: function agregarArticulo(articulo) {
	            var artAux = this.listadoArticulos.find(function (x) {
	                return x._id === articulo._id;
	            });
	            if (artAux) {
	                artAux.cantidad += articulo.cantidad;
	            } else {
	                this.listadoArticulos.push(new _Articulo(articulo));
	            }
	            this._actualizarCookies();
	        }
	    }, {
	        key: 'actualizarArticuloCarrito',
	        value: function actualizarArticuloCarrito() {
	            this._actualizarCookies();
	        }
	    }, {
	        key: 'quitarArticuloCarrito',
	        value: function quitarArticuloCarrito(articulo) {
	            var index = this.listadoArticulos.indexOf(articulo);
	            if (index != -1) {
	                this.listadoArticulos.splice(index, 1);
	            }
	            this._actualizarCookies();
	        }
	    }, {
	        key: 'vaciarCarrito',
	        value: function vaciarCarrito() {
	            this.listadoArticulos = [];
	            this._actualizarCookies();
	        }
	    }, {
	        key: 'getArticulosCarrito',
	        value: function getArticulosCarrito() {
	            return this.listadoArticulos;
	        }
	    }, {
	        key: 'getMontoTotalCarrito',
	        value: function getMontoTotalCarrito() {
	            var monto = 0;
	            var precioVisible = true;
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = this.listadoArticulos[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var item = _step.value;
	
	                    monto += item.precio * item.cantidad;
	                    if (item.precioVisible === false) precioVisible = false;
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            if (!precioVisible) monto = 0;
	            return monto;
	        }
	    }, {
	        key: 'getCantidadArticulos',
	        value: function getCantidadArticulos() {
	            return this.listadoArticulos.length;
	        }
	    }, {
	        key: 'generarOrder',
	        value: function generarOrder(extra) {
	            if (this.getCantidadArticulos() > 0) {
	                return this.$http.post(this.ORDENES_URL, { mensaje: extra.mensaje, articulos: this.getArticulosCarrito(), envio: extra.envio });
	            }
	        }
	    }, {
	        key: '_actualizarCookies',
	        value: function _actualizarCookies() {
	            var expires = new Date();
	            expires.setTime(expires.getTime() + 31556952000);
	            this.$cookies.putObject('carrito', { articulos: this.getArticulosCarrito() }, { expires: expires });
	        }
	    }]);
	
	    return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _contactoRouteComponent = __webpack_require__(47);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _contaco = __webpack_require__(49);
	
	var _contaco2 = _interopRequireDefault(_contaco);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ngRoute = __webpack_require__(20);
	
	/*@ngInject*/
	var routes = function routes($routeProvider) {
	    $routeProvider.when('/contacto', {
	        template: '<contacto-route></contacto-route>',
	        authenticate: true
	    });
	};
	routes.$inject = ['$routeProvider'];
	
	exports.default = _angular2.default.module('pizzutoAutopartesApp.contacto', [ngRoute]).config(routes).component(_contactoRouteComponent.ContactoRouteComponent.selector, _contactoRouteComponent.ContactoRouteComponent).service('ContactoService', _contaco2.default).name;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ContactoRouteComponent = exports.ContactoRouteComponent = {
	    selector: 'contactoRoute',
	    template: __webpack_require__(48),
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['ContactoService', 'ToasterService'];
	        function controller(ContactoService, ToasterService) {
	            _classCallCheck(this, controller);
	
	            Object.assign(this, { ContactoService: ContactoService, ToasterService: ToasterService });
	            this.mail = { nombre: '', telefono: '', email: '', ciudad: '', pais: '', mensaje: '' };
	            this.enviardoMensaje = false;
	            this.cleanForm();
	        }
	
	        _createClass(controller, [{
	            key: 'sendMail',
	            value: function sendMail(form) {
	                var _this = this;
	
	                if (form.$valid) {
	                    this.enviardoMensaje = true;
	                    this.ContactoService.sendMail(this.mail).then(function (res) {
	                        _this.mensajeEnviado = true;
	                        _this.ToasterService.popUp('success', 'E-Mail', 'Se ha enviado con éxito.');
	                    }).catch(function (err) {
	                        return _this.ToasterService.error();
	                    });
	                } else {
	                    this.enviardoMensaje = false;
	                    this.ToasterService.popUp('info', 'Informacion', 'El formulario esta incompleto o no es válido.');
	                }
	            }
	        }, {
	            key: 'cleanForm',
	            value: function cleanForm() {
	                this.mail = { nombre: '', telefono: '', email: '', ciudad: '', pais: '', mensaje: '' };
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <br>\n    <div class=\"row\">\n        <div class=\"col-12 col-lg-8 offset-lg-2 text-center\">\n            <h1>\n                <div class=\"alert alert-info\">Formulario de Contacto</div>\n            </h1>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-12 col-lg-8 offset-lg-2 \">\n            <fieldset ng-disabled=\"$ctrl.enviardoMensaje\">\n                <form class=\"formulario-background\" name=\"form\" autocomplete=\"off\">\n                    <div class=\"row\">\n                        <div class=\"col-12 col-lg-6\">\n                            <div class=\"form-group\">\n                                <label for=\"formContactoNombre\">Nombre completo\n                                    <small>(requerido)</small>\n                                </label>\n                                <input type=\"text\" class=\"form-control\" id=\"formContactoNombre\" ng-model=\"$ctrl.mail.nombre\" required>\n                            </div>\n                        </div>\n                        <div class=\"col-12 col-lg-6\">\n                            <div class=\"form-group\">\n                                <label for=\"formContactoTelefono\">Telefono\n                                    <small>(requerido)</small>\n                                </label>\n                                <input type=\"text\" class=\"form-control\" id=\"formContactoTelefono\" ng-model=\"$ctrl.mail.telefono\" required>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class=\"row\">\n                        <div class=\"col-12\">\n                            <div class=\"form-group\">\n                                <label for=\"formContactoCorreo\">Correo electronico\n                                    <small>(requerido)</small>\n                                </label>\n                                <input type=\"email\" class=\"form-control\" id=\"formContactoCorreo\" ng-model=\"$ctrl.mail.email\" required>\n                            </div>\n\n                        </div>\n                    </div>\n\n                    <div class=\"row\">\n                        <div class=\"col-6\">\n                            <div class=\"form-group\">\n                                <label for=\"formContactoPais\">Pais</label>\n                                <input type=\"text\" class=\"form-control\" id=\"formContactoPais\" ng-model=\"$ctrl.mail.pais\">\n                            </div>\n                        </div>\n                        <div class=\"col-6\">\n                            <div class=\"form-group\">\n                                <label for=\"formContactoCiudad\">Ciudad</label>\n                                <input type=\"text\" class=\"form-control\" id=\"formContactoCiudad\" ng-model=\"$ctrl.mail.ciudad\">\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-12\">\n                            <div class=\"form-group\">\n                                <label for=\"formContactoCiudad\">Comentario</label>\n                                <textarea class=\"form-control\" id=\"formContactoComentario\" ng-model=\"$ctrl.mail.mensaje\" required></textarea>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class=\"row\">\n                        <div class=\"col-6\">\n                        <strong ng-show=\"$ctrl.mensajeEnviado\">El mensaje se ha enviado con exito.</strong>\n                        </div>\n                        <div class=\"col-6\">\n                            <button type=\"submit\" class=\"btn btn-outline-info btn-lg pull-right\" ng-click=\"$ctrl.sendMail(form)\">ENVIAR\n                                <span class=\"fa fa-send\" ng-show=\"!$ctrl.enviardoMensaje || $ctrl.mensajeEnviado\"></span>\n                                <span class=\"fa fa-spin fa-circle-o-notch\" ng-show=\"$ctrl.enviardoMensaje && !$ctrl.mensajeEnviado\"></span>\n                            </button>\n                        </div>\n                    </div>\n\n                </form>\n            </fieldset>\n        </div>\n    </div>\n</div>\n<br>\n"

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
	
	    /*@ngInject*/
	    _class.$inject = ['$http', 'UTIL_URL'];
	    function _class($http, UTIL_URL) {
	        _classCallCheck(this, _class);
	
	        Object.assign(this, { $http: $http, UTIL_URL: UTIL_URL });
	    }
	
	    _createClass(_class, [{
	        key: "sendMail",
	        value: function sendMail(mail) {
	            return this.$http.post(this.UTIL_URL + "/sendMail", mail);
	        }
	    }]);
	
	    return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularRoute = __webpack_require__(20);
	
	var _angularRoute2 = _interopRequireDefault(_angularRoute);
	
	var _descargasRoute = __webpack_require__(51);
	
	var _editarDescargas = __webpack_require__(53);
	
	var _crearDescargas = __webpack_require__(55);
	
	var _descargas = __webpack_require__(57);
	
	var _descargas2 = _interopRequireDefault(_descargas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	var routes = function routes($routeProvider) {
	    getDescargas.$inject = ['DescargasService'];
	    $routeProvider.when('/descargas', {
	        template: '<descargas-route descargas="$resolve.descargas.data"></descargas-route>',
	        authenticate: true,
	        resolve: {
	            descargas: getDescargas
	        }
	
	    }).when('/descargas/crear', {
	        template: '<crear-descargas></crear-descargas>',
	        authenticate: true,
	        administrator: true
	    }).when('/descargas/editar', {
	        template: '<editar-descargas descargas="$resolve.descargas.data"></editar-descargas>',
	        authenticate: true,
	        administrator: true,
	        resolve: {
	            descargas: getDescargas
	        }
	    });
	
	    function getDescargas(DescargasService) {
	        return DescargasService.getDescargas();
	    }
	};
	routes.$inject = ['$routeProvider'];
	
	exports.default = _angular2.default.module('pizzutoAutopartesApp.descargas', [_angularRoute2.default]).config(routes).component(_descargasRoute.DescargasRouteComponent.selector, _descargasRoute.DescargasRouteComponent).component(_editarDescargas.EditarDescargasComponent.selector, _editarDescargas.EditarDescargasComponent).component(_crearDescargas.CrearDescargasComponent.selector, _crearDescargas.CrearDescargasComponent).service('DescargasService', _descargas2.default).name;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var DescargasRouteComponent = exports.DescargasRouteComponent = {
	    selector: 'descargasRoute',
	    template: __webpack_require__(52),
	    bindings: {
	        descargas: '<'
	    }
	};

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	module.exports = "<br>\n<div class=\"container\" id=\"descargas-container\">\n    <div class=\"row\">\n        <div class=\"col-12 col-lg-6 text-center\">\n            <h2 class=\"alert alert-danger\">FORMATO ACROBAT (PFD)\n                <link-editar link=\"/descargas/editar\"></link-editar>\n                <span class=\"fa fa-file-pdf-o\"></span>\n            </h2>\n            <ul class=\"ul-descargas\">\n                <li ng-repeat=\"item in $ctrl.descargas | filter: {tipo: 'pdf'}\">\n                    <h3>\n                        <a ng-href=\"{{item.link}}\" target=\"_blank\" download>\n                            <span class=\"fa fa-arrow-circle-down pull-left\"></span>\n                            {{item.nombre}}</a>\n                    </h3>\n                    <img ng-if=\"item.qrUrl\" ng-src=\"{{item.qrUrl}}\" class=\"img-qr-descarga\"\n                         alt=\"QR {{item.nombre}}\">\n                </li>\n            </ul>\n        </div>\n\n        <div class=\"col-12 col-lg-6 text-center\">\n            <h2 class=\"alert alert-danger\">FORMATO EXCEL (XLSX)\n                <link-editar link=\"/descargas/editar\"></link-editar>\n                <span class=\"fa fa-file-excel-o\"></span>\n            </h2>\n            <ul class=\"ul-descargas\">\n                <li ng-repeat=\"item in $ctrl.descargas | filter: {tipo: 'xlsx'}\">\n                    <h3>\n                        <a ng-href=\"{{item.link}}\" target=\"_blank\" download>\n                            <span class=\"fa fa-arrow-circle-down pull-left\"></span>\n                            {{item.nombre}}</a>\n                    </h3>\n                    <img ng-if=\"item.qrUrl\" ng-src=\"{{item.qrUrl}}\" class=\"img-qr-descarga\"\n                         alt=\"QR {{item.nombre}}\">\n                </li>\n            </ul>\n        </div>\n\n    </div>\n</div>\n"

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditarDescargasComponent = exports.EditarDescargasComponent = {
	    selector: 'editarDescargas',
	    template: __webpack_require__(54),
	    bindings: {
	        descargas: '='
	    },
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['DescargasService', 'ToasterService'];
	        function controller(DescargasService, ToasterService) {
	            _classCallCheck(this, controller);
	
	            Object.assign(this, { DescargasService: DescargasService, ToasterService: ToasterService });
	        }
	
	        _createClass(controller, [{
	            key: 'eliminarDescarga',
	            value: function eliminarDescarga(item) {
	                var _this = this;
	
	                this.DescargasService.eliminarDescarga(item._id).then(function () {
	                    _this.ToasterService.popUp('success', 'Descarga', 'Se ha eliminado con éxito.');
	                    var index = _this.descargas.indexOf(item);
	                    if (index != -1) {
	                        _this.descargas.splice(index, 1);
	                    } else {
	                        _this.ToasterService.popUp('error', 'Informacion', 'Descarga no encontrada.');
	                    }
	                });
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	module.exports = "<br>\n<div class=\"container\" id=\"descargas-container\">\n    <div class=\"card\">\n        <div class=\"card-block\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-hover\">\n                    <thead>\n                        <tr>\n                            <th>#</th>\n                            <th>Nombre</th>\n                            <th class=\"text-center\">Tipo</th>\n                            <th class=\"text-center\"><span class=\"fa fa-link\"></span></th>\n                            <th class=\"text-center\">QR</th>\n                            <th class=\"text-center\"><span class=\"fa fa-gear\"></span></th>\n                        </tr>\n                    </thead>\n                    <tbody>\n                        <tr ng-repeat=\"item in $ctrl.descargas track by $index\">\n                            <td>{{$index + 1}}</td>\n                            <td>{{item.nombre}}</td>\n                            <td class=\"text-center\">{{item.tipo.toUpperCase()}}</td>\n                            <td class=\"text-center\"><a ng-href=\"{{item.link}}\" class=\"btn btn-success btn-sm\"><span\n                                    class=\"fa fa-download\"></span></a></td>\n                            <td class=\"text-center\">\n                                <img ng-if=\"item.qrUrl\" ng-src=\"{{item.qrUrl}}\" alt=\"QR\" height=\"60px\">\n                            </td>\n                            <td class=\"text-center\">\n                                <button type=\"button\" class=\"btn btn-outline-danger btn-sm\"\n                                        ng-click=\"$ctrl.eliminarDescarga(item)\"><span class=\"fa fa-trash\"></span>\n                                </button>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CrearDescargasComponent = exports.CrearDescargasComponent = {
	    selector: 'crearDescargas',
	    template: __webpack_require__(56),
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['DescargasService', '$location', 'Upload', 'FILE_UPLOAD_URL', 'QR_UPLOAD_URL', 'ToasterService'];
	        function controller(DescargasService, $location, Upload, FILE_UPLOAD_URL, QR_UPLOAD_URL, ToasterService) {
	            _classCallCheck(this, controller);
	
	            Object.assign(this, { DescargasService: DescargasService, $location: $location, Upload: Upload, FILE_UPLOAD_URL: FILE_UPLOAD_URL, QR_UPLOAD_URL: QR_UPLOAD_URL, ToasterService: ToasterService });
	            this.nuevaDescarga = { nombre: '', tipo: 'pdf', link: '', qrUrl: '' };
	            this.subiendoArchivo = false;
	        }
	
	        _createClass(controller, [{
	            key: 'setTipo',
	            value: function setTipo(tipo) {
	                this.nuevaDescarga.tipo = tipo;
	            }
	        }, {
	            key: 'uploadFiles',
	            value: function uploadFiles(file) {
	                this.file = file;
	            }
	        }, {
	            key: 'uploadQr',
	            value: function uploadQr(file, err) {
	                if (!err || err.length === 0) this.qrFile = file;
	            }
	        }, {
	            key: 'subirQr',
	            value: function subirQr() {
	                var _this = this;
	
	                if (!this.qrFile) return Promise.resolve();
	                return this.Upload.upload({
	                    url: this.QR_UPLOAD_URL,
	                    data: {
	                        file: this.qrFile
	                    }
	                }).then(function (res) {
	                    _this.nuevaDescarga.qrUrl = res.data.secure_url;
	                });
	            }
	        }, {
	            key: 'crearDescarga',
	            value: function crearDescarga(form) {
	                var _this2 = this;
	
	                if (form.$valid) {
	                    if (this.file) {
	                        this.subiendoArchivo = true;
	                        this.Upload.upload({
	                            url: this.FILE_UPLOAD_URL,
	                            data: {
	                                file: this.file
	                            }
	                        }).then(function (res) {
	                            _this2.nuevaDescarga.link = res.data.secure_url;
	                            return _this2.subirQr();
	                        }).then(function () {
	                            return _this2.DescargasService.agregarDescarga(_this2.nuevaDescarga);
	                        }).then(function () {
	                            _this2.ToasterService.popUp('success', 'Descarga', 'Se ha creado con éxito.');
	                            _this2.$location.path('/');
	                        }).catch(function () {
	                            _this2.subiendoArchivo = false;
	                            _this2.ToasterService.popUp('error', 'Descarga', 'No se pudo crear la descarga.');
	                        });
	                    } else {
	                        this.subiendoArchivo = false;
	                        this.ToasterService.popUp('info', 'Informacion', 'Seleccione un documento.');
	                    }
	                } else {
	                    this.ToasterService.popUp('info', 'Informacion', 'El formulario esta incompleto o no es válido.');
	                }
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	module.exports = "<br>\n<div class=\"container\">\n    <div class=\"card\">\n        <div class=\"card-header c-celeste\">\n            <h1 class=\"text-center\">Crear nueva Descarga</h1>\n        </div>\n        <div class=\"card-block\">\n            <div class=\"col-12\">\n                <form class=\"\" name=\"formDescargas\" autocomplete=\"off\">\n                    <fieldset ng-disabled=\"$ctrl.subiendoArchivo\">\n                        <div class=\"form-group\">\n                            <div class=\"row\">\n                                <div class=\"col-12 col-lg-9\">\n                                    <label for=\"nombre\">Nombre de la descarga</label>\n                                    <input type=\"text\" id=\"nombre\" class=\"form-control\"\n                                           ng-model=\"$ctrl.nuevaDescarga.nombre\" required>\n                                </div>\n                                <div class=\"col-12 col-lg-3\">\n                                    <label for=\"\">Tipo</label>\n                                    <div class=\"btn-group btn-group-justified\">\n                                        <a class=\"btn \"\n                                           ng-class=\"{'btn-info': $ctrl.nuevaDescarga.tipo === 'pdf'}\"\n                                           ng-click=\"$ctrl.setTipo('pdf')\">PDF</a>\n                                        <a class=\"btn \"\n                                           ng-class=\"{'btn-info': $ctrl.nuevaDescarga.tipo === 'xlsx'}\"\n                                           ng-click=\"$ctrl.setTipo('xlsx')\">XLSX</a>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <div class=\"row\">\n                                <div class=\"col-12 col-lg-6\">\n                                    <label>Archivo</label><br>\n                                    <input type=\"file\" ngf-select=\"$ctrl.uploadFiles($file, $invalidFiles)\"\n                                           ngf-max-size=\"10MB\">\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <div class=\"row\">\n                                <div class=\"col-12 col-lg-6\">\n                                    <label>Imagen QR (opcional)</label><br>\n                                    <input type=\"file\" ngf-select=\"$ctrl.uploadQr($file, $invalidFiles)\"\n                                           ngf-multiple=\"false\" ngf-pattern=\"'image/*'\" accept=\"image/*\"\n                                           ngf-max-size=\"5MB\">\n                                    <div class=\"mt-2\" ng-show=\"$ctrl.qrFile\">\n                                        <img ngf-src=\"$ctrl.qrFile\" class=\"img-thumbnail img-qr-preview\">\n                                    </div>\n                                </div>\n                                <div class=\"col-12 col-lg-6\">\n                                    <button type=\"button\" class=\"btn btn-outline-info pull-right btn-lg\"\n                                            ng-click=\"$ctrl.crearDescarga(formDescargas)\"> Crear descarga\n                                        <span class=\"fa fa-plus\" ng-show=\"!$ctrl.subiendoArchivo\"></span>\n                                        <span class=\"fa fa-spin fa-circle-o-notch\"\n                                              ng-show=\"$ctrl.subiendoArchivo\"></span>\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                    </fieldset>\n                </form>\n            </div>\n        </div>\n    </div>\n    <br>\n</div>\n"

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
	
	    /*@ngInject*/
	    _class.$inject = ['$http', 'DESCARGAS_URL'];
	    function _class($http, DESCARGAS_URL) {
	        _classCallCheck(this, _class);
	
	        Object.assign(this, { $http: $http, DESCARGAS_URL: DESCARGAS_URL });
	    }
	
	    _createClass(_class, [{
	        key: 'getDescargas',
	        value: function getDescargas() {
	            return this.$http.get(this.DESCARGAS_URL);
	        }
	    }, {
	        key: 'agregarDescarga',
	        value: function agregarDescarga(descarga) {
	            return this.$http.post(this.DESCARGAS_URL, descarga);
	        }
	    }, {
	        key: 'eliminarDescarga',
	        value: function eliminarDescarga(id) {
	            return this.$http.delete(this.DESCARGAS_URL + '/' + id);
	        }
	    }]);
	
	    return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularRoute = __webpack_require__(20);
	
	var _angularRoute2 = _interopRequireDefault(_angularRoute);
	
	var _configuracion = __webpack_require__(59);
	
	var _configuracion2 = _interopRequireDefault(_configuracion);
	
	var _sliders = __webpack_require__(60);
	
	var _destacados = __webpack_require__(62);
	
	var _ofertas = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	var configuracionRoutes = function configuracionRoutes($routeProvider) {
	    getSlides.$inject = ['ConfiguracionService'];
	    getOfertas.$inject = ['ConfiguracionService'];
	    getDestacados.$inject = ['ConfiguracionService'];
	    $routeProvider.when('/configuracion/slider', {
	        template: '<editar-slider slides="$resolve.slides.data.slides" categorias="$resolve.slides.data.categorias"></editar-slider>',
	        authenticate: true,
	        administrator: true,
	        resolve: {
	            slides: getSlides
	        }
	    }).when('/configuracion/ofertas', {
	        template: '<editar-ofertas ofertas="$resolve.ofertas.data.ofertas" categorias="$resolve.ofertas.data.categorias"></editar-ofertas>',
	        authenticate: true,
	        administrator: true,
	        resolve: {
	            ofertas: getOfertas
	        }
	    }).when('/configuracion/destacados', {
	        template: '<editar-destacados destacados="$resolve.destacados.data.destacados"></editar-destacados>',
	        authenticate: true,
	        administrator: true,
	        resolve: {
	            destacados: getDestacados
	        }
	    });
	
	    function getSlides(ConfiguracionService) {
	        return ConfiguracionService.getSlides();
	    }
	
	    function getOfertas(ConfiguracionService) {
	        return ConfiguracionService.getOfertas();
	    }
	
	    function getDestacados(ConfiguracionService) {
	        return ConfiguracionService.getDestacados();
	    }
	};
	configuracionRoutes.$inject = ['$routeProvider'];
	
	exports.default = _angular2.default.module('pizzuto-autopartes.configuracion', [_angularRoute2.default]).config(configuracionRoutes).service('ConfiguracionService', _configuracion2.default).component(_sliders.SliderComponent.selector, _sliders.SliderComponent).component(_destacados.DestacadosComponent.selector, _destacados.DestacadosComponent).component(_ofertas.OfertasComponent.selector, _ofertas.OfertasComponent).name;

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
	
	    /*@ngInject*/
	    _class.$inject = ['$http', 'UTIL_URL'];
	    function _class($http, UTIL_URL) {
	        _classCallCheck(this, _class);
	
	        Object.assign(this, { $http: $http, UTIL_URL: UTIL_URL });
	    }
	
	    _createClass(_class, [{
	        key: "getSlides",
	        value: function getSlides() {
	            return this.$http.get(this.UTIL_URL + "/slides");
	        }
	    }, {
	        key: "actualizarSlide",
	        value: function actualizarSlide(id, destino) {
	            return this.$http.put(this.UTIL_URL + "/slides/" + id, destino);
	        }
	    }, {
	        key: "borrarSlide",
	        value: function borrarSlide(id) {
	            return this.$http.delete(this.UTIL_URL + "/slides/" + id);
	        }
	    }, {
	        key: "getOfertas",
	        value: function getOfertas() {
	            return this.$http.get(this.UTIL_URL + "/ofertas");
	        }
	    }, {
	        key: "actualizarOferta",
	        value: function actualizarOferta(id, destino) {
	            return this.$http.put(this.UTIL_URL + "/ofertas/" + id, destino);
	        }
	    }, {
	        key: "borrarOferta",
	        value: function borrarOferta(id) {
	            return this.$http.delete(this.UTIL_URL + "/ofertas/" + id);
	        }
	    }, {
	        key: "getDestacados",
	        value: function getDestacados() {
	            return this.$http.get(this.UTIL_URL + "/destacados");
	        }
	    }, {
	        key: "agregarDestacado",
	        value: function agregarDestacado(codigo) {
	            return this.$http.post(this.UTIL_URL + "/destacados/" + codigo);
	        }
	    }, {
	        key: "borrarDestacado",
	        value: function borrarDestacado(id) {
	            return this.$http.delete(this.UTIL_URL + "/destacados/" + id);
	        }
	    }]);
	
	    return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SliderComponent = exports.SliderComponent = {
	    selector: 'editarSlider',
	    template: __webpack_require__(61),
	    bindings: {
	        slides: '<',
	        categorias: '<'
	    },
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['UTIL_URL', 'Upload', 'ConfiguracionService', '$route', 'ToasterService'];
	        function controller(UTIL_URL, Upload, ConfiguracionService, $route, ToasterService) {
	            _classCallCheck(this, controller);
	
	            Object.assign(this, { UTIL_URL: UTIL_URL, Upload: Upload, ConfiguracionService: ConfiguracionService, $route: $route, ToasterService: ToasterService });
	            this.subiendoArchivo = false;
	        }
	
	        _createClass(controller, [{
	            key: '$onInit',
	            value: function $onInit() {
	                (this.slides || []).forEach(function (slide) {
	                    slide.categoria = slide.categoria || null;
	                    slide.subcategoria = slide.subcategoria || null;
	                });
	            }
	        }, {
	            key: 'uploadFiles',
	            value: function uploadFiles(file, err) {
	                if (err.length === 0) this.file = file;
	            }
	        }, {
	            key: 'subirSlide',
	            value: function subirSlide() {
	                var _this = this;
	
	                if (this.file) {
	                    this.subiendoArchivo = true;
	                    this.Upload.upload({
	                        url: this.UTIL_URL + '/slides/upload',
	                        data: {
	                            categoria: this.categoriaSeleccionada ? this.categoriaSeleccionada.categoria : '',
	                            subcategoria: this.subcategoriaSeleccionada ? this.subcategoriaSeleccionada.subcategoria : '',
	                            file: this.file
	                        }
	                    }).then(function (res) {
	                        _this.ToasterService.popUp('success', 'Slider', 'Se ha creado con éxito.');
	                        _this.$route.reload();
	                    });
	                } else {
	                    this.subiendoArchivo = false;
	                    this.ToasterService.popUp('info', 'Informacion', 'Seleccione una imagen.');
	                }
	            }
	        }, {
	            key: 'subcategoriasDe',
	            value: function subcategoriasDe(nombreCategoria) {
	                var categoria = (this.categorias || []).find(function (item) {
	                    return item.categoria === nombreCategoria;
	                });
	                return categoria ? categoria.subcategorias : [];
	            }
	        }, {
	            key: 'cambiarCategoriaSlide',
	            value: function cambiarCategoriaSlide(slide) {
	                slide.subcategoria = null;
	            }
	        }, {
	            key: 'guardarDestinoSlide',
	            value: function guardarDestinoSlide(slide) {
	                var _this2 = this;
	
	                this.ConfiguracionService.actualizarSlide(slide._id, {
	                    categoria: slide.categoria || '',
	                    subcategoria: slide.subcategoria || ''
	                }).then(function (data) {
	                    _this2.ToasterService.popUp('success', 'Slider', 'Se ha actualizado el destino.');
	                });
	            }
	        }, {
	            key: 'borrarSlide',
	            value: function borrarSlide(id) {
	                var _this3 = this;
	
	                this.ConfiguracionService.borrarSlide(id).then(function (data) {
	                    _this3.$route.reload();
	                });
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	module.exports = "<br>\n<div class=\"container p-lg-4\">\n<div class=\"col-12\">\n    <fieldset ng-disabled=\"$ctrl.subiendoArchivo\">\n        <form name=\"formCrearSlider\" autocomplete=\"off\">\n            <div class=\"form-group\">\n                <div class=\"row drag-and-drop-zone\" ngf-drag-over-class=\"'dragover'\"\n                     ngf-drop=\"$ctrl.uploadFiles($file, $invalidFiles)\" ngf-multiple=\"false\"\n                     ngf-pattern=\"'image/*'\" accept=\"image/*\" ngf-max-size=\"5MB\"\n                     ngf-resize=\"{width: 871, height: 381, centerCrop: true}\"\n                     ngf-resize-if=\"$width > 871 || $height > 381\">\n                    <div class=\"col-12 col-lg-4\">\n                        <div class=\"row\">\n                            <div class=\"col-12\">\n                                <h2 class=\"c-celeste\">Agregar nueva imagen</h2>\n                                <input type=\"file\" ngf-select=\"$ctrl.uploadFiles($file, $invalidFiles)\"\n                                       ngf-multiple=\"false\" ngf-pattern=\"'image/*'\" accept=\"image/*\" ngf-max-size=\"5MB\"\n                                       ngf-resize=\"{width: 871, height: 381, centerCrop: true}\"\n                                       ngf-resize-if=\"$width > 871 || $height > 381\">\n                            </div>\n                            <div class=\"col-12 text-center mt-2\">\n                                <img ngf-src=\"$ctrl.file\" class=\"img-thumbnail img-thumbnail-height\" height=\"70px\">\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-12 col-lg-4\">\n                        <div class=\"row\">\n                            <div class=\"col-12\">\n                                <div class=\"form-group\">\n                                    <label>Categoria (opcional)</label>\n                                    <select name=\"singleSelect\" class=\"form-control\"\n                                            ng-model=\"$ctrl.categoriaSeleccionada\"\n                                            ng-change=\"$ctrl.subcategoriaSeleccionada = null\"\n                                            ng-options=\"item.categoria for item in $ctrl.categorias\">\n                                        <option value=\"\">--Sin redireccion--</option>\n                                    </select>\n                                </div>\n                            </div>\n                            <div class=\"col-12\">\n                                <div class=\"form-group\">\n                                    <label>Subcategoria</label>\n                                    <select name=\"singleSelect\" class=\"form-control\"\n                                            ng-disabled=\"!$ctrl.categoriaSeleccionada\"\n                                            ng-model=\"$ctrl.subcategoriaSeleccionada\"\n                                            ng-options=\"item.subcategoria for item in $ctrl.categoriaSeleccionada.subcategorias | orderBy: 'subcategoria'\">\n                                        <option value=\"\">--Seleccionar Subcategoria--</option>\n                                    </select>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-12 col-lg-4\" style=\"margin-top: 20px\">\n                        <button type=\"button\" class=\"btn btn-info btn-lg pull-right\"\n                                ng-click=\"$ctrl.subirSlide()\">Agregar imagen\n                            <span class=\"fa fa-plus\" ng-show=\"!$ctrl.subiendoArchivo\"></span>\n                            <span class=\"fa fa-spin fa-circle-o-notch\" ng-show=\"$ctrl.subiendoArchivo\"></span>\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </form>\n    </fieldset>\n</div>\n\n    <div class=\"row\">\n        <div class=\"col-12\">\n            <div class=\"card\">\n                <div class=\"card-block\">\n                    <div class=\"table-responsive\">\n                        <table class=\"table table-hover\">\n                            <thead>\n                                <tr>\n                                    <th>Imagen</th>\n                                    <th>Redirige a</th>\n                                    <th class=\"text-center\">\n\n                                        <span class=\"fa fa-gear\"></span>\n                                    </th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr ng-repeat=\"item in $ctrl.slides\">\n                                    <td><img ng-src=\"{{item.imagenUrl}}\" alt=\"\" height=\"300px\"></td>\n                                    <td style=\"min-width: 250px\">\n                                        <div class=\"form-group\">\n                                            <label>Categoria</label>\n                                            <select class=\"form-control\"\n                                                    ng-model=\"item.categoria\"\n                                                    ng-change=\"$ctrl.cambiarCategoriaSlide(item)\"\n                                                    ng-options=\"cat.categoria as cat.categoria for cat in $ctrl.categorias\">\n                                                <option value=\"\">--Sin redireccion--</option>\n                                            </select>\n                                        </div>\n                                        <div class=\"form-group\">\n                                            <label>Subcategoria</label>\n                                            <select class=\"form-control\"\n                                                    ng-disabled=\"!item.categoria\"\n                                                    ng-model=\"item.subcategoria\"\n                                                    ng-options=\"sub.subcategoria as sub.subcategoria for sub in $ctrl.subcategoriasDe(item.categoria) | orderBy: 'subcategoria'\">\n                                                <option value=\"\">--Seleccionar Subcategoria--</option>\n                                            </select>\n                                        </div>\n                                        <button type=\"button\" class=\"btn btn-info\"\n                                                ng-click=\"$ctrl.guardarDestinoSlide(item)\"\n                                                ng-disabled=\"$ctrl.subiendoArchivo\">\n                                            <span class=\"fa fa-save\"></span>\n                                            Guardar destino\n                                        </button>\n                                    </td>\n                                    <td class=\"text-center\">\n                                        <button type=\"button\" class=\"btn btn-danger\"\n                                                title=\"Borrar imagen\" aria-label=\"Borrar imagen\"\n                                                ng-click=\"$ctrl.borrarSlide(item._id)\"\n                                                ng-disabled=\"$ctrl.subiendoArchivo\">\n                                            <span class=\"fa fa-trash\"></span>\n                                        </button>\n                                    </td>\n                                </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<br>\n"

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DestacadosComponent = exports.DestacadosComponent = {
	    selector: 'editarDestacados',
	    template: __webpack_require__(63),
	    bindings: {
	        destacados: '<'
	    },
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['ConfiguracionService', '$route', 'ToasterService'];
	        function controller(ConfiguracionService, $route, ToasterService) {
	            _classCallCheck(this, controller);
	
	            Object.assign(this, { ConfiguracionService: ConfiguracionService, $route: $route, ToasterService: ToasterService });
	            this.subiendoArchivo = false;
	        }
	
	        _createClass(controller, [{
	            key: 'agregarDestacado',
	            value: function agregarDestacado() {
	                var _this = this;
	
	                if (this.codigoDestacado) {
	                    this.ConfiguracionService.agregarDestacado(this.codigoDestacado).then(function (res) {
	                        _this.ToasterService.popUp('success', 'Articulo', 'Se ha agregado con éxito.');
	                        _this.$route.reload();
	                    }).catch(function (err) {
	                        if (err.status === 404) {
	                            _this.ToasterService.popUp('info', 'Articulo', 'El código no existe.');
	                        } else {
	                            _this.ToasterService.error();
	                        }
	                    });
	                } else {
	                    this.ToasterService.popUp('info', 'Articulo', 'Agregue un código.');
	                }
	            }
	        }, {
	            key: 'borrarDestacado',
	            value: function borrarDestacado(id) {
	                var _this2 = this;
	
	                this.ConfiguracionService.borrarDestacado(id).then(function (data) {
	                    _this2.ToasterService.popUp('success', 'Articulo', 'Se ha eliminado con éxito.');
	                    _this2.$route.reload();
	                });
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	module.exports = "<br>\n<div class=\"container\">\n    <div class=\"card mb-2\">\n        <div class=\"card-block p-3\">\n            <fieldset ng-disabled=\"$ctrl.subiendoArchivo\">\n                <form name=\"formCrearSlider\" autocomplete=\"off\">\n                    <div class=\"form-group mb-0\">\n                        <div class=\"row\">\n                            <div class=\"col-12 col-lg-5\">\n                                <h2 class=\"c-celeste\">Agregar Nuevo Articulo</h2>\n                            </div>\n                            <div class=\"col-12 col-lg-7\">\n                                <div class=\"input-group input-group-lg\">\n                                    <input type=\"text\" class=\"form-control\" placeholder=\"Codigo del articulo\"\n                                           ng-model=\"$ctrl.codigoDestacado\" enter-event=\"$ctrl.agregarDestacado()\">\n                                    <div class=\"input-group-append\">\n                                        <button type=\"button\" class=\"btn btn-info btn-lg pull-right\"\n                                                ng-click=\"$ctrl.agregarDestacado()\"\n                                                ng-disabled=\"!$ctrl.codigoDestacado\">Agregar Destacado\n                                            <span class=\"fa fa-plus\" ng-show=\"!$ctrl.subiendoArchivo\"></span>\n                                            <span class=\"fa fa-spin fa-circle-o-notch\"\n                                                  ng-show=\"$ctrl.subiendoArchivo\"></span>\n                                        </button>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n            </fieldset>\n        </div>\n    </div>\n\n    <div class=\"card\">\n        <div class=\"card-block\">\n\n            <div class=\"col-12\">\n                <div class=\"row mt-3\">\n\n                    <div class=\"mb-3 col-6 col-lg-3\" ng-repeat=\"item in $ctrl.destacados track by $index\">\n                        <articulo articulo=\"item\">\n                            <div id=\"link-eliminar\">\n                                <button type=\"button\" ng-click=\"$ctrl.borrarDestacado(item._id)\"\n                                        class=\"btn btn-secondary c-rojo\">\n                                    <span class=\"fa fa-trash\"></span>\n                                </button>\n                            </div>\n                        </articulo>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<br>\n"

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OfertasComponent = exports.OfertasComponent = {
	    selector: 'editarOfertas',
	    template: __webpack_require__(65),
	    bindings: {
	        ofertas: '<',
	        categorias: '<'
	    },
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['UTIL_URL', 'Upload', 'ConfiguracionService', '$route', 'ToasterService'];
	        function controller(UTIL_URL, Upload, ConfiguracionService, $route, ToasterService) {
	            _classCallCheck(this, controller);
	
	            Object.assign(this, { UTIL_URL: UTIL_URL, Upload: Upload, ConfiguracionService: ConfiguracionService, $route: $route, ToasterService: ToasterService });
	            this.subiendoArchivo = false;
	        }
	
	        _createClass(controller, [{
	            key: '$onInit',
	            value: function $onInit() {
	                (this.ofertas || []).forEach(function (oferta) {
	                    oferta.categoria = oferta.categoria || null;
	                    oferta.subcategoria = oferta.subcategoria || null;
	                });
	            }
	        }, {
	            key: 'uploadFiles',
	            value: function uploadFiles(file, err) {
	                if (err.length === 0) this.file = file;
	            }
	        }, {
	            key: 'subirOferta',
	            value: function subirOferta() {
	                var _this = this;
	
	                if (this.file) {
	                    if (this.categoriaSeleccionada) {
	
	                        this.subiendoArchivo = true;
	                        this.Upload.upload({
	                            url: this.UTIL_URL + '/ofertas/upload',
	                            data: {
	                                categoria: this.categoriaSeleccionada.categoria,
	                                subcategoria: this.subcategoriaSeleccionada ? this.subcategoriaSeleccionada.subcategoria : '',
	                                file: this.file
	                            }
	                        }).then(function (res) {
	                            _this.ToasterService.popUp('success', 'Oferta', 'Se ha creado con éxito.');
	                            _this.$route.reload();
	                        });
	                    } else {
	                        this.ToasterService.popUp('info', 'Informacion', 'Seleccione una categoría.');
	                    }
	                } else {
	                    this.ToasterService.popUp('info', 'Informacion', 'Seleccione una imagen.');
	                }
	            }
	        }, {
	            key: 'subcategoriasDe',
	            value: function subcategoriasDe(nombreCategoria) {
	                var categoria = (this.categorias || []).find(function (item) {
	                    return item.categoria === nombreCategoria;
	                });
	                return categoria ? categoria.subcategorias : [];
	            }
	        }, {
	            key: 'cambiarCategoriaOferta',
	            value: function cambiarCategoriaOferta(oferta) {
	                oferta.subcategoria = null;
	            }
	        }, {
	            key: 'guardarDestinoOferta',
	            value: function guardarDestinoOferta(oferta) {
	                var _this2 = this;
	
	                if (!oferta.categoria) {
	                    this.ToasterService.popUp('info', 'Informacion', 'Seleccione una categoría.');
	                    return;
	                }
	                this.ConfiguracionService.actualizarOferta(oferta._id, {
	                    categoria: oferta.categoria,
	                    subcategoria: oferta.subcategoria || ''
	                }).then(function (data) {
	                    _this2.ToasterService.popUp('success', 'Oferta', 'Se ha actualizado el destino.');
	                });
	            }
	        }, {
	            key: 'borrarOferta',
	            value: function borrarOferta(id) {
	                var _this3 = this;
	
	                this.ConfiguracionService.borrarOferta(id).then(function (data) {
	                    _this3.ToasterService.popUp('success', 'Oferta', 'Se ha eliminado con éxito.');
	                    _this3.$route.reload();
	                });
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	module.exports = "<br>\n<div class=\"container p-3 p-lg-0\">\n    <div class=\"col-12\">\n    <fieldset ng-disabled=\"$ctrl.subiendoArchivo\">\n        <form name=\"formCrearOferta\" autocomplete=\"off\">\n            <div class=\"form-group\">\n                <div class=\"row drag-and-drop-zone\" ngf-drag-over-class=\"'dragover'\"\n                     ngf-drop=\"$ctrl.uploadFiles($file, $invalidFiles)\" ngf-multiple=\"false\"\n                     ngf-pattern=\"'image/*'\"\n                     accept=\"image/*\" ngf-max-size=\"5MB\"\n                     ngf-resize=\"{width: 871, height: 381, centerCrop: true}\"\n                     ngf-resize-if=\"$width > 871 || $height > 381\">\n                    <div class=\"col-12 col-lg-4\">\n\n                        <div class=\"row\">\n                            <div class=\"col-12\">\n                                <h2 class=\"c-celeste\">Agregar nueva imagen</h2>\n                                <input type=\"file\" ngf-select=\"$ctrl.uploadFiles($file, $invalidFiles)\"\n                                       ngf-multiple=\"false\"\n                                       ngf-pattern=\"'image/*'\" accept=\"image/*\" ngf-max-size=\"5MB\"\n                                       ngf-resize=\"{width: 871, height: 381, centerCrop: true}\"\n                                       ngf-resize-if=\"$width > 871 || $height > 381\">\n                            </div>\n                            <br>\n                            <div class=\"col-12 text-center mt-2\">\n                                <img ngf-src=\"$ctrl.file\" class=\"img-thumbnail img-thumbnail-height\" height=\"70px\">\n                            </div>\n                        </div>\n\n                    </div>\n                    <div class=\"col-12 col-lg-4\">\n                        <div class=\"row\">\n                            <div class=\"col-12\">\n                                <div class=\"form-group\">\n                                    <label>Categoria</label>\n                                    <select name=\"singleSelect\" class=\"form-control\"\n                                            ng-model=\"$ctrl.categoriaSeleccionada\"\n                                            ng-options=\"item.categoria for item in $ctrl.categorias\">\n                                        <option value=\"\">--Seleccionar Categoria--</option>\n                                    </select>\n                                </div>\n                            </div>\n                            <div class=\"col-12\">\n                                <div class=\"form-group\">\n                                    <label>Subcategoria</label>\n                                    <select name=\"singleSelect\" class=\"form-control\"\n                                            ng-disabled=\"!$ctrl.categoriaSeleccionada\"\n                                            ng-model=\"$ctrl.subcategoriaSeleccionada\"\n                                            ng-options=\"item.subcategoria for item in $ctrl.categoriaSeleccionada.subcategorias | orderBy: 'subcategoria'\">\n                                        <option value=\"\">--Seleccionar Subcategoria--</option>\n                                    </select>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-12 col-lg-4\" style=\"margin-top: 20px\">\n                        <button type=\"button\" class=\"btn btn-info btn-lg pull-right\"\n                                ng-click=\"$ctrl.subirOferta()\">\n                            Crear nueva OFERTA\n                            <span class=\"fa fa-plus\" ng-show=\"!$ctrl.subiendoArchivo\"></span>\n                            <span class=\"fa fa-spin fa-circle-o-notch\" ng-show=\"$ctrl.subiendoArchivo\"></span>\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </form>\n    </fieldset>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-12\">\n            <div class=\"card\">\n                <div class=\"card-block\">\n                    <div class=\"table-responsive\">\n                        <table class=\"table table-hover\">\n                            <thead>\n                                <tr>\n                                    <th>Imagen</th>\n                                    <th>Redirige a</th>\n                                    <th class=\"text-center\">\n\n                                        <span class=\"fa fa-gear\"></span>\n                                    </th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr ng-repeat=\"item in $ctrl.ofertas\">\n                                    <td><img ng-src=\"{{item.imagenUrl}}\" alt=\"\" height=\"300px\"></td>\n                                    <td style=\"min-width: 250px\">\n                                        <div class=\"form-group\">\n                                            <label>Categoria</label>\n                                            <select class=\"form-control\"\n                                                    ng-model=\"item.categoria\"\n                                                    ng-change=\"$ctrl.cambiarCategoriaOferta(item)\"\n                                                    ng-options=\"cat.categoria as cat.categoria for cat in $ctrl.categorias\">\n                                                <option value=\"\">--Seleccionar Categoria--</option>\n                                            </select>\n                                        </div>\n                                        <div class=\"form-group\">\n                                            <label>Subcategoria</label>\n                                            <select class=\"form-control\"\n                                                    ng-disabled=\"!item.categoria\"\n                                                    ng-model=\"item.subcategoria\"\n                                                    ng-options=\"sub.subcategoria as sub.subcategoria for sub in $ctrl.subcategoriasDe(item.categoria) | orderBy: 'subcategoria'\">\n                                                <option value=\"\">--Seleccionar Subcategoria--</option>\n                                            </select>\n                                        </div>\n                                        <button type=\"button\" class=\"btn btn-info\"\n                                                ng-click=\"$ctrl.guardarDestinoOferta(item)\"\n                                                ng-disabled=\"$ctrl.subiendoArchivo\">\n                                            <span class=\"fa fa-save\"></span>\n                                            Guardar destino\n                                        </button>\n                                    </td>\n                                    <td class=\"text-center\">\n                                        <button type=\"button\" class=\"btn btn-danger\"\n                                                title=\"Borrar imagen\" aria-label=\"Borrar imagen\"\n                                                ng-click=\"$ctrl.borrarOferta(item._id)\"\n                                                ng-disabled=\"$ctrl.subiendoArchivo\">\n                                            <span class=\"fa fa-trash\"></span>\n                                        </button>\n                                    </td>\n                                </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<br>\n"

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _verOrdenes = __webpack_require__(67);
	
	var _ordenes = __webpack_require__(69);
	
	var _ordenes2 = __webpack_require__(71);
	
	var _ordenes3 = _interopRequireDefault(_ordenes2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	var routesOrdenes = function routesOrdenes($routeProvider) {
	    getOrdenesPendientes.$inject = ['OrdenesService'];
	    getOrden.$inject = ['OrdenesService', '$route'];
	    $routeProvider.when('/ordenes', {
	        template: '<ordenes-list ordenes="$resolve.ordenes.data"></ordenes-list>',
	        authenticate: true,
	        administrator: true,
	        resolve: {
	            ordenes: getOrdenesPendientes
	        }
	    }).when('/ordenes/:id', {
	        template: '<ordenes-detail orden="$resolve.orden.data"></ordenes-detail>',
	        authenticate: true,
	        administrator: true,
	        resolve: {
	            orden: getOrden
	        }
	    });
	
	    function getOrden(OrdenesService, $route) {
	        return OrdenesService.getOrden($route.current.params.id);
	    }
	
	    function getOrdenesPendientes(OrdenesService) {
	        return OrdenesService.getOrdenesPendientes(20);
	    }
	};
	routesOrdenes.$inject = ['$routeProvider'];
	exports.default = _angular2.default.module('pizzuto-autopartes.ordenes', []).config(routesOrdenes).component(_ordenes.OrdenesComponent.selector, _ordenes.OrdenesComponent).component(_verOrdenes.VerOrdenesComponent.selector, _verOrdenes.VerOrdenesComponent).service('OrdenesService', _ordenes3.default).name;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var VerOrdenesComponent = exports.VerOrdenesComponent = {
	    selector: 'ordenesDetail',
	    template: __webpack_require__(68),
	    bindings: {
	        orden: '<'
	    },
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['OrdenesService', '$route', '$location'];
	        function controller(OrdenesService, $route, $location) {
	            _classCallCheck(this, controller);
	
	            Object.assign(this, { OrdenesService: OrdenesService, $route: $route, $location: $location });
	        }
	
	        _createClass(controller, [{
	            key: 'cambiarEstado',
	            value: function cambiarEstado() {
	                var _this = this;
	
	                var nuevoEstado = 'enProceso';
	                if (this.orden.estado === 'enProceso') nuevoEstado = 'finalizada';
	                this.OrdenesService.cambiarEstadoOrden(this.orden._id, { estado: nuevoEstado }).then(function () {
	                    if (nuevoEstado === 'enProceso') {
	                        _this.$route.reload();
	                    } else {
	                        _this.$location.path('/ordenes');
	                    }
	                }).catch(function (err) {
	                    return console.log(err.data.message);
	                });
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	module.exports = "<br>\n<div class=\"container\" id=\"carrito-container\">\n    <div class=\"row\">\n        <div class=\"col-12 text-center\">\n            <h2>Listado de articulos de la Orden</h2>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-12 p-lg-0\">\n            <div class=\"alert alert-info\">\n                <div class=\"row\">\n                    <div class=\"col-12\">\n                        <strong>Usuario</strong>\n                        <span class=\"text-muted\">{{$ctrl.orden.usuario.name}}</span>\n                        <span class=\"pull-right font-weight-bold\">{{$ctrl.orden.fecha | date: 'dd/MM/yyyy HH:mm'}}</span>\n                    </div>\n                </div>\n                <div class=\"row\" ng-show=\"$ctrl.orden.mensaje\">\n                    <div class=\"col-12\">\n                        Mensaje:\n                        <span class=\"text-muted\">{{$ctrl.orden.mensaje}}</span>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-12 p-lg-0\">\n            <div class=\"card\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-hover m-0\">\n                    <thead class=\"\">\n                        <tr>\n                            <th>#</th>\n                            <th>Codigo</th>\n                            <th>Articulo</th>\n                            <th>Cantidad</th>\n                            <th>Precio Unidad</th>\n                            <th>Precio Total</th>\n                        </tr>\n                    </thead>\n                    <tbody>\n                        <tr ng-repeat=\"item in $ctrl.orden.articulos\">\n                            <td>{{$index + 1}}</td>\n                            <td><a ng-href=\"/articulo/ver/{{item.articulo._id}}\">{{item.articulo.codigo}}</a></td>\n                            <td>{{item.articulo.descripcion}}</td>\n                            <td width=\"80px\" class=\"text-center\">{{item.cantidad}}</td>\n                            <td>{{item.precio | currency}}</td>\n                            <td>{{item.precio * item.cantidad | currency}}</td>\n                        </tr>\n                    </tbody>\n                    <tfoot>\n                        <tr>\n                            <td class=\"text-right\" colspan=\"7\">Monto del pedido:\n                                <span class=\"badge badge-danger\" id=\"carrito-monto-total\">{{$ctrl.orden.montoTotal | currency}}</span>\n                            </td>\n                        </tr>\n                    </tfoot>\n                </table>\n            </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"alert alert-warning\">\n        <strong>Metodo de envio:</strong> &nbsp; {{$ctrl.orden.envio.tipo}} &nbsp; - &nbsp;\n        {{$ctrl.orden.envio.mensaje}}\n    </div>\n    <div class=\"row\" ng-hide=\"$ctrl.orden.estado === 'finalizada'\">\n        <div class=\"col-12 pr-lg-0\">\n            <!--<button type=\"button\" class=\"btn btn-warning\"></button>-->\n            <button type=\"button\" class=\"btn pull-right btn-lg\"\n                    ng-class=\"{'btn-outline-info': $ctrl.orden.estado === 'pendiente', 'btn-outline-danger': $ctrl.orden.estado === 'enProceso'}\"\n                    ng-click=\"$ctrl.cambiarEstado()\">\n                {{$ctrl.orden.estado === 'pendiente' ? 'Marcar orden en proceso' : 'Marcar orden como finalizada'}}\n                <span ng-class=\"{'fa fa-arrow-right': $ctrl.orden.estado === 'pendiente', 'fa fa-list-alt': $ctrl.orden.estado === 'enProceso'}\"></span>\n            </button>\n        </div>\n    </div>\n</div>\n<br>\n"

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OrdenesComponent = exports.OrdenesComponent = {
	    selector: 'ordenesList',
	    template: __webpack_require__(70),
	    bindings: {
	        ordenes: '<'
	    },
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['OrdenesService'];
	        function controller(OrdenesService) {
	            _classCallCheck(this, controller);
	
	            this.limit = 20;
	            this.loadMoreVisible = true;
	
	            Object.assign(this, { OrdenesService: OrdenesService });
	            this.estado = 'pendiente';
	        }
	
	        _createClass(controller, [{
	            key: 'setEstado',
	            value: function setEstado(tipo) {
	                var _this = this;
	
	                if (this.estado !== tipo) {
	                    this.estado = tipo;
	
	                    this.limit = 20;
	                    this.loadMoreVisible = true;
	
	                    switch (tipo) {
	                        case 'pendiente':
	                            this.OrdenesService.getOrdenesPendientes(this.limit).then(function (ordenes) {
	                                _this.ordenes = ordenes.data;
	                                if (ordenes.data.length < _this.limit) _this.loadMoreVisible = false;
	                            });
	                            break;
	                        case 'enProceso':
	                            this.OrdenesService.getOrdenesEnProceso(this.limit).then(function (ordenes) {
	                                _this.ordenes = ordenes.data;
	                                if (ordenes.data.length < _this.limit) _this.loadMoreVisible = false;
	                            });
	                            break;
	                        case 'finalizada':
	                            this.OrdenesService.getOrdenesFinalizadas(this.limit).then(function (ordenes) {
	                                _this.ordenes = ordenes.data;
	                                if (ordenes.data.length < _this.limit) _this.loadMoreVisible = false;
	                            });
	                            break;
	                    }
	                }
	            }
	        }, {
	            key: 'cargarMas',
	            value: function cargarMas() {
	                var _this2 = this;
	
	                this.limit += 20;
	                switch (this.estado) {
	                    case 'pendiente':
	                        this.OrdenesService.getOrdenesPendientes(this.limit).then(function (ordenes) {
	                            _this2.ordenes = ordenes.data;
	                            if (ordenes.data.length < _this2.limit) _this2.loadMoreVisible = false;
	                        });
	                        break;
	                    case 'enProceso':
	                        this.OrdenesService.getOrdenesEnProceso(this.limit).then(function (ordenes) {
	                            _this2.ordenes = ordenes.data;
	                            if (ordenes.data.length < _this2.limit) _this2.loadMoreVisible = false;
	                        });
	                        break;
	                    case 'finalizada':
	                        this.OrdenesService.getOrdenesFinalizadas(this.limit).then(function (ordenes) {
	                            _this2.ordenes = ordenes.data;
	                            if (ordenes.data.length < _this2.limit) _this2.loadMoreVisible = false;
	                        });
	                        break;
	                }
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports = "<br>\n<div class=\"container\" id=\"listado-ordenes\">\n    <div class=\"row\">\n        <div class=\"col-12 text-center\">\n            <h1>Listado de Ordenes de Compra</h1>\n        </div>\n    </div>\n    <br>\n    <div class=\"row\">\n        <div class=\"col-12\">\n            <div class=\"card\">\n\n            <ul class=\"nav nav-pills nav-justified m-3\">\n                <li class=\"nav-item\">\n                    <a href=\"#\" class=\"nav-link\" ng-class=\"{'active': $ctrl.estado === 'pendiente'}\"\n                       ng-click=\"$ctrl.setEstado('pendiente')\">PENDIENTES</a>\n                </li>\n                <li class=\"nav-item\">\n                    <a href=\"#\" class=\"nav-link\" ng-class=\"{'active': $ctrl.estado === 'enProceso'}\"\n                       ng-click=\"$ctrl.setEstado('enProceso')\">EN PROCESO</a>\n                </li>\n                <li class=\"nav-item\">\n                    <a href=\"#\" class=\"nav-link\" ng-class=\"{'active': $ctrl.estado === 'finalizada'}\"\n                       ng-click=\"$ctrl.setEstado('finalizada')\">FINALIZADAS</a>\n                </li>\n            </ul>\n            <div class=\"table-responsive\">\n                <table class=\"table table-hover\">\n                    <thead class=\"\">\n                        <tr>\n                            <th>#</th>\n                            <th>Fecha</th>\n                            <th>Usuario</th>\n                            <th>Monto</th>\n                            <th>Envio</th>\n                            <th class=\"text-center\"><span class=\"fa fa-gear\"></span></th>\n                        </tr>\n                    </thead>\n                    <tbody>\n                        <tr ng-repeat=\"item in $ctrl.ordenes\">\n                            <td>{{$index + 1}}</td>\n                            <td>{{item.fecha | date: 'dd/MM/yyyy HH:mm'}}</td>\n                            <td>{{item.usuario.name}}</td>\n                            <td>{{item.montoTotal | currency}}</td>\n                            <td>{{item.envio.tipo}}</td>\n                            <td class=\"text-center\">\n                                <a ng-href=\"/ordenes/{{item._id}}\" class=\"btn btn-info btn-sm\"><span\n                                        class=\"fa fa-search\"></span></a>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n\n            </div>\n        </div>\n        </div>\n    </div>\n    <div class=\"row\" ng-if=\"$ctrl.loadMoreVisible\">\n        <div class=\"col-12\">\n            <button class=\"btn btn-outline-info btn-lg pull-right\" type=\"button\" style=\"margin-top: 20px;padding: 5px 10px;\" ng-click=\"$ctrl.cargarMas()\">\n                Cargar mas\n                <span class=\"fa fa-arrow-down\"></span>\n            </button>\n        </div>\n    </div>\n</div>\n<br>\n"

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
	
	    /*@ngInject*/
	    _class.$inject = ['$http', 'ORDENES_URL'];
	    function _class($http, ORDENES_URL) {
	        _classCallCheck(this, _class);
	
	        Object.assign(this, { $http: $http, ORDENES_URL: ORDENES_URL });
	    }
	
	    _createClass(_class, [{
	        key: 'getOrdenesPendientes',
	        value: function getOrdenesPendientes(limit) {
	            return this.$http.get(this.ORDENES_URL + '/pendientes?limit=' + limit);
	        }
	    }, {
	        key: 'getOrdenesEnProceso',
	        value: function getOrdenesEnProceso(limit) {
	            return this.$http.get(this.ORDENES_URL + '/en-proceso?limit=' + limit);
	        }
	    }, {
	        key: 'getOrdenesFinalizadas',
	        value: function getOrdenesFinalizadas(limit) {
	            return this.$http.get(this.ORDENES_URL + '/historial?limit=' + limit);
	        }
	    }, {
	        key: 'getOrden',
	        value: function getOrden(id) {
	            return this.$http.get(this.ORDENES_URL + '/' + id);
	        }
	    }, {
	        key: 'cambiarEstadoOrden',
	        value: function cambiarEstadoOrden(id, estado) {
	            return this.$http.post(this.ORDENES_URL + '/estado/' + id, estado);
	        }
	    }]);
	
	    return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _verHistorial = __webpack_require__(73);
	
	var _historial = __webpack_require__(75);
	
	var _historial2 = __webpack_require__(77);
	
	var _historial3 = _interopRequireDefault(_historial2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	var routesHistorial = function routesHistorial($routeProvider) {
	    getHistorial.$inject = ['HistorialService'];
	    getHistorialDetail.$inject = ['HistorialService', '$route'];
	    $routeProvider.when('/historial', {
	        template: '<historial-list historial="$resolve.historial.data"></historial-list>',
	        authenticate: true,
	        administrator: false,
	        resolve: {
	            historial: getHistorial
	        }
	    }).when('/historial/:id', {
	        template: '<historial-detail orden="$resolve.orden.data"></historial-detail>',
	        authenticate: true,
	        administrator: false,
	        resolve: {
	            orden: getHistorialDetail
	        }
	    });
	
	    function getHistorialDetail(HistorialService, $route) {
	        return HistorialService.getHistorialDetail($route.current.params.id);
	    }
	
	    function getHistorial(HistorialService) {
	        return HistorialService.getHistorial(20);
	    }
	};
	routesHistorial.$inject = ['$routeProvider'];
	exports.default = _angular2.default.module('pizzuto-autopartes.historial', []).config(routesHistorial).component(_historial.HistorialComponent.selector, _historial.HistorialComponent).component(_verHistorial.VerHistorialComponent.selector, _verHistorial.VerHistorialComponent).service('HistorialService', _historial3.default).name;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var VerHistorialComponent = exports.VerHistorialComponent = {
	    selector: 'historialDetail',
	    template: __webpack_require__(74),
	    bindings: {
	        orden: '<'
	    },
	    controller:
	
	    /*@ngInject*/
	    ['HistorialService', '$route', '$location', function controller(HistorialService, $route, $location) {
	        _classCallCheck(this, controller);
	
	        Object.assign(this, { HistorialService: HistorialService, $route: $route, $location: $location });
	    }]
	};

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	module.exports = "<br>\n<div class=\"container\" id=\"carrito-container\">\n    <div class=\"row\">\n        <div class=\"col-12 text-center\">\n            <h2>Listado de articulos de la Orden</h2>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-12 p-lg-0\">\n            <div class=\"alert alert-info\">\n                <div class=\"row\">\n                    <div class=\"col-12\">\n                        <strong>Usuario</strong>\n                        <span class=\"text-muted\">{{$ctrl.orden.usuario.name}}</span>\n                        <span class=\"pull-right font-weight-bold\">{{$ctrl.orden.fecha | date: 'dd/MM/yyyy HH:mm'}}</span>\n                    </div>\n                </div>\n                <div class=\"row\" ng-show=\"$ctrl.orden.mensaje\">\n                    <div class=\"col-12\">\n                        Mensaje:\n                        <span class=\"text-muted\">{{$ctrl.orden.mensaje}}</span>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-12\">\n                        <strong>Metodo de envio:</strong> &nbsp; {{$ctrl.orden.envio.tipo}} &nbsp; - &nbsp;\n                        {{$ctrl.orden.envio.mensaje}}\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-12 p-lg-0\">\n            <div class=\"card\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-hover m-0\">\n                    <thead class=\"\">\n                        <tr>\n                            <th>#</th>\n                            <th>Codigo</th>\n                            <th>Articulo</th>\n                            <th>Cantidad</th>\n                            <th>Precio Unidad</th>\n                            <th>Precio Total</th>\n                        </tr>\n                    </thead>\n                    <tbody>\n                        <tr ng-repeat=\"item in $ctrl.orden.articulos\">\n                            <td>{{$index + 1}}</td>\n                            <td><a ng-href=\"/articulo/ver/{{item.articulo._id}}\">{{item.articulo.codigo}}</a></td>\n                            <td>{{item.articulo.descripcion}}</td>\n                            <td width=\"80px\" class=\"text-center\">{{item.cantidad}}</td>\n                            <td>{{item.precio | currency}}</td>\n                            <td>{{item.precio * item.cantidad | currency}}</td>\n                        </tr>\n                    </tbody>\n                    <tfoot>\n                        <tr>\n                            <td class=\"text-right\" colspan=\"7\">Monto del pedido:\n                                <span class=\"badge badge-danger\" id=\"carrito-monto-total\">{{$ctrl.orden.montoTotal | currency}}</span>\n                            </td>\n                        </tr>\n                    </tfoot>\n                </table>\n            </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"alert alert-warning\">\n        <strong>ATENCIÓN</strong>: Todos los <strong>precios</strong> tiene un valor meramente informativo, pero pueden no ser los precios finales.\n    </div>\n</div>\n<br>\n"

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HistorialComponent = exports.HistorialComponent = {
	    selector: 'historialList',
	    template: __webpack_require__(76),
	    bindings: {
	        historial: '<'
	    },
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['HistorialService'];
	        function controller(HistorialService) {
	            _classCallCheck(this, controller);
	
	            this.limit = 20;
	            this.loadMoreVisible = true;
	
	            Object.assign(this, { HistorialService: HistorialService });
	        }
	
	        _createClass(controller, [{
	            key: 'cargarMas',
	            value: function cargarMas() {
	                var _this = this;
	
	                this.limit += 20;
	                this.HistorialService.getHistorial(this.limit).then(function (historial) {
	                    _this.historial = historial.data;
	                    if (historial.data.length < _this.limit) _this.loadMoreVisible = false;
	                });
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	module.exports = "<br>\n<div class=\"container\" id=\"listado-ordenes\">\n    <div class=\"row\">\n        <div class=\"col-12 text-center\">\n            <h1>Historial de Ordenes de Compra</h1>\n        </div>\n    </div>\n    <br>\n    <div class=\"row\">\n        <div class=\"col-12\">\n            <div class=\"alert alert-warning\">\n                <strong>ATENCIÓN</strong>: Todos los <strong>precios</strong> tiene un valor meramente informativo, pero pueden no ser los precios finales.\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-12\">\n            <div class=\"card\">\n\n            <div class=\"table-responsive\">\n                <table class=\"table table-hover\">\n                    <thead class=\"\">\n                        <tr>\n                            <th>#</th>\n                            <th>Fecha</th>\n                            <th>Usuario</th>\n                            <th>Monto</th>\n                            <th>Envio</th>\n                            <th class=\"text-center\"><span class=\"fa fa-gear\"></span></th>\n                        </tr>\n                    </thead>\n                    <tbody>\n                        <tr ng-repeat=\"item in $ctrl.historial\">\n                            <td>{{$index + 1}}</td>\n                            <td>{{item.fecha | date: 'dd/MM/yyyy HH:mm'}}</td>\n                            <td>{{item.usuario.name}}</td>\n                            <td>{{item.montoTotal | currency}}</td>\n                            <td>{{item.envio.tipo}}</td>\n                            <td class=\"text-center\">\n                                <a ng-href=\"/historial/{{item._id}}\" class=\"btn btn-info btn-sm\"><span\n                                        class=\"fa fa-search\"></span></a>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n\n            </div>\n        </div>\n        </div>\n    </div>\n    <div class=\"row\" ng-if=\"$ctrl.loadMoreVisible\">\n        <div class=\"col-12\">\n            <button class=\"btn btn-outline-info btn-lg pull-right\" type=\"button\" style=\"margin-top: 20px;padding: 5px 10px;\" ng-click=\"$ctrl.cargarMas()\">\n                Cargar mas\n                <span class=\"fa fa-arrow-down\"></span>\n            </button>\n        </div>\n    </div>\n</div>\n<br>\n"

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
	
	    /*@ngInject*/
	    _class.$inject = ['$http', 'ORDENES_URL'];
	    function _class($http, ORDENES_URL) {
	        _classCallCheck(this, _class);
	
	        Object.assign(this, { $http: $http, ORDENES_URL: ORDENES_URL });
	    }
	
	    _createClass(_class, [{
	        key: 'getHistorial',
	        value: function getHistorial(limit) {
	            return this.$http.get(this.ORDENES_URL + '/historial/me?limit=' + limit);
	        }
	    }, {
	        key: 'getHistorialDetail',
	        value: function getHistorialDetail(id) {
	            console.log('id', id);
	            return this.$http.get(this.ORDENES_URL + '/historial/me/' + id);
	        }
	    }]);
	
	    return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _categoriasRouteComponent = __webpack_require__(79);
	
	var _editarCategoria = __webpack_require__(81);
	
	var _categoriasRoute = __webpack_require__(83);
	
	var _categoriasRoute2 = _interopRequireDefault(_categoriasRoute);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ngRoute = __webpack_require__(20);
	
	/*@ngInject*/
	var routeCategoria = function routeCategoria($routeProvider) {
	    getCategorias.$inject = ['CategoriasService'];
	    getPathCategoria.$inject = ['$route'];
	    getPathSubcategoria.$inject = ['$route'];
	    $routeProvider.when('/categorias', {
	        template: '<categorias-route categorias="$resolve.categorias.data.categorias"></categorias-route>',
	        resolve: {
	            categorias: getCategorias
	        },
	        authenticate: true,
	        administrator: true
	    }).when('/categorias/editar/:categoria', {
	        template: '<editar-categoria-route categoria="$resolve.categoria"></editar-categoria-route>',
	        resolve: {
	            categoria: getPathCategoria
	        },
	        authenticate: true,
	        administrator: true
	    }).when('/categorias/editar/:categoria/:subcategoria', {
	        template: '<editar-categoria-route categoria="$resolve.categoria" subcategoria="$resolve.subcategoria"></editar-categoria-route>',
	        resolve: {
	            categoria: getPathCategoria,
	            subcategoria: getPathSubcategoria
	        },
	        authenticate: true,
	        administrator: true
	    });
	
	    function getCategorias(CategoriasService) {
	        return CategoriasService.getCategorias();
	    }
	
	    function getPathCategoria($route) {
	        return $route.current.params.categoria;
	    }
	
	    function getPathSubcategoria($route) {
	        return $route.current.params.subcategoria;
	    }
	};
	routeCategoria.$inject = ['$routeProvider'];
	
	exports.default = _angular2.default.module('pizzutoAutopartesApp.categorias', [ngRoute]).component(_categoriasRouteComponent.CategoriasRouteComponent.selector, _categoriasRouteComponent.CategoriasRouteComponent).component(_editarCategoria.EditarCategoriaRouteComponent.selector, _editarCategoria.EditarCategoriaRouteComponent).service('CategoriasService', _categoriasRoute2.default).config(routeCategoria).name;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CategoriasRouteComponent = exports.CategoriasRouteComponent = {
	
	    selector: 'categoriasRoute',
	    template: __webpack_require__(80),
	    bindings: {
	        categorias: '='
	    },
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['ToasterService', 'CategoriasService', '$location'];
	        function controller(ToasterService, CategoriasService, $location) {
	            _classCallCheck(this, controller);
	
	            this.categoriaSeleccionada = null;
	            this.subcategoriaSeleccionada = null;
	
	            Object.assign(this, { ToasterService: ToasterService, CategoriasService: CategoriasService, $location: $location });
	            this.guardandoDatos = false;
	        }
	
	        _createClass(controller, [{
	            key: 'agregarNuevaCategoria',
	            value: function agregarNuevaCategoria() {
	                if (this.nuevaCategoria) {
	                    this.categorias.push({
	                        categoria: this.nuevaCategoria.toUpperCase(),
	                        subcategorias: [],
	                        nuevoItem: true
	                    });
	                    this.ToasterService.popUp('success', 'Categoria', 'Se ha agregado la categoria. Recuerda guardar los cambios');
	                    this.nuevaCategoria = '';
	                } else {
	                    this.ToasterService.popUp('info', 'Categoria', 'Escriba el nombre de la nueva categoria.');
	                }
	            }
	        }, {
	            key: 'agregarNuevaSubcategoria',
	            value: function agregarNuevaSubcategoria() {
	                if (this.nuevaSubcategoria) {
	                    this.categoriaSeleccionada.subcategorias.push({ subcategoria: this.nuevaSubcategoria, nuevoItem: true });
	                    this.ToasterService.popUp('success', 'Subcategoria', 'Se ha agregado la subcategoria. Recuerda guardar los cambios');
	                    this.nuevaSubcategoria = '';
	                } else {
	                    this.ToasterService.popUp('info', 'Subcategoria', 'Escriba el nombre de la nueva subcategoria.');
	                }
	            }
	        }, {
	            key: 'eliminarCategoria',
	            value: function eliminarCategoria() {
	                var index = this.categorias.indexOf(this.categoriaSeleccionada);
	                if (index !== -1) {
	                    this.categorias.splice(index, 1);
	                    this.ToasterService.popUp('success', 'Categoria', 'Se ha eliminado la categoria. Recuerda guardar los cambios');
	                } else {
	                    this.ToasterService.popUp('info', 'Categoria', 'La categoria no se ha encontrado.');
	                }
	            }
	        }, {
	            key: 'eliminarSubCategoria',
	            value: function eliminarSubCategoria() {
	                var index = this.categoriaSeleccionada.subcategorias.indexOf(this.subcategoriaSeleccionada);
	                if (index !== -1) {
	                    this.categoriaSeleccionada.subcategorias.splice(index, 1);
	                    this.ToasterService.popUp('success', 'Subcategoria', 'Se ha eliminado la subcategoria. Recuerda guardar los cambios');
	                } else {
	                    this.ToasterService.popUp('info', 'Categoria', 'La subcategoria no se ha encontrado.');
	                }
	            }
	        }, {
	            key: 'guardarCambiosCategorias',
	            value: function guardarCambiosCategorias() {
	                var _this = this;
	
	                this.guardandoDatos = true;
	                this.CategoriasService.guardarCambiosCategorias({ categorias: this.categorias }).then(function (res) {
	                    _this.categorias = res.data;
	                    _this.ToasterService.popUp('success', 'Categorias', 'Los cambios se han guardado.');
	                    _this.$location.path('/');
	                }).catch(function (err) {
	                    _this.guardandoDatos = false;
	                    _this.ToasterService.popUp('error', 'Error', 'Se ha producido un error.');
	                });
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <br>\n    <div class=\"row\">\n        <div class=\"col-12 text-center\">\n            <h1>Gestion de Categorias</h1>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-12 p-lg-0\">\n            <div class=\"card\">\n                <br>\n                <div class=\"row\">\n                    <div class=\"col-8 offset-1\">\n\n                        <div class=\"form-group\">\n                            <label>Categoria</label>\n                            <select name=\"singleSelect\" class=\"form-control\" ng-model=\"$ctrl.categoriaSeleccionada\" ng-options=\"item.categoria for item in $ctrl.categorias | orderBy: 'categoria'\">\n                                <option value=\"\">--Seleccionar Categoria--</option>\n                            </select>\n                        </div>\n                        <div class=\"form-group\">\n                            <div class=\"input-group\">\n                                <input type=\"text\" class=\"form-control\" placeholder=\"Nombre de la Nueva categoria\" ng-model=\"$ctrl.nuevaCategoria\" capitalize>\n                                <div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-outline-info\" ng-disabled=\"!$ctrl.nuevaCategoria\" ng-click=\"$ctrl.agregarNuevaCategoria()\"><span class=\"fa fa-plus\"></span></button></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-2\">\n                        <div class=\"form-group\">\n                            <label>&nbsp;&nbsp;</label><br>\n                            <!--<button type=\"button\" class=\"btn btn-outline-info\">-->\n                                <!--<span class=\"fa fa-plus\"></span>-->\n                            <!--</button>-->\n                            <a ng-href=\"/categorias/editar/{{$ctrl.categoriaSeleccionada.categoria}}\" class=\"btn btn-outline-info\" ng-class=\"{disabled: !$ctrl.categoriaSeleccionada || $ctrl.categoriaSeleccionada.nuevoItem}\">\n                                <span class=\"fa fa-edit\"></span>\n                            </a>\n                            <button ng-click=\"$ctrl.eliminarCategoria()\" class=\"btn btn-outline-danger\" ng-class=\"{disabled: !$ctrl.categoriaSeleccionada || $ctrl.categoriaSeleccionada.nuevoItem}\">\n                                <span class=\"fa fa-trash-o\"></span>\n                            </button>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-8 offset-1\">\n                        <div class=\"form-group\">\n                            <label>Subcategoria</label>\n                            <select name=\"singleSelect\" class=\"form-control\" ng-disabled=\"!$ctrl.categoriaSeleccionada\" ng-model=\"$ctrl.subcategoriaSeleccionada\" ng-options=\"item.subcategoria for item in $ctrl.categoriaSeleccionada.subcategorias | orderBy: 'subcategoria'\">\n                                <option value=\"\">--Seleccionar Subcategoria--</option>\n                            </select>\n                        </div>\n                        <div class=\"form-group\">\n                            <div class=\"input-group\">\n                            <input type=\"text\" class=\"form-control\" placeholder=\"Nombre de la Nueva subcategoria\" ng-model=\"$ctrl.nuevaSubcategoria\" ng-disabled=\"!$ctrl.categoriaSeleccionada\" capitalize>\n                                <div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-outline-info\" ng-disabled=\"!$ctrl.categoriaSeleccionada || !$ctrl.nuevaSubcategoria\" ng-click=\"$ctrl.agregarNuevaSubcategoria()\"><span class=\"fa fa-plus\"></span></button></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-2\">\n                        <div class=\"form-group\">\n                            <label>&nbsp;&nbsp;</label><br>\n                            <!--<button type=\"button\" class=\"btn btn-outline-info\">-->\n                                <!--<span class=\"fa fa-plus\"></span>-->\n                            <!--</button>-->\n                            <a ng-href=\"/categorias/editar/{{$ctrl.categoriaSeleccionada.categoria}}/{{$ctrl.subcategoriaSeleccionada.subcategoria}}\" class=\"btn btn-outline-info\" ng-class=\"{'disabled': !$ctrl.subcategoriaSeleccionada || $ctrl.subcategoriaSeleccionada.nuevoItem}\">\n                                <span class=\"fa fa-edit\"></span>\n                            </a>\n                            <button  ng-click=\"$ctrl.eliminarSubCategoria()\"  class=\"btn btn-outline-danger\" ng-class=\"{'disabled': !$ctrl.subcategoriaSeleccionada || $ctrl.subcategoriaSeleccionada.nuevoItem}\">\n                                <span class=\"fa fa-trash-o\"></span>\n                            </button>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-6 offset-3\">\n                        <button class=\"btn btn-block btn-outline-info text-center\" ng-click=\"$ctrl.guardarCambiosCategorias()\" ng-disabled=\"$ctrl.guardandoDatos\">Guardar Cambios\n                            <span class=\"fa fa-save\" ng-show=\"!$ctrl.guardandoDatos\"></span>\n                            <span class=\"fa fa-spin fa-circle-o-notch\" ng-show=\"$ctrl.guardandoDatos\"></span>\n                        </button>\n                    </div>\n                </div>\n                <br>\n            </div>\n        </div>\n    </div>\n    <br>\n</div>\n"

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditarCategoriaRouteComponent = exports.EditarCategoriaRouteComponent = {
	    selector: 'editarCategoriaRoute',
	    template: __webpack_require__(82),
	    bindings: {
	        categoria: '<',
	        subcategoria: '<'
	    },
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['CategoriasService', '$location', 'ToasterService'];
	        function controller(CategoriasService, $location, ToasterService) {
	            _classCallCheck(this, controller);
	
	            this.editandoSubcategoria = false;
	
	            Object.assign(this, { CategoriasService: CategoriasService, $location: $location, ToasterService: ToasterService });
	            this.guardandoDatos = false;
	        }
	
	        _createClass(controller, [{
	            key: '$onInit',
	            value: function $onInit() {
	                if (this.subcategoria) {
	                    this.editandoSubcategoria = true;
	                }
	            }
	        }, {
	            key: 'cambiarNombreCategoria',
	            value: function cambiarNombreCategoria() {
	                var _this = this;
	
	                if (!this.editandoSubcategoria) {
	                    if (this.nuevaCategoria) {
	                        this.guardandoDatos = true;
	                        this.CategoriasService.cambiarNombreCategoria(this.categoria, this.nuevaCategoria).then(function (res) {
	                            _this.ToasterService.popUp('success', 'Categoria', 'Se ha cambiado el nombre con exito.');
	                            _this.$location.path('/');
	                        }).catch(function (err) {
	                            _this.guardandoDatos = false;
	                            _this.ToasterService.popUp('error', 'Error', 'Se ha producido un error.');
	                        });
	                    } else {
	                        this.ToasterService.popUp('info', 'Categoria', 'Escriba el nuevo nombre de la categoria.');
	                    }
	                } else {
	                    if (this.nuevaSubcategoria) {
	                        this.guardandoDatos = true;
	                        this.CategoriasService.cambiarNombreSubcategoria(this.categoria, this.subcategoria, this.nuevaSubcategoria).then(function (res) {
	                            _this.ToasterService.popUp('success', 'Subcategoria', 'Se ha cambiado el nombre con exito.');
	                            _this.$location.path('/');
	                        }).catch(function (err) {
	                            _this.guardandoDatos = false;
	                            _this.ToasterService.popUp('error', 'Error', 'Se ha producido un error.');
	                        });
	                    } else {
	                        this.ToasterService.popUp('info', 'Categoria', 'Escriba el nuevo nombre de la categoria.');
	                    }
	                }
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <br>\n    <div class=\"row\">\n        <div class=\"col-12 text-center\">\n            <h1>Gestion de nombre de Categorias</h1>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-12 p-lg-0\">\n            <div class=\"card\">\n                <br>\n                <div class=\"row\">\n                    <div class=\"col-10 offset-1\">\n\n                        <div class=\"form-group\">\n                            <label>Categoria</label>\n                            <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.categoria\" disabled>\n                        </div>\n                        <div class=\"form-group\" ng-if=\"!$ctrl.editandoSubcategoria\">\n                                <input type=\"text\" class=\"form-control\" placeholder=\"Nuevo nombre de la categoria\" ng-model=\"$ctrl.nuevaCategoria\" capitalize>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\" ng-show=\"$ctrl.editandoSubcategoria\">\n                    <div class=\"col-10 offset-1\">\n\n                        <div class=\"form-group\">\n                            <label>Subcategoria</label>\n                            <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.subcategoria\" disabled>\n                        </div>\n                        <div class=\"form-group\">\n                            <input type=\"text\" class=\"form-control\" placeholder=\"Nuevo nombre de la subcategoria\" ng-model=\"$ctrl.nuevaSubcategoria\" capitalize>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-10 offset-1 text-center\">\n                        <button class=\"btn btn-outline-info text-center btn-guardar-cambios\" ng-click=\"$ctrl.cambiarNombreCategoria()\" ng-disabled=\"$ctrl.guardandoDatos\">Guardar Cambios\n                            <span class=\"fa fa-save\" ng-show=\"!$ctrl.guardandoDatos\"></span>\n                            <span class=\"fa fa-spin fa-circle-o-notch\" ng-show=\"$ctrl.guardandoDatos\"></span>\n                        </button>\n                    </div>\n                </div>\n                <br>\n            </div>\n        </div>\n    </div>\n    <br>\n</div>\n"

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CategoriasService = function () {
	
	    /*@ngInject*/
	    CategoriasService.$inject = ['$http', 'CATEGORIAS_URL'];
	    function CategoriasService($http, CATEGORIAS_URL) {
	        _classCallCheck(this, CategoriasService);
	
	        Object.assign(this, { $http: $http, CATEGORIAS_URL: CATEGORIAS_URL });
	    }
	
	    _createClass(CategoriasService, [{
	        key: 'getCategorias',
	        value: function getCategorias() {
	            return this.$http.get(this.CATEGORIAS_URL);
	        }
	    }, {
	        key: 'guardarCambiosCategorias',
	        value: function guardarCambiosCategorias(categorias) {
	            return this.$http.put(this.CATEGORIAS_URL, categorias);
	        }
	    }, {
	        key: 'cambiarNombreCategoria',
	        value: function cambiarNombreCategoria(oldCat, newCat) {
	            return this.$http.put(this.CATEGORIAS_URL + '/categoria', { oldCategoria: oldCat, newCategoria: newCat });
	        }
	    }, {
	        key: 'cambiarNombreSubcategoria',
	        value: function cambiarNombreSubcategoria(cat, oldSubcat, newSubcat) {
	            return this.$http.put(this.CATEGORIAS_URL + '/subcategoria', { categoria: cat, oldSubcategoria: oldSubcat, newSubcategoria: newSubcat });
	        }
	    }]);
	
	    return CategoriasService;
	}();
	
	exports.default = CategoriasService;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _mainRouteComponent = __webpack_require__(85);
	
	var _mainRouteService = __webpack_require__(87);
	
	var _mainRouteService2 = _interopRequireDefault(_mainRouteService);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularRoute = __webpack_require__(20);
	
	var _angularRoute2 = _interopRequireDefault(_angularRoute);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	var rutes = function routes($routeProvider) {
	    getUtilData.$inject = ['MainService'];
	    $routeProvider.when('/', {
	        template: '<main-route util-data="$resolve.utilData.data"></main-route>',
	        resolve: {
	            utilData: getUtilData
	        }
	    });
	
	    function getUtilData(MainService) {
	        return MainService.getUtilData();
	    }
	};
	rutes.$inject = ['$routeProvider'];
	
	exports.default = _angular2.default.module('pizzutoAutopartesApp.main', [_angularRoute2.default]).config(rutes).service('MainService', _mainRouteService2.default).component(_mainRouteComponent.MainRouteComponent.selector, _mainRouteComponent.MainRouteComponent).name;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MainRouteComponent = exports.MainRouteComponent = {
	
	    selector: 'mainRoute',
	    template: __webpack_require__(86),
	    bindings: {
	        utilData: '<'
	    },
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['$http', 'MainService', 'Auth', 'ArticuloService', '$location', 'ToasterService'];
	        function controller($http, MainService, Auth, ArticuloService, $location, ToasterService) {
	            _classCallCheck(this, controller);
	
	            Object.assign(this, { $http: $http, MainService: MainService, ArticuloService: ArticuloService, $location: $location, ToasterService: ToasterService });
	
	            this.slides = [];
	            this.listadoCategorias = [];
	            this.listadoPromociones = [];
	            this.slides = [];
	        }
	
	        _createClass(controller, [{
	            key: '$onInit',
	            value: function $onInit() {
	                var data = this.utilData;
	                this.listadoCategorias = data.categorias;
	                this.slides = data.slides;
	                this.listadoPromociones = data.ofertas;
	                this.listadoArticulosDestacados = data.destacados;
	            }
	        }, {
	            key: 'buscarPorCodigo',
	            value: function buscarPorCodigo() {
	                if (this.inputBuscarPorCodigo) {
	                    this.$location.path('/articulo/codigo/' + this.inputBuscarPorCodigo.toUpperCase());
	                }
	            }
	        }, {
	            key: 'buscarPorPalabraClave',
	            value: function buscarPorPalabraClave() {
	                if (this.inputBuscarPorPalabraClave) {
	                    var aux = this.inputBuscarPorPalabraClave.replace(/\//g, '%2F');
	                    this.$location.path('/articulo/palabra-clave/' + aux.toUpperCase());
	                }
	            }
	        }, {
	            key: 'buscarPorCategoria',
	            value: function buscarPorCategoria() {
	                this.$location.path('/articulo/categoria/' + this.categoriaSeleccionada.categoria.toUpperCase() + '/' + this.subcategoriaSeleccionada.subcategoria.toUpperCase());
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	module.exports = "<br>\n<div class=\"container\">\n    <div class=\"row\">\n        <div class=\"col-12 col-lg-4 pl-4 pr-4\">\n            <div class=\"row\">\n                <div class=\"col-12 text-center p-0\">\n                    <div class=\"alert alert-info text-uppercase\">\n                        <strong>Buscar producto</strong>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-12 p-0\">\n                    <div class=\"input-group\">\n                        <input type=\"text\" class=\"form-control\" placeholder=\"Buscar por codigo\" ng-model=\"$ctrl.inputBuscarPorCodigo\" enter-event=\"$ctrl.buscarPorCodigo()\">\n                        <div class=\"input-group-btn\">\n                            <button type=\"button\" class=\"btn btn-secondary bg-celeste\" ng-click=\"$ctrl.buscarPorCodigo()\">\n                                <span class=\"fa fa-search\"></span>\n                            </button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <hr>\n            <div class=\"row\">\n                <div class=\"col-12 p-0\">\n                    <div class=\"input-group\">\n                        <input type=\"text\" class=\"form-control\" placeholder=\"Buscar por palabra clave\" ng-model=\"$ctrl.inputBuscarPorPalabraClave\" enter-event=\"$ctrl.buscarPorPalabraClave()\">\n                        <div class=\"input-group-btn\">\n                            <button type=\"button\" class=\"btn btn-secondary bg-celeste\" ng-click=\"$ctrl.buscarPorPalabraClave()\">\n                                <span class=\"fa fa-search\"></span>\n                            </button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <br>\n            <div class=\"row\">\n                <div class=\"col-12 p-0 text-center text-uppercase\">\n                    <div class=\"alert alert-info\">\n                        <link-editar link=\"/categorias\"></link-editar>\n                        <strong>Buscar por categoria</strong>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-12 p-0\">\n                    <select name=\"singleSelect\" class=\"form-control\" ng-model=\"$ctrl.categoriaSeleccionada\" ng-options=\"item.categoria for item in $ctrl.listadoCategorias | orderBy: 'categoria'\">\n                        <option value=\"\">--Seleccionar Categoria--</option>\n                    </select><br>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-12 p-0\">\n                    <select name=\"singleSelect\" class=\"form-control\" ng-disabled=\"!$ctrl.categoriaSeleccionada\" ng-model=\"$ctrl.subcategoriaSeleccionada\" ng-change=\"$ctrl.buscarPorCategoria()\" ng-options=\"item.subcategoria for item in $ctrl.categoriaSeleccionada.subcategorias | orderBy: 'subcategoria'\">\n                        <option value=\"\">--Seleccionar Subcategoria--</option>\n                        <!--<option value=\"{{item.subcategoria}}\" ng-repeat=\"item in $ctrl.categoriaSeleccionada.subcategorias | orderBy: 'subcategoria'\">{{item.subcategoria}}</option>-->\n                    </select><br>\n                </div>\n            </div>\n        </div>\n        <!-- END col-4 -->\n\n\n        <div class=\"col-12 col-lg-8\">\n            <div class=\"card p-2\" id=\"card-slider\">\n                <link-editar link=\"/configuracion/slider\"></link-editar>\n                <carousel slides=\"$ctrl.slides\"></carousel>\n            </div>\n        </div>\n    </div>\n    <br>\n    <div class=\"row\">\n        <div class=\"col-12 col-lg-4\">\n            <div class=\"row\">\n                <div class=\"col-12 p-0\">\n                    <link-editar link=\"/configuracion/ofertas\"></link-editar>\n                    <div class=\"bg-rojo c-blanco p-2 text-center text-uppercase row-destacados\">\n                        <strong class=\"\">Nuestras Ofertas</strong>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row mt-3\" ng-if=\"$ctrl.listadoPromociones.length === 0\">\n                <span class=\"alert alert-info text-center w-100\">No hay ofertas al momento</span>\n            </div>\n            <div class=\"row mt-3\" ng-repeat=\"item in $ctrl.listadoPromociones\">\n                <div class=\"col-12 \">\n                    <figure class=\"text-center\">\n                        <a ng-href=\"/articulo/categoria/{{item.categoria.toUpperCase()}}/{{item.subcategoria ? item.subcategoria.toUpperCase() : ''}}\"><img class=\"img-fluid img-oferta\" ng-src=\"{{item.imagenUrl}}\"></a>\n                    </figure>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-12 col-lg-8\">\n            <div class=\"row\">\n                <div class=\"col-12 p-0\">\n                    <link-editar link=\"/configuracion/destacados\"></link-editar>\n                    <div class=\"bg-celeste c-blanco p-2 text-center text-uppercase row-destacados\">\n                        <strong>Productos destacados</strong>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"row mt-3\">\n                <div class=\"col-12\">\n                    <articulo-list articulos=\"$ctrl.listadoArticulosDestacados\" columna=\"col-sm-12 col-md-4 col-lg-4 col-xl-4\"></articulo-list>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MainService = function () {
	
	    /*@ngInject*/
	    MainService.$inject = ['$http', 'UTIL_URL'];
	    function MainService($http, UTIL_URL) {
	        _classCallCheck(this, MainService);
	
	        Object.assign(this, { $http: $http, UTIL_URL: UTIL_URL });
	    }
	
	    _createClass(MainService, [{
	        key: 'getUtilData',
	        value: function getUtilData() {
	            return this.$http.get(this.UTIL_URL);
	        }
	    }]);
	
	    return MainService;
	}();
	
	exports.default = MainService;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	addInterceptor.$inject = ['$httpProvider'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _app = __webpack_require__(89);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _util = __webpack_require__(91);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _angularCookies = __webpack_require__(3);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _interceptor = __webpack_require__(96);
	
	var _router = __webpack_require__(97);
	
	var _auth = __webpack_require__(98);
	
	var _user = __webpack_require__(99);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ngRoute = __webpack_require__(20);
	
	function addInterceptor($httpProvider) {
	    'ngInject';
	
	    $httpProvider.interceptors.push('authInterceptor');
	}
	
	exports.default = _angular2.default.module('pizzutoAutopartesApp.auth', [_app2.default, _util2.default, _angularCookies2.default, ngRoute]).factory('authInterceptor', _interceptor.authInterceptor).run(_router.routerDecorator).factory('Auth', _auth.AuthService).factory('User', _user.UserResource).config(['$httpProvider', addInterceptor]).name;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('pizzutoAutopartesApp.constants', []).constant('appConfig', __webpack_require__(90)).constant('ARTICULOS_URL', '/api/articulos').constant('ORDENES_URL', '/api/ordenes').constant('USUARIOS_URL', '/api/users').constant('ARTICULO_CATEGORIA_URL', '/api/articulos/categoria').constant('CATEGORIAS_URL', '/api/utils/categorias').constant('IMAGE_UPLOAD_URL', '/api/articulos/images/upload').constant('FILE_UPLOAD_URL', '/api/descargas/file/upload').constant('QR_UPLOAD_URL', '/api/descargas/qr/upload').constant('UTIL_URL', '/api/utils').constant('DESCARGAS_URL', '/api/descargas').name;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	'use strict';
	
	exports = module.exports = {
	    // List of user roles
	    userRoles: ['guest', 'user', 'admin'],
	    cloudinary: {
	        cloud_name: 'dcjcodcql',
	        api_key: '128428673699392',
	        api_secret: 'vCuyovufE4pdI4iZHt2NHhKrWyQ'
	    },
	    // cloudinary: { //cuenta de martin (mia)
	    //     cloud_name: 'dezsjisey',
	    //     api_key: '548859556433139',
	    //     api_secret: '5Pr-Jh7aXCdTGrgjQEWV81dPkwQ'
	    // },
	    sendGridApi: {
	        KEY: 'YJQ5jVjMRFSJUBMYWg_t5g',
	        SECRET: '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'
	    }
	};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _util = __webpack_require__(92);
	
	var _enterEvent = __webpack_require__(93);
	
	var _textUppercase = __webpack_require__(94);
	
	var _toaster = __webpack_require__(95);
	
	var _toaster2 = _interopRequireDefault(_toaster);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('pizzutoAutopartesApp.util', []).factory('Util', _util.UtilService).factory('ToasterService', _toaster2.default).directive('enterEvent', _enterEvent.EnterEventDirective).directive('capitalize', _textUppercase.CapitalizeDirective).name;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	UtilService.$inject = ['$window'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UtilService = UtilService;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	function UtilService($window) {
	
	    var Util = {
	        safeCb: function safeCb(cb) {
	            return _angular2.default.isFunction(cb) ? cb : _angular2.default.noop;
	        },
	        urlParse: function urlParse(url) {
	            var a = document.createElement('a');
	            a.href = url;
	
	            if (a.host === '') {
	                a.href = a.href;
	            }
	
	            return a;
	        },
	        isSameOrigin: function isSameOrigin(url, origins) {
	            url = Util.urlParse(url);
	            origins = origins && [].concat(origins) || [];
	            origins = origins.map(Util.urlParse);
	            origins.push($window.location);
	            origins = origins.filter(function (o) {
	                var hostnameCheck = url.hostname === o.hostname;
	                var protocolCheck = url.protocol === o.protocol;
	
	                var portCheck = url.port === o.port || o.port === '' && (url.port === '80' || url.port === '443');
	                return hostnameCheck && protocolCheck && portCheck;
	            });
	            return origins.length >= 1;
	        }
	    };
	
	    return Util;
	}

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EnterEventDirective = EnterEventDirective;
	function EnterEventDirective() {
	    return {
	        restrict: 'A',
	        link: link
	    };
	
	    function link(scope, elem, attrs) {
	        elem.bind('keydown keypress', function (event) {
	            if (event.which == 13) {
	                scope.$apply(function () {
	                    scope.$eval(attrs.enterEvent);
	                });
	                event.preventDefault();
	            }
	        });
	    }
	}

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CapitalizeDirective = CapitalizeDirective;
	function CapitalizeDirective() {
	    return {
	        require: 'ngModel',
	        link: link
	    };
	
	    function link(scope, element, attrs, modelCtrl) {
	        var capitalize = function capitalize(inputValue) {
	            if (inputValue == undefined) inputValue = '';
	            var capitalized = inputValue.toUpperCase();
	            if (capitalized !== inputValue) {
	                modelCtrl.$setViewValue(capitalized);
	                modelCtrl.$render();
	            }
	            return capitalized;
	        };
	        modelCtrl.$parsers.push(capitalize);
	        capitalize(scope[attrs.ngModel]);
	    }
	}

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ['toaster', function (toaster) {
	    'ngInject';
	
	    return {
	        popUp: function popUp(type, title, body) {
	            toaster.clear();
	            toaster.pop({
	                type: type,
	                title: title,
	                body: body
	            });
	        },
	        error: function error() {
	            toaster.clear();
	            toaster.pop({
	                type: 'error',
	                title: 'Error',
	                body: 'Se ha producido un error en el servidor.'
	            });
	        }
	    };
	}];

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	'use strict';
	
	authInterceptor.$inject = ['$rootScope', '$q', '$cookies', '$location', 'Util'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.authInterceptor = authInterceptor;
	function authInterceptor($rootScope, $q, $cookies, $location, Util) {
	    'ngInject';
	
	    return {
	        request: function request(config) {
	            config.headers = config.headers || {};
	            if ($cookies.get('token') && Util.isSameOrigin(config.url)) {
	                config.headers.Authorization = 'Bearer ' + $cookies.get('token');
	            }
	            return config;
	        },
	        responseError: function responseError(response) {
	            if (response.status === 401) {
	                $location.path('/login');
	
	                $cookies.remove('token');
	            }
	            return $q.reject(response);
	        }
	    };
	}

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	'use strict';
	
	routerDecorator.$inject = ['$rootScope', '$location', 'Auth'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.routerDecorator = routerDecorator;
	function routerDecorator($rootScope, $location, Auth) {
	    'ngInject';
	
	    $rootScope.$on('$routeChangeStart', function (event, next) {
	        if (!next.authenticate) {
	            return;
	        }
	
	        if (typeof next.authenticate === 'string') {
	            Auth.hasRole(next.authenticate).then(function (has) {
	                if (has) {
	                    return;
	                }
	
	                event.preventDefault();
	                return Auth.isLoggedIn().then(function (is) {
	                    $location.path(is ? '/' : '/login');
	                });
	            });
	        } else {
	            Auth.isLoggedIn().then(function (is) {
	                if (is) {
	                    return;
	                }
	
	                event.preventDefault();
	                $location.path('/login');
	            });
	        }
	    });
	}

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	'use strict';
	
	AuthService.$inject = ['$location', '$http', '$cookies', '$q', 'appConfig', 'Util', 'User'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AuthService = AuthService;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _User = function _User() {
	    _classCallCheck(this, _User);
	
	    this._id = '';
	    this.name = '';
	    this.email = '';
	    this.role = '';
	    this.$promise = undefined;
	};
	
	/*@ngInject*/
	
	
	function AuthService($location, $http, $cookies, $q, appConfig, Util, User) {
	    var safeCb = Util.safeCb;
	    var currentUser = new _User();
	    var userRoles = appConfig.userRoles || [];
	
	    var _hasRole = function _hasRole(userRole, role) {
	        return userRoles.indexOf(userRole) >= userRoles.indexOf(role);
	    };
	
	    if ($cookies.get('token') && $location.path() !== '/logout') {
	        currentUser = User.get();
	    }
	
	    var Auth = {
	        login: function login(_ref, callback) {
	            var email = _ref.email,
	                password = _ref.password;
	
	            return $http.post('/auth/local', {
	                email: email,
	                password: password
	            }).then(function (res) {
	                var expires = new Date();
	                expires.setTime(expires.getTime() + 31556952000);
	                $cookies.put('token', res.data.token, { expires: expires });
	                currentUser = User.get();
	                return currentUser.$promise;
	            }).then(function (user) {
	                safeCb(callback)(null, user);
	                return user;
	            }).catch(function (err) {
	                Auth.logout();
	                safeCb(callback)(err.data);
	                return $q.reject(err.data);
	            });
	        },
	        logout: function logout() {
	            $cookies.remove('token');
	            currentUser = new _User();
	        },
	        createUser: function createUser(user, callback) {
	            return User.save(user, function (data) {
	                var expires = new Date();
	                expires.setTime(expires.getTime() + 31556952000);
	                $cookies.put('token', data.token, { expires: expires });
	                currentUser = User.get();
	                return safeCb(callback)(null, user);
	            }, function (err) {
	                Auth.logout();
	                return safeCb(callback)(err);
	            }).$promise;
	        },
	        changePassword: function changePassword(oldPassword, newPassword, callback) {
	            return User.changePassword({
	                id: currentUser._id
	            }, {
	                oldPassword: oldPassword,
	                newPassword: newPassword
	            }, function () {
	                return safeCb(callback)(null);
	            }, function (err) {
	                return safeCb(callback)(err);
	            }).$promise;
	        },
	        getCurrentUser: function getCurrentUser(callback) {
	            var value = _.get(currentUser, '$promise') ? currentUser.$promise : currentUser;
	
	            return $q.when(value).then(function (user) {
	                safeCb(callback)(user);
	                return user;
	            }, function () {
	                safeCb(callback)({});
	                return {};
	            });
	        },
	        getCurrentUserSync: function getCurrentUserSync() {
	            return currentUser;
	        },
	        isLoggedIn: function isLoggedIn(callback) {
	            return Auth.getCurrentUser(undefined).then(function (user) {
	                var is = _.get(user, 'role');
	
	                safeCb(callback)(is);
	                return is;
	            });
	        },
	        isLoggedInSync: function isLoggedInSync() {
	            return !!_.get(currentUser, 'role');
	        },
	        hasRole: function hasRole(role, callback) {
	            return Auth.getCurrentUser(undefined).then(function (user) {
	                var has = _hasRole(_.get(user, 'role'), role);
	
	                callback(has);
	                return has;
	            });
	        },
	        hasRoleSync: function hasRoleSync(role) {
	            return _hasRole(_.get(currentUser, 'role'), role);
	        },
	        isAdmin: function isAdmin() {
	            return Auth.hasRole.apply(Auth, _toConsumableArray([].concat.apply(['admin'], arguments)));
	        },
	        isAdminSync: function isAdminSync() {
	            return Auth.hasRoleSync('admin');
	        },
	        getToken: function getToken() {
	            return $cookies.get('token');
	        }
	    };
	
	    return Auth;
	}

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	'use strict';
	
	UserResource.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UserResource = UserResource;
	function UserResource($resource) {
	    'ngInject';
	
	    return $resource('/api/users/:id/:controller', {
	        id: '@_id'
	    }, {
	        changePassword: {
	            method: 'PUT',
	            params: {
	                controller: 'password'
	            }
	        },
	        get: {
	            method: 'GET',
	            params: {
	                id: 'me'
	            }
	        }
	    });
	}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NavbarComponent = undefined;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavbarComponent = exports.NavbarComponent = ['Auth', function NavbarComponent(Auth) {
	    'ngInject';
	
	    _classCallCheck(this, NavbarComponent);
	
	    this.isLoggedIn = Auth.isLoggedInSync;
	    this.getCurrentUser = Auth.getCurrentUserSync;
	}];
	
	exports.default = _angular2.default.module('directives.navbar', []).component('navbar', {
	    template: __webpack_require__(101),
	    controller: NavbarComponent
	}).name;

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	module.exports = "<nav class=\"navbar navbar-expand navbar-inverse bg-celeste\">\n    <!--<a href=\"/\" class=\"navbar-brand\">Inicio</a>-->\n    <div class=\"container\">\n        <div class=\"collapse navbar-collapse\">\n            <div class=\"navbar-text mr-5 text-uppercase navbar-usuario\" style=\"opacity: 0.9\">Bienvenido</div><!--mr-auto-->\n\n            <div class=\"navbar-text ml-5 mr-auto\">\n\n            </div>\n\n            <!--<div class=\"navbar-text\">|</div>-->\n\n            <div class=\"navbar-text pt-0 pb-0\">\n                <a href=\"/settings\" class=\"navbar-usuario mr-3\" ng-show=\"$ctrl.isLoggedIn()\">{{$ctrl.getCurrentUser().name}}\n                    <span class=\"fa fa-user fa-2x\"></span>\n                </a>\n                <a href=\"/logout\" class=\"navbar-usuario\" ng-show=\"$ctrl.isLoggedIn()\">Salir\n                    <span class=\"fa fa-power-off fa-2x\"></span>\n                </a>\n                <a href=\"/login\" class=\"navbar-usuario\" ng-show=\"!$ctrl.isLoggedIn()\">Login\n                    <span class=\"fa fa-user fa-2x\"></span>\n                </a>\n            </div>\n        </div>\n    </div>\n</nav>\n"

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MainHeaderComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MainHeaderComponent = exports.MainHeaderComponent = function () {
	
	    /*@ngInject*/
	    MainHeaderComponent.$inject = ['Auth', '$location'];
	    function MainHeaderComponent(Auth, $location) {
	        _classCallCheck(this, MainHeaderComponent);
	
	        this.Auth = Auth;
	        this.isLoggedInSync = Auth.isLoggedInSync;
	        this.isAdminSync = Auth.isAdminSync;
	        this.$location = $location;
	        this.user = Auth.getCurrentUserSync;
	    }
	
	    _createClass(MainHeaderComponent, [{
	        key: 'isActive',
	        value: function isActive(route) {
	            return route === this.$location.path();
	        }
	    }]);
	
	    return MainHeaderComponent;
	}();
	
	exports.default = _angular2.default.module('directives.main-header', []).component('mainHeader', {
	    template: __webpack_require__(103),
	    controller: MainHeaderComponent
	}).name;

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\" id=\"main-header\">\n    <div class=\"row mt-2\">\n        <div class=\"col-8 col-lg-4 pl-0\">\n            <a href=\"/\">\n                <img src=\"../../assets/images/logo.png\" class=\"main-logo\" alt=\"pizzuto autopartes\" width=\"300\">\n            </a>\n        </div>\n        <div class=\"col-4 col-lg-2\" ng-if=\"$ctrl.isAdminSync()\">\n            <div class=\"text-center icon-header mt-1 pull-right\" ng-show=\"$ctrl.isLoggedInSync() && $ctrl.isAdminSync() && $ctrl.isActive('/descargas')\">\n                <a href=\"/descargas/crear\">\n                    <figure class=\"mb-0\">\n                        <img ng-src=\"../../assets/images/nueva-descarga.svg\" alt=\"\" style=\"padding-top: 15px\">\n                        <figcaption><strong>CREAR</strong></figcaption>\n                    </figure>\n                </a>\n            </div>\n            <div class=\"text-center icon-header mt-1 pull-right\" ng-show=\"$ctrl.isLoggedInSync() && $ctrl.isAdminSync() && $ctrl.isActive('/usuarios')\">\n                <a href=\"/usuarios/crear\">\n                    <figure class=\"mb-0\">\n                        <img ng-src=\"../../assets/images/nuevo-user.svg\" alt=\"\">\n                        <figcaption><strong>CREAR</strong></figcaption>\n                    </figure>\n                </a>\n            </div>\n            <div class=\"text-center icon-header mt-1 pull-right\" ng-show=\"$ctrl.isLoggedInSync() && $ctrl.isAdminSync() && $ctrl.isActive('/articulo/actualizar')\">\n                <a href=\"/articulo/crear\">\n                    <figure class=\"mb-0\">\n                        <img ng-src=\"../../assets/images/nuevo-articulo.svg\" alt=\"\">\n                        <figcaption><strong>CREAR</strong></figcaption>\n                    </figure>\n                </a>\n            </div>\n        </div>\n        <div class=\"col-4 col-lg-2\" ng-if=\"$ctrl.isAdminSync()\">\n            <div class=\"text-center icon-header mt-2 pull-right\" ng-show=\"$ctrl.isLoggedInSync() && $ctrl.isAdminSync()\">\n                <a href=\"/articulo/actualizar\">\n                    <figure>\n                        <img ng-src=\"../../assets/images/articulos.svg\" alt=\"\">\n                        <figcaption><strong>ARTICULOS</strong></figcaption>\n                    </figure>\n                </a>\n            </div>\n        </div>\n        <div class=\"col-4 col-lg-2\" ng-if=\"$ctrl.isAdminSync()\">\n            <div class=\"text-center icon-header mt-2 pull-right\" ng-show=\"$ctrl.isLoggedInSync() && $ctrl.isAdminSync()\">\n                <a href=\"/usuarios\">\n                    <figure>\n                        <img ng-src=\"../../assets/images/users.svg\" alt=\"\">\n                        <figcaption><strong>USUARIOS</strong></figcaption>\n                    </figure>\n                </a>\n            </div>\n        </div>\n        <div class=\"col-8 col-lg-2 pull-right\" ng-if=\"$ctrl.isAdminSync()\">\n            <div class=\"text-center icon-header mt-2 pull-right\" ng-show=\"$ctrl.isLoggedInSync() && $ctrl.isAdminSync()\">\n                <a href=\"/ordenes\">\n                    <figure>\n                        <img ng-src=\"../../assets/images/carrito.png\" alt=\"\">\n                        <figcaption><strong>ORDENES</strong></figcaption>\n                    </figure>\n                </a>\n            </div>\n        </div>\n        <div class=\"col-6 col-lg-6 col-\">\n            <div class=\"text-center icon-header mt-2 pull-right\" ng-show=\"$ctrl.isLoggedInSync() && !$ctrl.isAdminSync()\">\n                <a href=\"/historial\">\n                    <figure>\n                        <img ng-src=\"../../assets/images/pedidos.png\" alt=\"\">\n                        <figcaption><strong>HISTORIAL</strong></figcaption>\n                    </figure>\n                </a>\n            </div>\n        </div>\n        <div class=\"col-2 col-lg-2 pull-right\">\n            <div class=\"text-center icon-header mt-2 pull-right\" ng-show=\"$ctrl.isLoggedInSync() && !$ctrl.isAdminSync()\">\n                <a href=\"/carrito\">\n                    <figure>\n                        <img ng-src=\"../../assets/images/carrito.png\" alt=\"\">\n                        <figcaption><strong>MI PEDIDO</strong></figcaption>\n                    </figure>\n                </a>\n            </div>\n        </div>\n    </div>\n    <div class=\"row mt-1\">\n        <div class=\"col-12 pl-0 pr-0\">\n            <nav class=\"navbar navbar-expand navbar-inverse bg-rojo\">\n                <div class=\"collapse navbar-collapse\">\n                    <ul class=\"navbar-nav mr-auto\">\n                        <li class=\"nav-item\">\n                            <a href=\"/\" class=\"nav-link\" ng-class=\"{'active': $ctrl.isActive('/')}\">INICIO</a>\n                        </li>\n                        <li class=\"nav-item\" ng-show=\"$ctrl.isLoggedInSync()\">\n                            <a href=\"/descargas\" class=\"nav-link\" ng-class=\"{'active': $ctrl.isActive('/descargas')}\">DESCARGAS</a>\n                        </li>\n                        <li class=\"nav-item\" ng-show=\"$ctrl.isLoggedInSync()\">\n                            <a href=\"/contacto\" class=\"nav-link\" ng-class=\"{'active': $ctrl.isActive('/contacto')}\">CONTACTO</a>\n                        </li>\n                        <li class=\"nav-item\" ng-show=\"$ctrl.isLoggedInSync() && $ctrl.isAdminSync() && $ctrl.isActive('/articulo/actualizar')\">\n                            <a ng-href=\"/api/articulos/descargar/csv/{{$ctrl.user()._id}}\" target=\"_blank\" class=\"nav-link\">LISTADO ARTICULOS <span class=\"fa fa-download\"></span></a>\n                        </li>\n                    </ul>\n                    <div class=\"navbar-text pt-1 pb-0\" ng-hide=\"$ctrl.isLoggedInSync() && $ctrl.isAdminSync() && $ctrl.isActive('/articulo/actualizar')\">Tel: (0223) 475-1675 / 473-3422 / 472-5754</div>\n\n                </div>\n            </nav>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _articuloComponent = __webpack_require__(105);
	
	var _articuloList = __webpack_require__(107);
	
	var _articulo = __webpack_require__(109);
	
	var _articulo2 = _interopRequireDefault(_articulo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('pizzutoAutopartesApp.articulo-component', []).service('ArticuloService', _articulo2.default).component(_articuloComponent.ArticuloComponent.selector, _articuloComponent.ArticuloComponent).component(_articuloList.ArticuloListComponent.selector, _articuloList.ArticuloListComponent).name;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ArticuloComponent = exports.ArticuloComponent = {
	    selector: 'articulo',
	    template: __webpack_require__(106),
	    transclude: true,
	    scope: true,
	    bindings: {
	        articulo: '<'
	    }
	};

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"articulo-box\">\n    <div class=\"card\">\n        <figure class=\"text-center mb-0\">\n            <img class=\"img-fluid\" ng-src=\"{{$ctrl.articulo.imagenUrl}}\" alt=\"{{$ctrl.articulo.codigo}}\">\n        </figure>\n        <div class=\"card-block text-center\">\n            <hr>\n            <a href=\"/articulo/ver/{{$ctrl.articulo._id}}\" class=\"articulo-destacado-texto\">\n            <h5 class=\"mb-0 c-rojo\">{{$ctrl.articulo.codigo}}</h5>\n            <p class=\"mb-0 articulo-descripcion c-negro\">{{$ctrl.articulo.descripcion}}</p>\n            <span class=\"text-center c-celeste articulo-destacado-precio\" ng-if=\"$ctrl.articulo.precioVisible\">{{$ctrl.articulo.precio | currency}}</span>\n            </a>\n        </div>\n    </div>\n    <link-editar link=\"/articulo/editar/{{$ctrl.articulo._id}}\"></link-editar>\n    <div ng-transclude></div>\n</div>\n\n"

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ArticuloListComponent = exports.ArticuloListComponent = {
	    selector: 'articuloList',
	    template: __webpack_require__(108),
	    transclude: true,
	    scope: true,
	    bindings: {
	        columna: '@',
	        articulos: '<'
	    }
	};

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\" ng-show=\"$ctrl.articulos.length > 0\">\n    <div  class=\"mb-3\" ng-class=\"'{{$ctrl.columna}}'\" ng-repeat=\"item in $ctrl.articulos track by $index\">\n        <articulo articulo=\"item\">\n            <div ng-transclude></div>\n        </articulo>\n    </div>\n</div>\n<div class=\"row\" ng-show=\"$ctrl.articulos.length === 0\">\n    <div class=\"col-12\">\n        <br><br>\n        <div class=\"alert alert-danger text-center texto-sin-articulos p-5\">\n            No se han encontrado coincidencias.\n        </div>\n        <br><br><br>\n    </div>\n</div>"

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
	
	    /*@ngInject*/
	    _class.$inject = ['$http', 'ARTICULO_CATEGORIA_URL', 'ARTICULOS_URL', 'UTIL_URL'];
	    function _class($http, ARTICULO_CATEGORIA_URL, ARTICULOS_URL, UTIL_URL) {
	        _classCallCheck(this, _class);
	
	        Object.assign(this, { $http: $http, ARTICULO_CATEGORIA_URL: ARTICULO_CATEGORIA_URL, ARTICULOS_URL: ARTICULOS_URL, UTIL_URL: UTIL_URL });
	    }
	
	    _createClass(_class, [{
	        key: 'getArticulosPorCategoria',
	        value: function getArticulosPorCategoria(categoria) {
	            return this.$http.get(this.ARTICULO_CATEGORIA_URL + '/' + categoria);
	        }
	    }, {
	        key: 'getArticulosPorSubcategoria',
	        value: function getArticulosPorSubcategoria(categoria, subcategoria) {
	            return this.$http.get(this.ARTICULO_CATEGORIA_URL + '/' + categoria + '/' + subcategoria);
	        }
	    }, {
	        key: 'getArticuloPorCodigo',
	        value: function getArticuloPorCodigo(codigo) {
	            return this.$http.get(this.ARTICULOS_URL + '/' + codigo);
	        }
	    }, {
	        key: 'getArticulosPorCodigo',
	        value: function getArticulosPorCodigo(codigo) {
	            return this.$http.get(this.ARTICULOS_URL + '/codigo/' + codigo);
	        }
	    }, {
	        key: 'getArticulosPorPalabraClave',
	        value: function getArticulosPorPalabraClave(palabra) {
	            return this.$http.get(this.ARTICULOS_URL + '/palabra/' + palabra);
	        }
	    }, {
	        key: 'getArticuloCategorias',
	        value: function getArticuloCategorias() {
	            return this.$http.get(this.UTIL_URL + '/categorias');
	        }
	    }, {
	        key: 'crearArticulo',
	        value: function crearArticulo(articulo) {
	            return this.$http.post(this.ARTICULOS_URL, articulo);
	        }
	    }, {
	        key: 'actualizarArticulos',
	        value: function actualizarArticulos(lista) {
	            return this.$http.put(this.ARTICULOS_URL + '/lista', lista);
	        }
	    }, {
	        key: 'mostrarPrecios',
	        value: function mostrarPrecios() {
	            return this.$http.put(this.ARTICULOS_URL + '/precios/mostrar');
	        }
	    }, {
	        key: 'ocultarPrecios',
	        value: function ocultarPrecios() {
	            return this.$http.put(this.ARTICULOS_URL + '/precios/ocultar');
	        }
	    }, {
	        key: 'editarArticulo',
	        value: function editarArticulo(articulo) {
	            return this.$http.post(this.ARTICULOS_URL + '/' + articulo._id, articulo);
	        }
	    }, {
	        key: 'getSubcategoriasPorCategoria',
	        value: function getSubcategoriasPorCategoria(categoria) {
	            return this.$http.get(this.UTIL_URL + '/categorias/' + categoria + '/subcategorias');
	        }
	    }]);
	
	    return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _carousel = __webpack_require__(111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('pizzutoAutopartesApp.carousel', []).component(_carousel.CarouselComponent.selector, _carousel.CarouselComponent).name;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CarouselComponent = exports.CarouselComponent = {
	    selector: 'carousel',
	    template: __webpack_require__(112),
	    bindings: {
	        slides: '<'
	    },
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['$interval'];
	        function controller($interval) {
	            var _this = this;
	
	            _classCallCheck(this, controller);
	
	            this.activeSlide = 0;
	            this.isMouseHover = false;
	
	            $interval(function () {
	                if (!_this.isMouseHover) {
	                    _this.nextSlide();
	                }
	            }, 7000);
	        }
	
	        _createClass(controller, [{
	            key: 'previousSlide',
	            value: function previousSlide() {
	                if (this.activeSlide === 0) {
	                    this.activeSlide = this.slides.length - 1;
	                } else {
	                    this.activeSlide--;
	                }
	            }
	        }, {
	            key: 'nextSlide',
	            value: function nextSlide() {
	                if (this.slides.length - 1 === this.activeSlide) {
	                    this.activeSlide = 0;
	                } else {
	                    this.activeSlide++;
	                }
	            }
	        }, {
	            key: 'setSlide',
	            value: function setSlide(index) {
	                this.activeSlide = index;
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"carousel slide\">\n    <ol class=\"carousel-indicators\">\n        <li ng-class=\"{'active': $ctrl.slides[$ctrl.activeSlide]._id === item._id}\" ng-click=\"$ctrl.setSlide($index)\" ng-repeat=\"item in $ctrl.slides\"></li>\n    </ol>\n    <div class=\"carousel-inner\" role=\"listbox\">\n        <div class=\"carousel-item\" ng-class=\"{'active': $ctrl.slides[$ctrl.activeSlide]._id === item._id}\" ng-repeat=\"item in $ctrl.slides\" ng-show=\"$ctrl.slides[$ctrl.activeSlide]._id === item._id\">\n            <a ng-if=\"item.categoria\" ng-href=\"/articulo/categoria/{{item.categoria.toUpperCase()}}/{{item.subcategoria ? item.subcategoria.toUpperCase() : ''}}\">\n                <img class=\"d-block img-fluid\" ng-src=\"{{item.imagenUrl}}\" alt=\"First slide\" ng-mouseenter=\"$ctrl.isMouseHover = true\" ng-mouseleave=\"$ctrl.isMouseHover = false\">\n            </a>\n            <img ng-if=\"!item.categoria\" class=\"d-block img-fluid\" ng-src=\"{{item.imagenUrl}}\" alt=\"First slide\" ng-mouseenter=\"$ctrl.isMouseHover = true\" ng-mouseleave=\"$ctrl.isMouseHover = false\">\n        </div>\n    </div>\n    <a class=\"carousel-control-prev\" href=\"#\" ng-click=\"$ctrl.previousSlide()\">\n        <span class=\"carousel-control-prev-icon\" aria-hidden=\"true\"></span>\n        <span class=\"sr-only\">Anterior</span>\n    </a>\n    <a class=\"carousel-control-next\" href=\"#\" ng-click=\"$ctrl.nextSlide()\">\n        <span class=\"carousel-control-next-icon\" aria-hidden=\"true\"></span>\n        <span class=\"sr-only\">Siguiente</span>\n    </a>\n</div>\n"

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FooterComponent = function FooterComponent() {
	    _classCallCheck(this, FooterComponent);
	};
	
	exports.default = _angular2.default.module('directives.footer', []).component('footer', {
	    template: __webpack_require__(114),
	    controller: FooterComponent
	}).name;

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	module.exports = "<!--<div class=\"container\">-->\n    <!--<p>Angular Fullstack v4.1.3 |-->\n        <!--<a href=\"http://angular-fullstack.github.io/generator-angular-fullstack\">Documentation</a> |-->\n        <!--<a href=\"https://gitter.im/DaftMonk/generator-angular-fullstack\">Chat on Gitter</a> |-->\n        <!--<a href=\"https://github.com/angular-fullstack/generator-angular-fullstack/issues?state=open\">Issues</a> |-->\n        <!--<a href=\"https://opencollective.com/angular-fullstack\">Donate to our Open Collective</a>-->\n    <!--</p>-->\n<!--</div>-->\n\n<div class=\"container bg-celeste\">\n    <br>\n    <div class=\"row\">\n        <div class=\"col-12\">\n            <figure class=\"text-center\">\n                <a href=\"/\"><img src=\"../../assets/images/logoPie.png\" alt=\"\"></a>\n            </figure>\n        </div>\n    </div>\n    <br>\n    <div class=\"row\">\n        <div class=\"col-12 text-center\">\n            <span class=\"c-blanco\">RODOLFO PIZZUTO AUTOPARTES - COPYRIGHT 2023 - DERECHOS RESERVADOS</span>\n        </div>\n    </div>\n    <br>\n</div>\n"

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _linkEditar = __webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('pizzutoAutopartesApp.link-editar', []).component(_linkEditar.LinkEditarComponent.selector, _linkEditar.LinkEditarComponent).name;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LinkEditarComponent = exports.LinkEditarComponent = {
	    selector: 'linkEditar',
	    template: __webpack_require__(117),
	    bindings: {
	        link: '@'
	    },
	    controller:
	
	    /*@ngInject*/
	    ['Auth', function controller(Auth) {
	        _classCallCheck(this, controller);
	
	        this.isAdmin = Auth.isAdminSync;
	    }]
	};

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"link-editar\" ng-show=\"$ctrl.isAdmin()\">\n    <a ng-href=\"{{$ctrl.link}}\" class=\"btn btn-secondary bg-celeste\">\n        <span class=\"fa fa-pencil\"></span>\n    </a>\n</div>\n"

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _articulosPagination = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('pizzutoAutopartes.articulosPagination', []).component(_articulosPagination.ArticulosPaginationComponent.selector, _articulosPagination.ArticulosPaginationComponent).name;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArticulosPaginationComponent = exports.ArticulosPaginationComponent = {
	    selector: 'articulosPagination',
	    template: __webpack_require__(120),
	    bindings: {
	        totalPages: '=',
	        currentPage: '='
	    },
	    controller: function () {
	
	        /*@ngInject*/
	        controller.$inject = ['$scope'];
	        function controller($scope) {
	            _classCallCheck(this, controller);
	
	            Object.assign(this, { $scope: $scope });
	        }
	
	        _createClass(controller, [{
	            key: '$onInit',
	            value: function $onInit() {}
	        }, {
	            key: 'changePage',
	            value: function changePage(number) {
	                this.$scope.$emit('setPageTo', number);
	            }
	        }, {
	            key: 'pageRange',
	            value: function pageRange() {
	                var range = [];
	
	                for (var i = 0; i < this.totalPages; i++) {
	                    range.push(i + 1);
	                }
	                return range;
	            }
	        }]);
	
	        return controller;
	    }()
	};

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	module.exports = "<nav class=\"pull-right\" ng-hide=\"$ctrl.totalPages <= 1\">\n    <ul class=\"pagination\">\n        <li class=\"page-item\" ng-class=\"{'disabled': $ctrl.currentPage === 1}\"><a href=\"#\" class=\"page-link\" ng-click=\"$ctrl.changePage(1)\">Primero</a></li>\n        <li class=\"page-item\" ng-class=\"{'disabled': $ctrl.currentPage === 1}\"><a href=\"#\" class=\"page-link\" ng-click=\"$ctrl.changePage($ctrl.currentPage - 1)\">Anterior</a></li>\n        <li class=\"page-item\" ng-repeat=\"item in $ctrl.pageRange()\" ng-class=\"{'disabled': $ctrl.currentPage === item}\" ng-click=\"$ctrl.changePage(item)\" ng-show=\"($ctrl.currentPage - 5) <= item && item <= ($ctrl.currentPage + 5)\">\n            <a href=\"#\" class=\"page-link\">{{item}}</a>\n        </li>\n        <li class=\"page-item\" ng-class=\"{'disabled': $ctrl.currentPage === $ctrl.totalPages}\"><a href=\"#\" class=\"page-link\" ng-click=\"$ctrl.changePage($ctrl.currentPage + 1)\">Siguiente</a></li>\n        <li class=\"page-item\" ng-class=\"{'disabled': $ctrl.currentPage === $ctrl.totalPages}\"><a href=\"#\" class=\"page-link\" ng-click=\"$ctrl.changePage($ctrl.totalPages)\">Ultimo</a></li>\n    </ul>\n</nav>\n"

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(122);
	module.exports = "toaster";


/***/ }),
/* 122 */
/***/ (function(module, exports) {

	/* global angular */
	/*
	    * @license
	    * AngularJS Toaster
	    * Version: 3.0.0
	    *
	    * Copyright 2013-2019 Jiri Kavulak, Stabzs.
	    * All Rights Reserved.
	    * Use, reproduction, distribution, and modification of this code is subject to the terms and
	    * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
	    *
	    * Authors: Jiri Kavulak, Stabzs
	    * Related to project of John Papa, Hans Fjällemark and Nguyễn Thiện Hùng (thienhung1989)
	*/
	(function(window, document) {
	    'use strict';
	
	    angular.module('toaster', []).constant(
	        'toasterConfig', {
	            'limit': 0,                   // limits max number of toasts
	            'tap-to-dismiss': true,
	            'close-button': false,
	            'close-html': '<button class="toast-close-button" type="button">&times;</button>',
	            'newest-on-top': true,
	            'time-out': 5000,
	            'icon-classes': {
	                error: 'toast-error',
	                info: 'toast-info',
	                wait: 'toast-wait',
	                success: 'toast-success',
	                warning: 'toast-warning'
	            },
	            'body-output-type': '', // Options: '', 'html', 'trustedHtml', 'template', 'templateWithData', 'directive'
	            'body-template': 'toasterBodyTmpl.html',
	            'icon-class': 'toast-info',
	            'position-class': 'toast-top-right', // Options (see CSS):
	            // 'toast-top-full-width', 'toast-bottom-full-width', 'toast-center',
	            // 'toast-top-left', 'toast-top-center', 'toast-top-right',
	            // 'toast-bottom-left', 'toast-bottom-center', 'toast-bottom-right',
	            'title-class': 'toast-title',
	            'message-class': 'toast-message',
	            'prevent-duplicates': false,
	            'mouseover-timer-stop': true // stop timeout on mouseover and restart timer on mouseout
	        }
	    ).run(['$templateCache', function($templateCache) {
	            $templateCache.put('angularjs-toaster/toast.html',
	                '<div id="toast-container" ng-class="[config.position, config.animation]">' +
	                    '<div ng-repeat="toaster in toasters" class="toast" ng-class="toaster.type" ng-click="click($event, toaster)" ng-mouseover="stopTimer(toaster)" ng-mouseout="restartTimer(toaster)">' +
	                        '<div ng-if="toaster.showCloseButton" ng-click="click($event, toaster, true)" ng-bind-html="toaster.closeHtml"></div>' +
	                        '<div ng-class="config.title">{{toaster.title}}</div>' +
	                        '<div ng-class="config.message" ng-switch on="toaster.bodyOutputType">' +
	                        '<div ng-switch-when="html" ng-bind-html="toaster.body"></div>' +
	                        '<div ng-switch-when="trustedHtml" ng-bind-html="toaster.html"></div>' +
	                        '<div ng-switch-when="template"><div ng-include="toaster.bodyTemplate"></div></div>' +
	                        '<div ng-switch-when="templateWithData"><div ng-include="toaster.bodyTemplate"></div></div>' +
	                        '<div ng-switch-when="directive"><div directive-template directive-name="{{toaster.html}}" directive-data="toaster.directiveData"></div></div>' +
	                        '<div ng-switch-default >{{toaster.body}}</div>' +
	                        '</div>' +
	                    '</div>' +
	                '</div>');
	        }
	    ]).service(
	        'toaster', [
	            '$rootScope', 'toasterConfig', function($rootScope, toasterConfig) {
	                // http://stackoverflow.com/questions/26501688/a-typescript-guid-class
	                var Guid = (function() {
	                    var Guid = {};
	                    Guid.newGuid = function() {
	                        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	                            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
	                            return v.toString(16);
	                        });
	                    };
	                    return Guid;
	                }());
	
	                this.pop = function(type, title, body, timeout, bodyOutputType, clickHandler, toasterId, showCloseButton, toastId, onHideCallback) {
	                    if (angular.isObject(type)) {
	                        var params = type; // Enable named parameters as pop argument
	                        this.toast = {
	                            type: params.type,
	                            title: params.title,
	                            body: params.body,
	                            timeout: params.timeout,
	                            bodyOutputType: params.bodyOutputType,
	                            clickHandler: params.clickHandler,
	                            showCloseButton: params.showCloseButton,
	                            closeHtml: params.closeHtml,
	                            toastId: params.toastId,
	                            onShowCallback: params.onShowCallback,
	                            onHideCallback: params.onHideCallback,
	                            directiveData: params.directiveData,
	                            tapToDismiss: params.tapToDismiss
	                        };
	                        toasterId = params.toasterId;
	                    } else {
	                        this.toast = {
	                            type: type,
	                            title: title,
	                            body: body,
	                            timeout: timeout,
	                            bodyOutputType: bodyOutputType,
	                            clickHandler: clickHandler,
	                            showCloseButton: showCloseButton,
	                            toastId: toastId,
	                            onHideCallback: onHideCallback
	                        };
	                    }
	
	                    if (!this.toast.toastId || !this.toast.toastId.length) {
	                        this.toast.toastId = Guid.newGuid();
	                    }
	
	                    $rootScope.$emit('toaster-newToast', toasterId, this.toast.toastId);
	                    
	                    return {
	                        toasterId: toasterId,
	                        toastId: this.toast.toastId
	                    };
	                };
	
	                this.clear = function(toasterId, toastId) {
	                    if (angular.isObject(toasterId)) {
	                        $rootScope.$emit('toaster-clearToasts', toasterId.toasterId, toasterId.toastId);
	                    } else {
	                        $rootScope.$emit('toaster-clearToasts', toasterId, toastId);
	                    }
	                };
	
	                // Create one method per icon class, to allow to call toaster.info() and similar
	                for (var type in toasterConfig['icon-classes']) {
	                    this[type] = createTypeMethod(type);
	                }
	
	                function createTypeMethod(toasterType) {
	                    return function(title, body, timeout, bodyOutputType, clickHandler, toasterId, showCloseButton, toastId, onHideCallback) {
	                        if (angular.isString(title)) {
	                            return this.pop(
	                                toasterType,
	                                title,
	                                body,
	                                timeout,
	                                bodyOutputType,
	                                clickHandler,
	                                toasterId,
	                                showCloseButton,
	                                toastId,
	                                onHideCallback);
	                        } else { // 'title' is actually an object with options
	                            return this.pop(angular.extend(title, { type: toasterType }));
	                        }
	                    };
	                }
	            }]
	        ).factory(
	        'toasterEventRegistry', [
	            '$rootScope', function($rootScope) {
	                var deregisterNewToast = null, deregisterClearToasts = null, newToastEventSubscribers = [], clearToastsEventSubscribers = [], toasterFactory;
	
	                toasterFactory = {
	                    setup: function() {
	                        if (!deregisterNewToast) {
	                            deregisterNewToast = $rootScope.$on(
	                                'toaster-newToast', function(event, toasterId, toastId) {
	                                    for (var i = 0, len = newToastEventSubscribers.length; i < len; i++) {
	                                        newToastEventSubscribers[i](event, toasterId, toastId);
	                                    }
	                                });
	                        }
	
	                        if (!deregisterClearToasts) {
	                            deregisterClearToasts = $rootScope.$on(
	                                'toaster-clearToasts', function(event, toasterId, toastId) {
	                                    for (var i = 0, len = clearToastsEventSubscribers.length; i < len; i++) {
	                                        clearToastsEventSubscribers[i](event, toasterId, toastId);
	                                    }
	                                });
	                        }
	                    },
	
	                    subscribeToNewToastEvent: function(onNewToast) {
	                        newToastEventSubscribers.push(onNewToast);
	                    },
	                    subscribeToClearToastsEvent: function(onClearToasts) {
	                        clearToastsEventSubscribers.push(onClearToasts);
	                    },
	                    unsubscribeToNewToastEvent: function(onNewToast) {
	                        var index = newToastEventSubscribers.indexOf(onNewToast);
	                        if (index >= 0) {
	                            newToastEventSubscribers.splice(index, 1);
	                        }
	
	                        if (newToastEventSubscribers.length === 0) {
	                            deregisterNewToast();
	                            deregisterNewToast = null;
	                        }
	                    },
	                    unsubscribeToClearToastsEvent: function(onClearToasts) {
	                        var index = clearToastsEventSubscribers.indexOf(onClearToasts);
	                        if (index >= 0) {
	                            clearToastsEventSubscribers.splice(index, 1);
	                        }
	
	                        if (clearToastsEventSubscribers.length === 0) {
	                            deregisterClearToasts();
	                            deregisterClearToasts = null;
	                        }
	                    }
	                };
	                return {
	                    setup: toasterFactory.setup,
	                    subscribeToNewToastEvent: toasterFactory.subscribeToNewToastEvent,
	                    subscribeToClearToastsEvent: toasterFactory.subscribeToClearToastsEvent,
	                    unsubscribeToNewToastEvent: toasterFactory.unsubscribeToNewToastEvent,
	                    unsubscribeToClearToastsEvent: toasterFactory.unsubscribeToClearToastsEvent
	                };
	            }]
	        )
	        .directive('directiveTemplate', ['$compile', '$injector', function($compile, $injector) {
	            return {
	                restrict: 'A',
	                scope: {
	                    directiveName: '@directiveName',
	                    directiveData: '=directiveData'
	                },
	                replace: true,
	                link: function(scope, elm, attrs) {
	                    scope.$watch('directiveName', function(directiveName) {
	                        if (angular.isUndefined(directiveName) || directiveName.length <= 0)
	                            throw new Error('A valid directive name must be provided via the toast body argument when using bodyOutputType: directive');
	
	                        var directive;
	
	                        try {
	                            directive = $injector.get(attrs.$normalize(directiveName) + 'Directive');
	                        } catch (e) {
	                            throw new Error(directiveName + ' could not be found. ' +
	                                'The name should appear as it exists in the markup, not camelCased as it would appear in the directive declaration,' +
	                                ' e.g. directive-name not directiveName.');
	                        }
	
	
	                        var directiveDetails = directive[0];
	
	                        if (directiveDetails.scope !== true && directiveDetails.scope) {
	                            throw new Error('Cannot use a directive with an isolated scope. ' +
	                                'The scope must be either true or falsy (e.g. false/null/undefined). ' +
	                                'Occurred for directive ' + directiveName + '.');
	                        }
	
	                        if (directiveDetails.restrict.indexOf('A') < 0) {
	                            throw new Error('Directives must be usable as attributes. ' +
	                                'Add "A" to the restrict option (or remove the option entirely). Occurred for directive ' +
	                                directiveName + '.');
	                        }
	
	                        if (scope.directiveData)
	                            scope.directiveData = angular.fromJson(scope.directiveData);
	
	                        var template = $compile('<div ' + directiveName + '></div>')(scope);
	
	                        elm.append(template);
	                    });
	                }
	            };
	        }])
	        .directive(
	        'toasterContainer', [
	            '$parse', '$rootScope', '$interval', '$sce', 'toasterConfig', 'toaster', 'toasterEventRegistry',
	            function($parse, $rootScope, $interval, $sce, toasterConfig, toaster, toasterEventRegistry) {
	                return {
	                    replace: true,
	                    restrict: 'EA',
	                    scope: true, // creates an internal scope for this directive (one per directive instance)
	                    link: function(scope, elm, attrs) {
	                        var mergedConfig;
	
	                        // Merges configuration set in directive with default one
	                        mergedConfig = angular.extend({}, toasterConfig, scope.$eval(attrs.toasterOptions));
	
	                        scope.config = {
	                            toasterId: mergedConfig['toaster-id'],
	                            position: mergedConfig['position-class'],
	                            title: mergedConfig['title-class'],
	                            message: mergedConfig['message-class'],
	                            tap: mergedConfig['tap-to-dismiss'],
	                            closeButton: mergedConfig['close-button'],
	                            closeHtml: mergedConfig['close-html'],
	                            animation: mergedConfig['animation-class'],
	                            mouseoverTimer: mergedConfig['mouseover-timer-stop']
	                        };
	
	                        scope.$on(
	                            "$destroy", function() {
	                                toasterEventRegistry.unsubscribeToNewToastEvent(scope._onNewToast);
	                                toasterEventRegistry.unsubscribeToClearToastsEvent(scope._onClearToasts);
	                            }
	                        );
	
	                        function setTimeout(toast, time) {
	                            toast.timeoutPromise = $interval(
	                                function() {
	                                    scope.removeToast(toast.toastId);
	                                }, time, 1
	                            );
	                        }
	
	                        scope.configureTimer = function(toast) {
	                            var timeout = angular.isNumber(toast.timeout) ? toast.timeout : mergedConfig['time-out'];
	                            if (typeof timeout === "object") timeout = timeout[toast.type];
	                            if (timeout > 0) {
	                                setTimeout(toast, timeout);
	                            }
	                        };
	
	                        function addToast(toast, toastId) {
	                            toast.type = mergedConfig['icon-classes'][toast.type];
	                            if (!toast.type) {
	                                toast.type = mergedConfig['icon-class'];
	                            }
	
	                            if (mergedConfig['prevent-duplicates'] === true && scope.toasters.length) {
	                                if (scope.toasters[scope.toasters.length - 1].body === toast.body) {
	                                    return;
	                                } else {
	                                    var i, len, dupFound = false;
	                                    for (i = 0, len = scope.toasters.length; i < len; i++) {
	                                        if (scope.toasters[i].toastId === toastId) {
	                                            dupFound = true;
	                                            break;
	                                        }
	                                    }
	                                    
	                                    if (dupFound) return;
	                                }
	                            }
	
	
	                            // set the showCloseButton property on the toast so that
	                            // each template can bind directly to the property to show/hide
	                            // the close button
	                            var closeButton = mergedConfig['close-button'];
	
	                            // if toast.showCloseButton is a boolean value,
	                            // it was specifically overriden in the pop arguments
	                            if (typeof toast.showCloseButton === "boolean") {
	
	                            } else if (typeof closeButton === "boolean") {
	                                toast.showCloseButton = closeButton;
	                            } else if (typeof closeButton === "object") {
	                                var closeButtonForType = closeButton[toast.type];
	
	                                if (typeof closeButtonForType !== "undefined" && closeButtonForType !== null) {
	                                    toast.showCloseButton = closeButtonForType;
	                                }
	                            } else {
	                                // if an option was not set, default to false.
	                                toast.showCloseButton = false;
	                            }
	
	                            if (toast.showCloseButton) {
	                                toast.closeHtml = $sce.trustAsHtml(toast.closeHtml || scope.config.closeHtml);
	                            }
	
	                            // Set the toast.bodyOutputType to the default if it isn't set
	                            toast.bodyOutputType = toast.bodyOutputType || mergedConfig['body-output-type'];
	                            switch (toast.bodyOutputType) {
	                                case 'trustedHtml':
	                                    toast.html = $sce.trustAsHtml(toast.body);
	                                    break;
	                                case 'template':
	                                    toast.bodyTemplate = toast.body || mergedConfig['body-template'];
	                                    break;
	                                case 'templateWithData':
	                                    var fcGet = $parse(toast.body || mergedConfig['body-template']);
	                                    var templateWithData = fcGet(scope);
	                                    toast.bodyTemplate = templateWithData.template;
	                                    toast.data = templateWithData.data;
	                                    break;
	                                case 'directive':
	                                    toast.html = toast.body;
	                                    break;
	                            }
	
	                            scope.configureTimer(toast);
	
	                            if (mergedConfig['newest-on-top'] === true) {
	                                scope.toasters.unshift(toast);
	                                if (mergedConfig['limit'] > 0 && scope.toasters.length > mergedConfig['limit']) {
	                                    removeToast(scope.toasters.length - 1);
	                                }
	                            } else {
	                                scope.toasters.push(toast);
	                                if (mergedConfig['limit'] > 0 && scope.toasters.length > mergedConfig['limit']) {
	                                    removeToast(0);
	                                }
	                            }
	
	                            if (angular.isFunction(toast.onShowCallback)) {
	                                toast.onShowCallback(toast);
	                            }
	                        }
	
	                        scope.removeToast = function(toastId) {
	                            var i, len;
	                            for (i = 0, len = scope.toasters.length; i < len; i++) {
	                                if (scope.toasters[i].toastId === toastId) {
	                                    removeToast(i);
	                                    break;
	                                }
	                            }
	                        };
	
	                        function removeToast(toastIndex) {
	                            var toast = scope.toasters[toastIndex];
	
	                            // toast is always defined since the index always has a match
	                            if (toast.timeoutPromise) {
	                                $interval.cancel(toast.timeoutPromise);
	                            }
	                            scope.toasters.splice(toastIndex, 1);
	
	                            if (angular.isFunction(toast.onHideCallback)) {
	                                toast.onHideCallback(toast);
	                            }
	                        }
	
	                        function removeAllToasts(toastId) {
	                            for (var i = scope.toasters.length - 1; i >= 0; i--) {
	                                if (isUndefinedOrNull(toastId)) {
	                                    removeToast(i);
	                                } else {
	                                    if (scope.toasters[i].toastId == toastId) {
	                                        removeToast(i);
	                                    }
	                                }
	                            }
	                        }
	
	                        scope.toasters = [];
	
	                        function isUndefinedOrNull(val) {
	                            return angular.isUndefined(val) || val === null;
	                        }
	
	                        scope._onNewToast = function(event, toasterId, toastId) {
	                            // Compatibility: if toaster has no toasterId defined, and if call to display
	                            // hasn't either, then the request is for us
	                            if ((isUndefinedOrNull(scope.config.toasterId) && isUndefinedOrNull(toasterId)) || (!isUndefinedOrNull(scope.config.toasterId) && !isUndefinedOrNull(toasterId) && scope.config.toasterId == toasterId)) {
	                                addToast(toaster.toast, toastId);
	                            }
	                        };
	                        scope._onClearToasts = function(event, toasterId, toastId) {
	                            // Compatibility: if toaster has no toasterId defined, and if call to display
	                            // hasn't either, then the request is for us
	                            if (toasterId == '*' || (isUndefinedOrNull(scope.config.toasterId) && isUndefinedOrNull(toasterId)) || (!isUndefinedOrNull(scope.config.toasterId) && !isUndefinedOrNull(toasterId) && scope.config.toasterId == toasterId)) {
	                                removeAllToasts(toastId);
	                            }
	                        };
	
	                        toasterEventRegistry.setup();
	
	                        toasterEventRegistry.subscribeToNewToastEvent(scope._onNewToast);
	                        toasterEventRegistry.subscribeToClearToastsEvent(scope._onClearToasts);
	                    },
	                    controller: [
	                        '$scope', '$element', '$attrs', function($scope, $element, $attrs) {
	                            // Called on mouseover
	                            $scope.stopTimer = function(toast) {
	                                if ($scope.config.mouseoverTimer === true) {
	                                    if (toast.timeoutPromise) {
	                                        $interval.cancel(toast.timeoutPromise);
	                                        toast.timeoutPromise = null;
	                                    }
	                                }
	                            };
	
	                            // Called on mouseout
	                            $scope.restartTimer = function(toast) {
	                                if ($scope.config.mouseoverTimer === true) {
	                                    if (!toast.timeoutPromise) {
	                                        $scope.configureTimer(toast);
	                                    }
	                                } else if (toast.timeoutPromise === null) {
	                                    $scope.removeToast(toast.toastId);
	                                }
	                            };
	
	                            $scope.click = function(event, toast, isCloseButton) {
	                                event.stopPropagation();
	
	                                var tapToDismiss = typeof toast.tapToDismiss === "boolean" 
	                                                        ? toast.tapToDismiss 
	                                                        : $scope.config.tap;
	                                if (tapToDismiss === true || (toast.showCloseButton === true && isCloseButton === true)) {
	                                    var removeToast = true;
	                                    if (toast.clickHandler) {
	                                        if (angular.isFunction(toast.clickHandler)) {
	                                            removeToast = toast.clickHandler(toast, isCloseButton);
	                                        } else if (angular.isFunction($scope.$parent.$eval(toast.clickHandler))) {
	                                            removeToast = $scope.$parent.$eval(toast.clickHandler)(toast, isCloseButton);
	                                        } else {
	                                            console.log("TOAST-NOTE: Your click handler is not inside a parent scope of toaster-container.");
	                                        }
	                                    }
	                                    if (removeToast) {
	                                        $scope.removeToast(toast.toastId);
	                                    }
	                                }
	                            };
	                        }],
	                    templateUrl: 'angularjs-toaster/toast.html'
	                };
	            }]
	        );
	})(window, document);


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(124);
	module.exports = 'ngFileUpload';

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	/**!
	 * AngularJS file upload directives and services. Supports: file upload/drop/paste, resume, cancel/abort,
	 * progress, resize, thumbnail, preview, validation and CORS
	 * FileAPI Flash shim for old browsers not supporting FormData
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 12.2.13
	 */
	
	(function () {
	  /** @namespace FileAPI.noContentTimeout */
	
	  function patchXHR(fnName, newFn) {
	    window.XMLHttpRequest.prototype[fnName] = newFn(window.XMLHttpRequest.prototype[fnName]);
	  }
	
	  function redefineProp(xhr, prop, fn) {
	    try {
	      Object.defineProperty(xhr, prop, {get: fn});
	    } catch (e) {/*ignore*/
	    }
	  }
	
	  if (!window.FileAPI) {
	    window.FileAPI = {};
	  }
	
	  if (!window.XMLHttpRequest) {
	    throw 'AJAX is not supported. XMLHttpRequest is not defined.';
	  }
	
	  FileAPI.shouldLoad = !window.FormData || FileAPI.forceLoad;
	  if (FileAPI.shouldLoad) {
	    var initializeUploadListener = function (xhr) {
	      if (!xhr.__listeners) {
	        if (!xhr.upload) xhr.upload = {};
	        xhr.__listeners = [];
	        var origAddEventListener = xhr.upload.addEventListener;
	        xhr.upload.addEventListener = function (t, fn) {
	          xhr.__listeners[t] = fn;
	          if (origAddEventListener) origAddEventListener.apply(this, arguments);
	        };
	      }
	    };
	
	    patchXHR('open', function (orig) {
	      return function (m, url, b) {
	        initializeUploadListener(this);
	        this.__url = url;
	        try {
	          orig.apply(this, [m, url, b]);
	        } catch (e) {
	          if (e.message.indexOf('Access is denied') > -1) {
	            this.__origError = e;
	            orig.apply(this, [m, '_fix_for_ie_crossdomain__', b]);
	          }
	        }
	      };
	    });
	
	    patchXHR('getResponseHeader', function (orig) {
	      return function (h) {
	        return this.__fileApiXHR && this.__fileApiXHR.getResponseHeader ? this.__fileApiXHR.getResponseHeader(h) : (orig == null ? null : orig.apply(this, [h]));
	      };
	    });
	
	    patchXHR('getAllResponseHeaders', function (orig) {
	      return function () {
	        return this.__fileApiXHR && this.__fileApiXHR.getAllResponseHeaders ? this.__fileApiXHR.getAllResponseHeaders() : (orig == null ? null : orig.apply(this));
	      };
	    });
	
	    patchXHR('abort', function (orig) {
	      return function () {
	        return this.__fileApiXHR && this.__fileApiXHR.abort ? this.__fileApiXHR.abort() : (orig == null ? null : orig.apply(this));
	      };
	    });
	
	    patchXHR('setRequestHeader', function (orig) {
	      return function (header, value) {
	        if (header === '__setXHR_') {
	          initializeUploadListener(this);
	          var val = value(this);
	          // fix for angular < 1.2.0
	          if (val instanceof Function) {
	            val(this);
	          }
	        } else {
	          this.__requestHeaders = this.__requestHeaders || {};
	          this.__requestHeaders[header] = value;
	          orig.apply(this, arguments);
	        }
	      };
	    });
	
	    patchXHR('send', function (orig) {
	      return function () {
	        var xhr = this;
	        if (arguments[0] && arguments[0].__isFileAPIShim) {
	          var formData = arguments[0];
	          var config = {
	            url: xhr.__url,
	            jsonp: false, //removes the callback form param
	            cache: true, //removes the ?fileapiXXX in the url
	            complete: function (err, fileApiXHR) {
	              if (err && angular.isString(err) && err.indexOf('#2174') !== -1) {
	                // this error seems to be fine the file is being uploaded properly.
	                err = null;
	              }
	              xhr.__completed = true;
	              if (!err && xhr.__listeners.load)
	                xhr.__listeners.load({
	                  type: 'load',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (!err && xhr.__listeners.loadend)
	                xhr.__listeners.loadend({
	                  type: 'loadend',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (err === 'abort' && xhr.__listeners.abort)
	                xhr.__listeners.abort({
	                  type: 'abort',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (fileApiXHR.status !== undefined) redefineProp(xhr, 'status', function () {
	                return (fileApiXHR.status === 0 && err && err !== 'abort') ? 500 : fileApiXHR.status;
	              });
	              if (fileApiXHR.statusText !== undefined) redefineProp(xhr, 'statusText', function () {
	                return fileApiXHR.statusText;
	              });
	              redefineProp(xhr, 'readyState', function () {
	                return 4;
	              });
	              if (fileApiXHR.response !== undefined) redefineProp(xhr, 'response', function () {
	                return fileApiXHR.response;
	              });
	              var resp = fileApiXHR.responseText || (err && fileApiXHR.status === 0 && err !== 'abort' ? err : undefined);
	              redefineProp(xhr, 'responseText', function () {
	                return resp;
	              });
	              redefineProp(xhr, 'response', function () {
	                return resp;
	              });
	              if (err) redefineProp(xhr, 'err', function () {
	                return err;
	              });
	              xhr.__fileApiXHR = fileApiXHR;
	              if (xhr.onreadystatechange) xhr.onreadystatechange();
	              if (xhr.onload) xhr.onload();
	            },
	            progress: function (e) {
	              e.target = xhr;
	              if (xhr.__listeners.progress) xhr.__listeners.progress(e);
	              xhr.__total = e.total;
	              xhr.__loaded = e.loaded;
	              if (e.total === e.loaded) {
	                // fix flash issue that doesn't call complete if there is no response text from the server
	                var _this = this;
	                setTimeout(function () {
	                  if (!xhr.__completed) {
	                    xhr.getAllResponseHeaders = function () {
	                    };
	                    _this.complete(null, {status: 204, statusText: 'No Content'});
	                  }
	                }, FileAPI.noContentTimeout || 10000);
	              }
	            },
	            headers: xhr.__requestHeaders
	          };
	          config.data = {};
	          config.files = {};
	          for (var i = 0; i < formData.data.length; i++) {
	            var item = formData.data[i];
	            if (item.val != null && item.val.name != null && item.val.size != null && item.val.type != null) {
	              config.files[item.key] = item.val;
	            } else {
	              config.data[item.key] = item.val;
	            }
	          }
	
	          setTimeout(function () {
	            if (!FileAPI.hasFlash) {
	              throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
	            }
	            xhr.__fileApiXHR = FileAPI.upload(config);
	          }, 1);
	        } else {
	          if (this.__origError) {
	            throw this.__origError;
	          }
	          orig.apply(xhr, arguments);
	        }
	      };
	    });
	    window.XMLHttpRequest.__isFileAPIShim = true;
	    window.FormData = FormData = function () {
	      return {
	        append: function (key, val, name) {
	          if (val.__isFileAPIBlobShim) {
	            val = val.data[0];
	          }
	          this.data.push({
	            key: key,
	            val: val,
	            name: name
	          });
	        },
	        data: [],
	        __isFileAPIShim: true
	      };
	    };
	
	    window.Blob = Blob = function (b) {
	      return {
	        data: b,
	        __isFileAPIBlobShim: true
	      };
	    };
	  }
	
	})();
	
	(function () {
	  /** @namespace FileAPI.forceLoad */
	  /** @namespace window.FileAPI.jsUrl */
	  /** @namespace window.FileAPI.jsPath */
	
	  function isInputTypeFile(elem) {
	    return elem[0].tagName.toLowerCase() === 'input' && elem.attr('type') && elem.attr('type').toLowerCase() === 'file';
	  }
	
	  function hasFlash() {
	    try {
	      var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
	      if (fo) return true;
	    } catch (e) {
	      if (navigator.mimeTypes['application/x-shockwave-flash'] !== undefined) return true;
	    }
	    return false;
	  }
	
	  function getOffset(obj) {
	    var left = 0, top = 0;
	
	    if (window.jQuery) {
	      return jQuery(obj).offset();
	    }
	
	    if (obj.offsetParent) {
	      do {
	        left += (obj.offsetLeft - obj.scrollLeft);
	        top += (obj.offsetTop - obj.scrollTop);
	        obj = obj.offsetParent;
	      } while (obj);
	    }
	    return {
	      left: left,
	      top: top
	    };
	  }
	
	  if (FileAPI.shouldLoad) {
	    FileAPI.hasFlash = hasFlash();
	
	    //load FileAPI
	    if (FileAPI.forceLoad) {
	      FileAPI.html5 = false;
	    }
	
	    if (!FileAPI.upload) {
	      var jsUrl, basePath, script = document.createElement('script'), allScripts = document.getElementsByTagName('script'), i, index, src;
	      if (window.FileAPI.jsUrl) {
	        jsUrl = window.FileAPI.jsUrl;
	      } else if (window.FileAPI.jsPath) {
	        basePath = window.FileAPI.jsPath;
	      } else {
	        for (i = 0; i < allScripts.length; i++) {
	          src = allScripts[i].src;
	          index = src.search(/\/ng\-file\-upload[\-a-zA-z0-9\.]*\.js/);
	          if (index > -1) {
	            basePath = src.substring(0, index + 1);
	            break;
	          }
	        }
	      }
	
	      if (FileAPI.staticPath == null) FileAPI.staticPath = basePath;
	      script.setAttribute('src', jsUrl || basePath + 'FileAPI.min.js');
	      document.getElementsByTagName('head')[0].appendChild(script);
	    }
	
	    FileAPI.ngfFixIE = function (elem, fileElem, changeFn) {
	      if (!hasFlash()) {
	        throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
	      }
	      var fixInputStyle = function () {
	        var label = fileElem.parent();
	        if (elem.attr('disabled')) {
	          if (label) label.removeClass('js-fileapi-wrapper');
	        } else {
	          if (!fileElem.attr('__ngf_flash_')) {
	            fileElem.unbind('change');
	            fileElem.unbind('click');
	            fileElem.bind('change', function (evt) {
	              fileApiChangeFn.apply(this, [evt]);
	              changeFn.apply(this, [evt]);
	            });
	            fileElem.attr('__ngf_flash_', 'true');
	          }
	          label.addClass('js-fileapi-wrapper');
	          if (!isInputTypeFile(elem)) {
	            label.css('position', 'absolute')
	              .css('top', getOffset(elem[0]).top + 'px').css('left', getOffset(elem[0]).left + 'px')
	              .css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px')
	              .css('filter', 'alpha(opacity=0)').css('display', elem.css('display'))
	              .css('overflow', 'hidden').css('z-index', '900000')
	              .css('visibility', 'visible');
	            fileElem.css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px')
	              .css('position', 'absolute').css('top', '0px').css('left', '0px');
	          }
	        }
	      };
	
	      elem.bind('mouseenter', fixInputStyle);
	
	      var fileApiChangeFn = function (evt) {
	        var files = FileAPI.getFiles(evt);
	        //just a double check for #233
	        for (var i = 0; i < files.length; i++) {
	          if (files[i].size === undefined) files[i].size = 0;
	          if (files[i].name === undefined) files[i].name = 'file';
	          if (files[i].type === undefined) files[i].type = 'undefined';
	        }
	        if (!evt.target) {
	          evt.target = {};
	        }
	        evt.target.files = files;
	        // if evt.target.files is not writable use helper field
	        if (evt.target.files !== files) {
	          evt.__files_ = files;
	        }
	        (evt.__files_ || evt.target.files).item = function (i) {
	          return (evt.__files_ || evt.target.files)[i] || null;
	        };
	      };
	    };
	
	    FileAPI.disableFileInput = function (elem, disable) {
	      if (disable) {
	        elem.removeClass('js-fileapi-wrapper');
	      } else {
	        elem.addClass('js-fileapi-wrapper');
	      }
	    };
	  }
	})();
	
	if (!window.FileReader) {
	  window.FileReader = function () {
	    var _this = this, loadStarted = false;
	    this.listeners = {};
	    this.addEventListener = function (type, fn) {
	      _this.listeners[type] = _this.listeners[type] || [];
	      _this.listeners[type].push(fn);
	    };
	    this.removeEventListener = function (type, fn) {
	      if (_this.listeners[type]) _this.listeners[type].splice(_this.listeners[type].indexOf(fn), 1);
	    };
	    this.dispatchEvent = function (evt) {
	      var list = _this.listeners[evt.type];
	      if (list) {
	        for (var i = 0; i < list.length; i++) {
	          list[i].call(_this, evt);
	        }
	      }
	    };
	    this.onabort = this.onerror = this.onload = this.onloadstart = this.onloadend = this.onprogress = null;
	
	    var constructEvent = function (type, evt) {
	      var e = {type: type, target: _this, loaded: evt.loaded, total: evt.total, error: evt.error};
	      if (evt.result != null) e.target.result = evt.result;
	      return e;
	    };
	    var listener = function (evt) {
	      if (!loadStarted) {
	        loadStarted = true;
	        if (_this.onloadstart) _this.onloadstart(constructEvent('loadstart', evt));
	      }
	      var e;
	      if (evt.type === 'load') {
	        if (_this.onloadend) _this.onloadend(constructEvent('loadend', evt));
	        e = constructEvent('load', evt);
	        if (_this.onload) _this.onload(e);
	        _this.dispatchEvent(e);
	      } else if (evt.type === 'progress') {
	        e = constructEvent('progress', evt);
	        if (_this.onprogress) _this.onprogress(e);
	        _this.dispatchEvent(e);
	      } else {
	        e = constructEvent('error', evt);
	        if (_this.onerror) _this.onerror(e);
	        _this.dispatchEvent(e);
	      }
	    };
	    this.readAsDataURL = function (file) {
	      FileAPI.readAsDataURL(file, listener);
	    };
	    this.readAsText = function (file) {
	      FileAPI.readAsText(file, listener);
	    };
	  };
	}
	
	/**!
	 * AngularJS file upload directives and services. Supoorts: file upload/drop/paste, resume, cancel/abort,
	 * progress, resize, thumbnail, preview, validation and CORS
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 12.2.13
	 */
	
	if (window.XMLHttpRequest && !(window.FileAPI && FileAPI.shouldLoad)) {
	  window.XMLHttpRequest.prototype.setRequestHeader = (function (orig) {
	    return function (header, value) {
	      if (header === '__setXHR_') {
	        var val = value(this);
	        // fix for angular < 1.2.0
	        if (val instanceof Function) {
	          val(this);
	        }
	      } else {
	        orig.apply(this, arguments);
	      }
	    };
	  })(window.XMLHttpRequest.prototype.setRequestHeader);
	}
	
	var ngFileUpload = angular.module('ngFileUpload', []);
	
	ngFileUpload.version = '12.2.13';
	
	ngFileUpload.service('UploadBase', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
	  var upload = this;
	  upload.promisesCount = 0;
	
	  this.isResumeSupported = function () {
	    return window.Blob && window.Blob.prototype.slice;
	  };
	
	  var resumeSupported = this.isResumeSupported();
	
	  function sendHttp(config) {
	    config.method = config.method || 'POST';
	    config.headers = config.headers || {};
	
	    var deferred = config._deferred = config._deferred || $q.defer();
	    var promise = deferred.promise;
	
	    function notifyProgress(e) {
	      if (deferred.notify) {
	        deferred.notify(e);
	      }
	      if (promise.progressFunc) {
	        $timeout(function () {
	          promise.progressFunc(e);
	        });
	      }
	    }
	
	    function getNotifyEvent(n) {
	      if (config._start != null && resumeSupported) {
	        return {
	          loaded: n.loaded + config._start,
	          total: (config._file && config._file.size) || n.total,
	          type: n.type, config: config,
	          lengthComputable: true, target: n.target
	        };
	      } else {
	        return n;
	      }
	    }
	
	    if (!config.disableProgress) {
	      config.headers.__setXHR_ = function () {
	        return function (xhr) {
	          if (!xhr || !xhr.upload || !xhr.upload.addEventListener) return;
	          config.__XHR = xhr;
	          if (config.xhrFn) config.xhrFn(xhr);
	          xhr.upload.addEventListener('progress', function (e) {
	            e.config = config;
	            notifyProgress(getNotifyEvent(e));
	          }, false);
	          //fix for firefox not firing upload progress end, also IE8-9
	          xhr.upload.addEventListener('load', function (e) {
	            if (e.lengthComputable) {
	              e.config = config;
	              notifyProgress(getNotifyEvent(e));
	            }
	          }, false);
	        };
	      };
	    }
	
	    function uploadWithAngular() {
	      $http(config).then(function (r) {
	          if (resumeSupported && config._chunkSize && !config._finished && config._file) {
	            var fileSize = config._file && config._file.size || 0;
	            notifyProgress({
	                loaded: Math.min(config._end, fileSize),
	                total: fileSize,
	                config: config,
	                type: 'progress'
	              }
	            );
	            upload.upload(config, true);
	          } else {
	            if (config._finished) delete config._finished;
	            deferred.resolve(r);
	          }
	        }, function (e) {
	          deferred.reject(e);
	        }, function (n) {
	          deferred.notify(n);
	        }
	      );
	    }
	
	    if (!resumeSupported) {
	      uploadWithAngular();
	    } else if (config._chunkSize && config._end && !config._finished) {
	      config._start = config._end;
	      config._end += config._chunkSize;
	      uploadWithAngular();
	    } else if (config.resumeSizeUrl) {
	      $http.get(config.resumeSizeUrl).then(function (resp) {
	        if (config.resumeSizeResponseReader) {
	          config._start = config.resumeSizeResponseReader(resp.data);
	        } else {
	          config._start = parseInt((resp.data.size == null ? resp.data : resp.data.size).toString());
	        }
	        if (config._chunkSize) {
	          config._end = config._start + config._chunkSize;
	        }
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else if (config.resumeSize) {
	      config.resumeSize().then(function (size) {
	        config._start = size;
	        if (config._chunkSize) {
	          config._end = config._start + config._chunkSize;
	        }
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else {
	      if (config._chunkSize) {
	        config._start = 0;
	        config._end = config._start + config._chunkSize;
	      }
	      uploadWithAngular();
	    }
	
	
	    promise.success = function (fn) {
	      promise.then(function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.error = function (fn) {
	      promise.then(null, function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.progress = function (fn) {
	      promise.progressFunc = fn;
	      promise.then(null, null, function (n) {
	        fn(n);
	      });
	      return promise;
	    };
	    promise.abort = promise.pause = function () {
	      if (config.__XHR) {
	        $timeout(function () {
	          config.__XHR.abort();
	        });
	      }
	      return promise;
	    };
	    promise.xhr = function (fn) {
	      config.xhrFn = (function (origXhrFn) {
	        return function () {
	          if (origXhrFn) origXhrFn.apply(promise, arguments);
	          fn.apply(promise, arguments);
	        };
	      })(config.xhrFn);
	      return promise;
	    };
	
	    upload.promisesCount++;
	    if (promise['finally'] && promise['finally'] instanceof Function) {
	      promise['finally'](function () {
	        upload.promisesCount--;
	      });
	    }
	    return promise;
	  }
	
	  this.isUploadInProgress = function () {
	    return upload.promisesCount > 0;
	  };
	
	  this.rename = function (file, name) {
	    file.ngfName = name;
	    return file;
	  };
	
	  this.jsonBlob = function (val) {
	    if (val != null && !angular.isString(val)) {
	      val = JSON.stringify(val);
	    }
	    var blob = new window.Blob([val], {type: 'application/json'});
	    blob._ngfBlob = true;
	    return blob;
	  };
	
	  this.json = function (val) {
	    return angular.toJson(val);
	  };
	
	  function copy(obj) {
	    var clone = {};
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        clone[key] = obj[key];
	      }
	    }
	    return clone;
	  }
	
	  this.isFile = function (file) {
	    return file != null && (file instanceof window.Blob || (file.flashId && file.name && file.size));
	  };
	
	  this.upload = function (config, internal) {
	    function toResumeFile(file, formData) {
	      if (file._ngfBlob) return file;
	      config._file = config._file || file;
	      if (config._start != null && resumeSupported) {
	        if (config._end && config._end >= file.size) {
	          config._finished = true;
	          config._end = file.size;
	        }
	        var slice = file.slice(config._start, config._end || file.size);
	        slice.name = file.name;
	        slice.ngfName = file.ngfName;
	        if (config._chunkSize) {
	          formData.append('_chunkSize', config._chunkSize);
	          formData.append('_currentChunkSize', config._end - config._start);
	          formData.append('_chunkNumber', Math.floor(config._start / config._chunkSize));
	          formData.append('_totalSize', config._file.size);
	        }
	        return slice;
	      }
	      return file;
	    }
	
	    function addFieldToFormData(formData, val, key) {
	      if (val !== undefined) {
	        if (angular.isDate(val)) {
	          val = val.toISOString();
	        }
	        if (angular.isString(val)) {
	          formData.append(key, val);
	        } else if (upload.isFile(val)) {
	          var file = toResumeFile(val, formData);
	          var split = key.split(',');
	          if (split[1]) {
	            file.ngfName = split[1].replace(/^\s+|\s+$/g, '');
	            key = split[0];
	          }
	          config._fileKey = config._fileKey || key;
	          formData.append(key, file, file.ngfName || file.name);
	        } else {
	          if (angular.isObject(val)) {
	            if (val.$$ngfCircularDetection) throw 'ngFileUpload: Circular reference in config.data. Make sure specified data for Upload.upload() has no circular reference: ' + key;
	
	            val.$$ngfCircularDetection = true;
	            try {
	              for (var k in val) {
	                if (val.hasOwnProperty(k) && k !== '$$ngfCircularDetection') {
	                  var objectKey = config.objectKey == null ? '[i]' : config.objectKey;
	                  if (val.length && parseInt(k) > -1) {
	                    objectKey = config.arrayKey == null ? objectKey : config.arrayKey;
	                  }
	                  addFieldToFormData(formData, val[k], key + objectKey.replace(/[ik]/g, k));
	                }
	              }
	            } finally {
	              delete val.$$ngfCircularDetection;
	            }
	          } else {
	            formData.append(key, val);
	          }
	        }
	      }
	    }
	
	    function digestConfig() {
	      config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	      config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	      config.headers = config.headers || {};
	      config.headers['Content-Type'] = undefined;
	      config.transformRequest = config.transformRequest ?
	        (angular.isArray(config.transformRequest) ?
	          config.transformRequest : [config.transformRequest]) : [];
	      config.transformRequest.push(function (data) {
	        var formData = new window.FormData(), key;
	        data = data || config.fields || {};
	        if (config.file) {
	          data.file = config.file;
	        }
	        for (key in data) {
	          if (data.hasOwnProperty(key)) {
	            var val = data[key];
	            if (config.formDataAppender) {
	              config.formDataAppender(formData, key, val);
	            } else {
	              addFieldToFormData(formData, val, key);
	            }
	          }
	        }
	
	        return formData;
	      });
	    }
	
	    if (!internal) config = copy(config);
	    if (!config._isDigested) {
	      config._isDigested = true;
	      digestConfig();
	    }
	
	    return sendHttp(config);
	  };
	
	  this.http = function (config) {
	    config = copy(config);
	    config.transformRequest = config.transformRequest || function (data) {
	        if ((window.ArrayBuffer && data instanceof window.ArrayBuffer) || data instanceof window.Blob) {
	          return data;
	        }
	        return $http.defaults.transformRequest[0].apply(this, arguments);
	      };
	    config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	    config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	    return sendHttp(config);
	  };
	
	  this.translateScalars = function (str) {
	    if (angular.isString(str)) {
	      if (str.search(/kb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1024);
	      } else if (str.search(/mb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1048576);
	      } else if (str.search(/gb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1073741824);
	      } else if (str.search(/b/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/s/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/m/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 60);
	      } else if (str.search(/h/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 3600);
	      }
	    }
	    return str;
	  };
	
	  this.urlToBlob = function(url) {
	    var defer = $q.defer();
	    $http({url: url, method: 'get', responseType: 'arraybuffer'}).then(function (resp) {
	      var arrayBufferView = new Uint8Array(resp.data);
	      var type = resp.headers('content-type') || 'image/WebP';
	      var blob = new window.Blob([arrayBufferView], {type: type});
	      var matches = url.match(/.*\/(.+?)(\?.*)?$/);
	      if (matches.length > 1) {
	        blob.name = matches[1];
	      }
	      defer.resolve(blob);
	    }, function (e) {
	      defer.reject(e);
	    });
	    return defer.promise;
	  };
	
	  this.setDefaults = function (defaults) {
	    this.defaults = defaults || {};
	  };
	
	  this.defaults = {};
	  this.version = ngFileUpload.version;
	}
	
	]);
	
	ngFileUpload.service('Upload', ['$parse', '$timeout', '$compile', '$q', 'UploadExif', function ($parse, $timeout, $compile, $q, UploadExif) {
	  var upload = UploadExif;
	  upload.getAttrWithDefaults = function (attr, name) {
	    if (attr[name] != null) return attr[name];
	    var def = upload.defaults[name];
	    return (def == null ? def : (angular.isString(def) ? def : JSON.stringify(def)));
	  };
	
	  upload.attrGetter = function (name, attr, scope, params) {
	    var attrVal = this.getAttrWithDefaults(attr, name);
	    if (scope) {
	      try {
	        if (params) {
	          return $parse(attrVal)(scope, params);
	        } else {
	          return $parse(attrVal)(scope);
	        }
	      } catch (e) {
	        // hangle string value without single qoute
	        if (name.search(/min|max|pattern/i)) {
	          return attrVal;
	        } else {
	          throw e;
	        }
	      }
	    } else {
	      return attrVal;
	    }
	  };
	
	  upload.shouldUpdateOn = function (type, attr, scope) {
	    var modelOptions = upload.attrGetter('ngfModelOptions', attr, scope);
	    if (modelOptions && modelOptions.updateOn) {
	      return modelOptions.updateOn.split(' ').indexOf(type) > -1;
	    }
	    return true;
	  };
	
	  upload.emptyPromise = function () {
	    var d = $q.defer();
	    var args = arguments;
	    $timeout(function () {
	      d.resolve.apply(d, args);
	    });
	    return d.promise;
	  };
	
	  upload.rejectPromise = function () {
	    var d = $q.defer();
	    var args = arguments;
	    $timeout(function () {
	      d.reject.apply(d, args);
	    });
	    return d.promise;
	  };
	
	  upload.happyPromise = function (promise, data) {
	    var d = $q.defer();
	    promise.then(function (result) {
	      d.resolve(result);
	    }, function (error) {
	      $timeout(function () {
	        throw error;
	      });
	      d.resolve(data);
	    });
	    return d.promise;
	  };
	
	  function applyExifRotations(files, attr, scope) {
	    var promises = [upload.emptyPromise()];
	    angular.forEach(files, function (f, i) {
	      if (f.type.indexOf('image/jpeg') === 0 && upload.attrGetter('ngfFixOrientation', attr, scope, {$file: f})) {
	        promises.push(upload.happyPromise(upload.applyExifRotation(f), f).then(function (fixedFile) {
	          files.splice(i, 1, fixedFile);
	        }));
	      }
	    });
	    return $q.all(promises);
	  }
	
	  function resizeFile(files, attr, scope, ngModel) {
	    var resizeVal = upload.attrGetter('ngfResize', attr, scope);
	    if (!resizeVal || !upload.isResizeSupported() || !files.length) return upload.emptyPromise();
	    if (resizeVal instanceof Function) {
	      var defer = $q.defer();
	      return resizeVal(files).then(function (p) {
	        resizeWithParams(p, files, attr, scope, ngModel).then(function (r) {
	          defer.resolve(r);
	        }, function (e) {
	          defer.reject(e);
	        });
	      }, function (e) {
	        defer.reject(e);
	      });
	    } else {
	      return resizeWithParams(resizeVal, files, attr, scope, ngModel);
	    }
	  }
	
	  function resizeWithParams(params, files, attr, scope, ngModel) {
	    var promises = [upload.emptyPromise()];
	
	    function handleFile(f, i) {
	      if (f.type.indexOf('image') === 0) {
	        if (params.pattern && !upload.validatePattern(f, params.pattern)) return;
	        params.resizeIf = function (width, height) {
	          return upload.attrGetter('ngfResizeIf', attr, scope,
	            {$width: width, $height: height, $file: f});
	        };
	        var promise = upload.resize(f, params);
	        promises.push(promise);
	        promise.then(function (resizedFile) {
	          files.splice(i, 1, resizedFile);
	        }, function (e) {
	          f.$error = 'resize';
	          (f.$errorMessages = (f.$errorMessages || {})).resize = true;
	          f.$errorParam = (e ? (e.message ? e.message : e) + ': ' : '') + (f && f.name);
	          ngModel.$ngfValidations.push({name: 'resize', valid: false});
	          upload.applyModelValidation(ngModel, files);
	        });
	      }
	    }
	
	    for (var i = 0; i < files.length; i++) {
	      handleFile(files[i], i);
	    }
	    return $q.all(promises);
	  }
	
	  upload.updateModel = function (ngModel, attr, scope, fileChange, files, evt, noDelay) {
	    function update(files, invalidFiles, newFiles, dupFiles, isSingleModel) {
	      attr.$$ngfPrevValidFiles = files;
	      attr.$$ngfPrevInvalidFiles = invalidFiles;
	      var file = files && files.length ? files[0] : null;
	      var invalidFile = invalidFiles && invalidFiles.length ? invalidFiles[0] : null;
	
	      if (ngModel) {
	        upload.applyModelValidation(ngModel, files);
	        ngModel.$setViewValue(isSingleModel ? file : files);
	      }
	
	      if (fileChange) {
	        $parse(fileChange)(scope, {
	          $files: files,
	          $file: file,
	          $newFiles: newFiles,
	          $duplicateFiles: dupFiles,
	          $invalidFiles: invalidFiles,
	          $invalidFile: invalidFile,
	          $event: evt
	        });
	      }
	
	      var invalidModel = upload.attrGetter('ngfModelInvalid', attr);
	      if (invalidModel) {
	        $timeout(function () {
	          $parse(invalidModel).assign(scope, isSingleModel ? invalidFile : invalidFiles);
	        });
	      }
	      $timeout(function () {
	        // scope apply changes
	      });
	    }
	
	    var allNewFiles, dupFiles = [], prevValidFiles, prevInvalidFiles,
	      invalids = [], valids = [];
	
	    function removeDuplicates() {
	      function equals(f1, f2) {
	        return f1.name === f2.name && (f1.$ngfOrigSize || f1.size) === (f2.$ngfOrigSize || f2.size) &&
	          f1.type === f2.type;
	      }
	
	      function isInPrevFiles(f) {
	        var j;
	        for (j = 0; j < prevValidFiles.length; j++) {
	          if (equals(f, prevValidFiles[j])) {
	            return true;
	          }
	        }
	        for (j = 0; j < prevInvalidFiles.length; j++) {
	          if (equals(f, prevInvalidFiles[j])) {
	            return true;
	          }
	        }
	        return false;
	      }
	
	      if (files) {
	        allNewFiles = [];
	        dupFiles = [];
	        for (var i = 0; i < files.length; i++) {
	          if (isInPrevFiles(files[i])) {
	            dupFiles.push(files[i]);
	          } else {
	            allNewFiles.push(files[i]);
	          }
	        }
	      }
	    }
	
	    function toArray(v) {
	      return angular.isArray(v) ? v : [v];
	    }
	
	    function resizeAndUpdate() {
	      function updateModel() {
	        $timeout(function () {
	          update(keep ? prevValidFiles.concat(valids) : valids,
	            keep ? prevInvalidFiles.concat(invalids) : invalids,
	            files, dupFiles, isSingleModel);
	        }, options && options.debounce ? options.debounce.change || options.debounce : 0);
	      }
	
	      var resizingFiles = validateAfterResize ? allNewFiles : valids;
	      resizeFile(resizingFiles, attr, scope, ngModel).then(function () {
	        if (validateAfterResize) {
	          upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
	            .then(function (validationResult) {
	              valids = validationResult.validsFiles;
	              invalids = validationResult.invalidsFiles;
	              updateModel();
	            });
	        } else {
	          updateModel();
	        }
	      }, function () {
	        for (var i = 0; i < resizingFiles.length; i++) {
	          var f = resizingFiles[i];
	          if (f.$error === 'resize') {
	            var index = valids.indexOf(f);
	            if (index > -1) {
	              valids.splice(index, 1);
	              invalids.push(f);
	            }
	            updateModel();
	          }
	        }
	      });
	    }
	
	    prevValidFiles = attr.$$ngfPrevValidFiles || [];
	    prevInvalidFiles = attr.$$ngfPrevInvalidFiles || [];
	    if (ngModel && ngModel.$modelValue) {
	      prevValidFiles = toArray(ngModel.$modelValue);
	    }
	
	    var keep = upload.attrGetter('ngfKeep', attr, scope);
	    allNewFiles = (files || []).slice(0);
	    if (keep === 'distinct' || upload.attrGetter('ngfKeepDistinct', attr, scope) === true) {
	      removeDuplicates(attr, scope);
	    }
	
	    var isSingleModel = !keep && !upload.attrGetter('ngfMultiple', attr, scope) && !upload.attrGetter('multiple', attr);
	
	    if (keep && !allNewFiles.length) return;
	
	    upload.attrGetter('ngfBeforeModelChange', attr, scope, {
	      $files: files,
	      $file: files && files.length ? files[0] : null,
	      $newFiles: allNewFiles,
	      $duplicateFiles: dupFiles,
	      $event: evt
	    });
	
	    var validateAfterResize = upload.attrGetter('ngfValidateAfterResize', attr, scope);
	
	    var options = upload.attrGetter('ngfModelOptions', attr, scope);
	    upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
	      .then(function (validationResult) {
	      if (noDelay) {
	        update(allNewFiles, [], files, dupFiles, isSingleModel);
	      } else {
	        if ((!options || !options.allowInvalid) && !validateAfterResize) {
	          valids = validationResult.validFiles;
	          invalids = validationResult.invalidFiles;
	        } else {
	          valids = allNewFiles;
	        }
	        if (upload.attrGetter('ngfFixOrientation', attr, scope) && upload.isExifSupported()) {
	          applyExifRotations(valids, attr, scope).then(function () {
	            resizeAndUpdate();
	          });
	        } else {
	          resizeAndUpdate();
	        }
	      }
	    });
	  };
	
	  return upload;
	}]);
	
	ngFileUpload.directive('ngfSelect', ['$parse', '$timeout', '$compile', 'Upload', function ($parse, $timeout, $compile, Upload) {
	  var generatedElems = [];
	
	  function isDelayedClickSupported(ua) {
	    // fix for android native browser < 4.4 and safari windows
	    var m = ua.match(/Android[^\d]*(\d+)\.(\d+)/);
	    if (m && m.length > 2) {
	      var v = Upload.defaults.androidFixMinorVersion || 4;
	      return parseInt(m[1]) < 4 || (parseInt(m[1]) === v && parseInt(m[2]) < v);
	    }
	
	    // safari on windows
	    return ua.indexOf('Chrome') === -1 && /.*Windows.*Safari.*/.test(ua);
	  }
	
	  function linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, upload) {
	    /** @namespace attr.ngfSelect */
	    /** @namespace attr.ngfChange */
	    /** @namespace attr.ngModel */
	    /** @namespace attr.ngfModelOptions */
	    /** @namespace attr.ngfMultiple */
	    /** @namespace attr.ngfCapture */
	    /** @namespace attr.ngfValidate */
	    /** @namespace attr.ngfKeep */
	    var attrGetter = function (name, scope) {
	      return upload.attrGetter(name, attr, scope);
	    };
	
	    function isInputTypeFile() {
	      return elem[0].tagName.toLowerCase() === 'input' && attr.type && attr.type.toLowerCase() === 'file';
	    }
	
	    function fileChangeAttr() {
	      return attrGetter('ngfChange') || attrGetter('ngfSelect');
	    }
	
	    function changeFn(evt) {
	      if (upload.shouldUpdateOn('change', attr, scope)) {
	        var fileList = evt.__files_ || (evt.target && evt.target.files), files = [];
	        /* Handle duplicate call in  IE11 */
	        if (!fileList) return;
	        for (var i = 0; i < fileList.length; i++) {
	          files.push(fileList[i]);
	        }
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(),
	          files.length ? files : null, evt);
	      }
	    }
	
	    upload.registerModelChangeValidator(ngModel, attr, scope);
	
	    var unwatches = [];
	    if (attrGetter('ngfMultiple')) {
	      unwatches.push(scope.$watch(attrGetter('ngfMultiple'), function () {
	        fileElem.attr('multiple', attrGetter('ngfMultiple', scope));
	      }));
	    }
	    if (attrGetter('ngfCapture')) {
	      unwatches.push(scope.$watch(attrGetter('ngfCapture'), function () {
	        fileElem.attr('capture', attrGetter('ngfCapture', scope));
	      }));
	    }
	    if (attrGetter('ngfAccept')) {
	      unwatches.push(scope.$watch(attrGetter('ngfAccept'), function () {
	        fileElem.attr('accept', attrGetter('ngfAccept', scope));
	      }));
	    }
	    unwatches.push(attr.$observe('accept', function () {
	      fileElem.attr('accept', attrGetter('accept'));
	    }));
	    function bindAttrToFileInput(fileElem, label) {
	      function updateId(val) {
	        fileElem.attr('id', 'ngf-' + val);
	        label.attr('id', 'ngf-label-' + val);
	      }
	
	      for (var i = 0; i < elem[0].attributes.length; i++) {
	        var attribute = elem[0].attributes[i];
	        if (attribute.name !== 'type' && attribute.name !== 'class' && attribute.name !== 'style') {
	          if (attribute.name === 'id') {
	            updateId(attribute.value);
	            unwatches.push(attr.$observe('id', updateId));
	          } else {
	            fileElem.attr(attribute.name, (!attribute.value && (attribute.name === 'required' ||
	            attribute.name === 'multiple')) ? attribute.name : attribute.value);
	          }
	        }
	      }
	    }
	
	    function createFileInput() {
	      if (isInputTypeFile()) {
	        return elem;
	      }
	
	      var fileElem = angular.element('<input type="file">');
	
	      var label = angular.element('<label>upload</label>');
	      label.css('visibility', 'hidden').css('position', 'absolute').css('overflow', 'hidden')
	        .css('width', '0px').css('height', '0px').css('border', 'none')
	        .css('margin', '0px').css('padding', '0px').attr('tabindex', '-1');
	      bindAttrToFileInput(fileElem, label);
	
	      generatedElems.push({el: elem, ref: label});
	
	      document.body.appendChild(label.append(fileElem)[0]);
	
	      return fileElem;
	    }
	
	    function clickHandler(evt) {
	      if (elem.attr('disabled')) return false;
	      if (attrGetter('ngfSelectDisabled', scope)) return;
	
	      var r = detectSwipe(evt);
	      // prevent the click if it is a swipe
	      if (r != null) return r;
	
	      resetModel(evt);
	
	      // fix for md when the element is removed from the DOM and added back #460
	      try {
	        if (!isInputTypeFile() && !document.body.contains(fileElem[0])) {
	          generatedElems.push({el: elem, ref: fileElem.parent()});
	          document.body.appendChild(fileElem.parent()[0]);
	          fileElem.bind('change', changeFn);
	        }
	      } catch (e) {/*ignore*/
	      }
	
	      if (isDelayedClickSupported(navigator.userAgent)) {
	        setTimeout(function () {
	          fileElem[0].click();
	        }, 0);
	      } else {
	        fileElem[0].click();
	      }
	
	      return false;
	    }
	
	
	    var initialTouchStartY = 0;
	    var initialTouchStartX = 0;
	
	    function detectSwipe(evt) {
	      var touches = evt.changedTouches || (evt.originalEvent && evt.originalEvent.changedTouches);
	      if (touches) {
	        if (evt.type === 'touchstart') {
	          initialTouchStartX = touches[0].clientX;
	          initialTouchStartY = touches[0].clientY;
	          return true; // don't block event default
	        } else {
	          // prevent scroll from triggering event
	          if (evt.type === 'touchend') {
	            var currentX = touches[0].clientX;
	            var currentY = touches[0].clientY;
	            if ((Math.abs(currentX - initialTouchStartX) > 20) ||
	              (Math.abs(currentY - initialTouchStartY) > 20)) {
	              evt.stopPropagation();
	              evt.preventDefault();
	              return false;
	            }
	          }
	          return true;
	        }
	      }
	    }
	
	    var fileElem = elem;
	
	    function resetModel(evt) {
	      if (upload.shouldUpdateOn('click', attr, scope) && fileElem.val()) {
	        fileElem.val(null);
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(), null, evt, true);
	      }
	    }
	
	    if (!isInputTypeFile()) {
	      fileElem = createFileInput();
	    }
	    fileElem.bind('change', changeFn);
	
	    if (!isInputTypeFile()) {
	      elem.bind('click touchstart touchend', clickHandler);
	    } else {
	      elem.bind('click', resetModel);
	    }
	
	    function ie10SameFileSelectFix(evt) {
	      if (fileElem && !fileElem.attr('__ngf_ie10_Fix_')) {
	        if (!fileElem[0].parentNode) {
	          fileElem = null;
	          return;
	        }
	        evt.preventDefault();
	        evt.stopPropagation();
	        fileElem.unbind('click');
	        var clone = fileElem.clone();
	        fileElem.replaceWith(clone);
	        fileElem = clone;
	        fileElem.attr('__ngf_ie10_Fix_', 'true');
	        fileElem.bind('change', changeFn);
	        fileElem.bind('click', ie10SameFileSelectFix);
	        fileElem[0].click();
	        return false;
	      } else {
	        fileElem.removeAttr('__ngf_ie10_Fix_');
	      }
	    }
	
	    if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
	      fileElem.bind('click', ie10SameFileSelectFix);
	    }
	
	    if (ngModel) ngModel.$formatters.push(function (val) {
	      if (val == null || val.length === 0) {
	        if (fileElem.val()) {
	          fileElem.val(null);
	        }
	      }
	      return val;
	    });
	
	    scope.$on('$destroy', function () {
	      if (!isInputTypeFile()) fileElem.parent().remove();
	      angular.forEach(unwatches, function (unwatch) {
	        unwatch();
	      });
	    });
	
	    $timeout(function () {
	      for (var i = 0; i < generatedElems.length; i++) {
	        var g = generatedElems[i];
	        if (!document.body.contains(g.el[0])) {
	          generatedElems.splice(i, 1);
	          g.ref.remove();
	        }
	      }
	    });
	
	    if (window.FileAPI && window.FileAPI.ngfFixIE) {
	      window.FileAPI.ngfFixIE(elem, fileElem, changeFn);
	    }
	  }
	
	  return {
	    restrict: 'AEC',
	    require: '?ngModel',
	    link: function (scope, elem, attr, ngModel) {
	      linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, Upload);
	    }
	  };
	}]);
	
	(function () {
	
	  ngFileUpload.service('UploadDataUrl', ['UploadBase', '$timeout', '$q', function (UploadBase, $timeout, $q) {
	    var upload = UploadBase;
	    upload.base64DataUrl = function (file) {
	      if (angular.isArray(file)) {
	        var d = $q.defer(), count = 0;
	        angular.forEach(file, function (f) {
	          upload.dataUrl(f, true)['finally'](function () {
	            count++;
	            if (count === file.length) {
	              var urls = [];
	              angular.forEach(file, function (ff) {
	                urls.push(ff.$ngfDataUrl);
	              });
	              d.resolve(urls, file);
	            }
	          });
	        });
	        return d.promise;
	      } else {
	        return upload.dataUrl(file, true);
	      }
	    };
	    upload.dataUrl = function (file, disallowObjectUrl) {
	      if (!file) return upload.emptyPromise(file, file);
	      if ((disallowObjectUrl && file.$ngfDataUrl != null) || (!disallowObjectUrl && file.$ngfBlobUrl != null)) {
	        return upload.emptyPromise(disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl, file);
	      }
	      var p = disallowObjectUrl ? file.$$ngfDataUrlPromise : file.$$ngfBlobUrlPromise;
	      if (p) return p;
	
	      var deferred = $q.defer();
	      $timeout(function () {
	        if (window.FileReader && file &&
	          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 8') === -1 || file.size < 20000) &&
	          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 9') === -1 || file.size < 4000000)) {
	          //prefer URL.createObjectURL for handling refrences to files of all sizes
	          //since it doesn´t build a large string in memory
	          var URL = window.URL || window.webkitURL;
	          if (URL && URL.createObjectURL && !disallowObjectUrl) {
	            var url;
	            try {
	              url = URL.createObjectURL(file);
	            } catch (e) {
	              $timeout(function () {
	                file.$ngfBlobUrl = '';
	                deferred.reject();
	              });
	              return;
	            }
	            $timeout(function () {
	              file.$ngfBlobUrl = url;
	              if (url) {
	                deferred.resolve(url, file);
	                upload.blobUrls = upload.blobUrls || [];
	                upload.blobUrlsTotalSize = upload.blobUrlsTotalSize || 0;
	                upload.blobUrls.push({url: url, size: file.size});
	                upload.blobUrlsTotalSize += file.size || 0;
	                var maxMemory = upload.defaults.blobUrlsMaxMemory || 268435456;
	                var maxLength = upload.defaults.blobUrlsMaxQueueSize || 200;
	                while ((upload.blobUrlsTotalSize > maxMemory || upload.blobUrls.length > maxLength) && upload.blobUrls.length > 1) {
	                  var obj = upload.blobUrls.splice(0, 1)[0];
	                  URL.revokeObjectURL(obj.url);
	                  upload.blobUrlsTotalSize -= obj.size;
	                }
	              }
	            });
	          } else {
	            var fileReader = new FileReader();
	            fileReader.onload = function (e) {
	              $timeout(function () {
	                file.$ngfDataUrl = e.target.result;
	                deferred.resolve(e.target.result, file);
	                $timeout(function () {
	                  delete file.$ngfDataUrl;
	                }, 1000);
	              });
	            };
	            fileReader.onerror = function () {
	              $timeout(function () {
	                file.$ngfDataUrl = '';
	                deferred.reject();
	              });
	            };
	            fileReader.readAsDataURL(file);
	          }
	        } else {
	          $timeout(function () {
	            file[disallowObjectUrl ? '$ngfDataUrl' : '$ngfBlobUrl'] = '';
	            deferred.reject();
	          });
	        }
	      });
	
	      if (disallowObjectUrl) {
	        p = file.$$ngfDataUrlPromise = deferred.promise;
	      } else {
	        p = file.$$ngfBlobUrlPromise = deferred.promise;
	      }
	      p['finally'](function () {
	        delete file[disallowObjectUrl ? '$$ngfDataUrlPromise' : '$$ngfBlobUrlPromise'];
	      });
	      return p;
	    };
	    return upload;
	  }]);
	
	  function getTagType(el) {
	    if (el.tagName.toLowerCase() === 'img') return 'image';
	    if (el.tagName.toLowerCase() === 'audio') return 'audio';
	    if (el.tagName.toLowerCase() === 'video') return 'video';
	    return /./;
	  }
	
	  function linkFileDirective(Upload, $timeout, scope, elem, attr, directiveName, resizeParams, isBackground) {
	    function constructDataUrl(file) {
	      var disallowObjectUrl = Upload.attrGetter('ngfNoObjectUrl', attr, scope);
	      Upload.dataUrl(file, disallowObjectUrl)['finally'](function () {
	        $timeout(function () {
	          var src = (disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl;
	          if (isBackground) {
	            elem.css('background-image', 'url(\'' + (src || '') + '\')');
	          } else {
	            elem.attr('src', src);
	          }
	          if (src) {
	            elem.removeClass('ng-hide');
	          } else {
	            elem.addClass('ng-hide');
	          }
	        });
	      });
	    }
	
	    $timeout(function () {
	      var unwatch = scope.$watch(attr[directiveName], function (file) {
	        var size = resizeParams;
	        if (directiveName === 'ngfThumbnail') {
	          if (!size) {
	            size = {
	              width: elem[0].naturalWidth || elem[0].clientWidth,
	              height: elem[0].naturalHeight || elem[0].clientHeight
	            };
	          }
	          if (size.width === 0 && window.getComputedStyle) {
	            var style = getComputedStyle(elem[0]);
	            if (style.width && style.width.indexOf('px') > -1 && style.height && style.height.indexOf('px') > -1) {
	              size = {
	                width: parseInt(style.width.slice(0, -2)),
	                height: parseInt(style.height.slice(0, -2))
	              };
	            }
	          }
	        }
	
	        if (angular.isString(file)) {
	          elem.removeClass('ng-hide');
	          if (isBackground) {
	            return elem.css('background-image', 'url(\'' + file + '\')');
	          } else {
	            return elem.attr('src', file);
	          }
	        }
	        if (file && file.type && file.type.search(getTagType(elem[0])) === 0 &&
	          (!isBackground || file.type.indexOf('image') === 0)) {
	          if (size && Upload.isResizeSupported()) {
	            size.resizeIf = function (width, height) {
	              return Upload.attrGetter('ngfResizeIf', attr, scope,
	                {$width: width, $height: height, $file: file});
	            };
	            Upload.resize(file, size).then(
	              function (f) {
	                constructDataUrl(f);
	              }, function (e) {
	                throw e;
	              }
	            );
	          } else {
	            constructDataUrl(file);
	          }
	        } else {
	          elem.addClass('ng-hide');
	        }
	      });
	
	      scope.$on('$destroy', function () {
	        unwatch();
	      });
	    });
	  }
	
	
	  /** @namespace attr.ngfSrc */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfSrc', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfSrc',
	          Upload.attrGetter('ngfResize', attr, scope), false);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfBackground */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfBackground', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfBackground',
	          Upload.attrGetter('ngfResize', attr, scope), true);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfThumbnail */
	  /** @namespace attr.ngfAsBackground */
	  /** @namespace attr.ngfSize */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfThumbnail', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        var size = Upload.attrGetter('ngfSize', attr, scope);
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfThumbnail', size,
	          Upload.attrGetter('ngfAsBackground', attr, scope));
	      }
	    };
	  }]);
	
	  ngFileUpload.config(['$compileProvider', function ($compileProvider) {
	    if ($compileProvider.imgSrcSanitizationWhitelist) $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
	    if ($compileProvider.aHrefSanitizationWhitelist) $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
	  }]);
	
	  ngFileUpload.filter('ngfDataUrl', ['UploadDataUrl', '$sce', function (UploadDataUrl, $sce) {
	    return function (file, disallowObjectUrl, trustedUrl) {
	      if (angular.isString(file)) {
	        return $sce.trustAsResourceUrl(file);
	      }
	      var src = file && ((disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl);
	      if (file && !src) {
	        if (!file.$ngfDataUrlFilterInProgress && angular.isObject(file)) {
	          file.$ngfDataUrlFilterInProgress = true;
	          UploadDataUrl.dataUrl(file, disallowObjectUrl);
	        }
	        return '';
	      }
	      if (file) delete file.$ngfDataUrlFilterInProgress;
	      return (file && src ? (trustedUrl ? $sce.trustAsResourceUrl(src) : src) : file) || '';
	    };
	  }]);
	
	})();
	
	ngFileUpload.service('UploadValidate', ['UploadDataUrl', '$q', '$timeout', function (UploadDataUrl, $q, $timeout) {
	  var upload = UploadDataUrl;
	
	  function globStringToRegex(str) {
	    var regexp = '', excludes = [];
	    if (str.length > 2 && str[0] === '/' && str[str.length - 1] === '/') {
	      regexp = str.substring(1, str.length - 1);
	    } else {
	      var split = str.split(',');
	      if (split.length > 1) {
	        for (var i = 0; i < split.length; i++) {
	          var r = globStringToRegex(split[i]);
	          if (r.regexp) {
	            regexp += '(' + r.regexp + ')';
	            if (i < split.length - 1) {
	              regexp += '|';
	            }
	          } else {
	            excludes = excludes.concat(r.excludes);
	          }
	        }
	      } else {
	        if (str.indexOf('!') === 0) {
	          excludes.push('^((?!' + globStringToRegex(str.substring(1)).regexp + ').)*$');
	        } else {
	          if (str.indexOf('.') === 0) {
	            str = '*' + str;
	          }
	          regexp = '^' + str.replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]', 'g'), '\\$&') + '$';
	          regexp = regexp.replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
	        }
	      }
	    }
	    return {regexp: regexp, excludes: excludes};
	  }
	
	  upload.validatePattern = function (file, val) {
	    if (!val) {
	      return true;
	    }
	    var pattern = globStringToRegex(val), valid = true;
	    if (pattern.regexp && pattern.regexp.length) {
	      var regexp = new RegExp(pattern.regexp, 'i');
	      valid = (file.type != null && regexp.test(file.type)) ||
	        (file.name != null && regexp.test(file.name));
	    }
	    var len = pattern.excludes.length;
	    while (len--) {
	      var exclude = new RegExp(pattern.excludes[len], 'i');
	      valid = valid && (file.type == null || exclude.test(file.type)) &&
	        (file.name == null || exclude.test(file.name));
	    }
	    return valid;
	  };
	
	  upload.ratioToFloat = function (val) {
	    var r = val.toString(), xIndex = r.search(/[x:]/i);
	    if (xIndex > -1) {
	      r = parseFloat(r.substring(0, xIndex)) / parseFloat(r.substring(xIndex + 1));
	    } else {
	      r = parseFloat(r);
	    }
	    return r;
	  };
	
	  upload.registerModelChangeValidator = function (ngModel, attr, scope) {
	    if (ngModel) {
	      ngModel.$formatters.push(function (files) {
	        if (ngModel.$dirty) {
	          var filesArray = files;
	          if (files && !angular.isArray(files)) {
	            filesArray = [files];
	          }
	          upload.validate(filesArray, 0, ngModel, attr, scope).then(function () {
	            upload.applyModelValidation(ngModel, filesArray);
	          });
	        }
	        return files;
	      });
	    }
	  };
	
	  function markModelAsDirty(ngModel, files) {
	    if (files != null && !ngModel.$dirty) {
	      if (ngModel.$setDirty) {
	        ngModel.$setDirty();
	      } else {
	        ngModel.$dirty = true;
	      }
	    }
	  }
	
	  upload.applyModelValidation = function (ngModel, files) {
	    markModelAsDirty(ngModel, files);
	    angular.forEach(ngModel.$ngfValidations, function (validation) {
	      ngModel.$setValidity(validation.name, validation.valid);
	    });
	  };
	
	  upload.getValidationAttr = function (attr, scope, name, validationName, file) {
	    var dName = 'ngf' + name[0].toUpperCase() + name.substr(1);
	    var val = upload.attrGetter(dName, attr, scope, {$file: file});
	    if (val == null) {
	      val = upload.attrGetter('ngfValidate', attr, scope, {$file: file});
	      if (val) {
	        var split = (validationName || name).split('.');
	        val = val[split[0]];
	        if (split.length > 1) {
	          val = val && val[split[1]];
	        }
	      }
	    }
	    return val;
	  };
	
	  upload.validate = function (files, prevLength, ngModel, attr, scope) {
	    ngModel = ngModel || {};
	    ngModel.$ngfValidations = ngModel.$ngfValidations || [];
	
	    angular.forEach(ngModel.$ngfValidations, function (v) {
	      v.valid = true;
	    });
	
	    var attrGetter = function (name, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    var ignoredErrors = (upload.attrGetter('ngfIgnoreInvalid', attr, scope) || '').split(' ');
	    var runAllValidation = upload.attrGetter('ngfRunAllValidations', attr, scope);
	
	    if (files == null || files.length === 0) {
	      return upload.emptyPromise({'validFiles': files, 'invalidFiles': []});
	    }
	
	    files = files.length === undefined ? [files] : files.slice(0);
	    var invalidFiles = [];
	
	    function validateSync(name, validationName, fn) {
	      if (files) {
	        var i = files.length, valid = null;
	        while (i--) {
	          var file = files[i];
	          if (file) {
	            var val = upload.getValidationAttr(attr, scope, name, validationName, file);
	            if (val != null) {
	              if (!fn(file, val, i)) {
	                if (ignoredErrors.indexOf(name) === -1) {
	                  file.$error = name;
	                  (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
	                  file.$errorParam = val;
	                  if (invalidFiles.indexOf(file) === -1) {
	                    invalidFiles.push(file);
	                  }
	                  if (!runAllValidation) {
	                    files.splice(i, 1);
	                  }
	                  valid = false;
	                } else {
	                  files.splice(i, 1);
	                }
	              }
	            }
	          }
	        }
	        if (valid !== null) {
	          ngModel.$ngfValidations.push({name: name, valid: valid});
	        }
	      }
	    }
	
	    validateSync('pattern', null, upload.validatePattern);
	    validateSync('minSize', 'size.min', function (file, val) {
	      return file.size + 0.1 >= upload.translateScalars(val);
	    });
	    validateSync('maxSize', 'size.max', function (file, val) {
	      return file.size - 0.1 <= upload.translateScalars(val);
	    });
	    var totalSize = 0;
	    validateSync('maxTotalSize', null, function (file, val) {
	      totalSize += file.size;
	      if (totalSize > upload.translateScalars(val)) {
	        files.splice(0, files.length);
	        return false;
	      }
	      return true;
	    });
	
	    validateSync('validateFn', null, function (file, r) {
	      return r === true || r === null || r === '';
	    });
	
	    if (!files.length) {
	      return upload.emptyPromise({'validFiles': [], 'invalidFiles': invalidFiles});
	    }
	
	    function validateAsync(name, validationName, type, asyncFn, fn) {
	      function resolveResult(defer, file, val) {
	        function resolveInternal(fn) {
	          if (fn()) {
	            if (ignoredErrors.indexOf(name) === -1) {
	              file.$error = name;
	              (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
	              file.$errorParam = val;
	              if (invalidFiles.indexOf(file) === -1) {
	                invalidFiles.push(file);
	              }
	              if (!runAllValidation) {
	                var i = files.indexOf(file);
	                if (i > -1) files.splice(i, 1);
	              }
	              defer.resolve(false);
	            } else {
	              var j = files.indexOf(file);
	              if (j > -1) files.splice(j, 1);
	              defer.resolve(true);
	            }
	          } else {
	            defer.resolve(true);
	          }
	        }
	
	        if (val != null) {
	          asyncFn(file, val).then(function (d) {
	            resolveInternal(function () {
	              return !fn(d, val);
	            });
	          }, function () {
	            resolveInternal(function () {
	              return attrGetter('ngfValidateForce', {$file: file});
	            });
	          });
	        } else {
	          defer.resolve(true);
	        }
	      }
	
	      var promises = [upload.emptyPromise(true)];
	      if (files) {
	        files = files.length === undefined ? [files] : files;
	        angular.forEach(files, function (file) {
	          var defer = $q.defer();
	          promises.push(defer.promise);
	          if (type && (file.type == null || file.type.search(type) !== 0)) {
	            defer.resolve(true);
	            return;
	          }
	          if (name === 'dimensions' && upload.attrGetter('ngfDimensions', attr) != null) {
	            upload.imageDimensions(file).then(function (d) {
	              resolveResult(defer, file,
	                attrGetter('ngfDimensions', {$file: file, $width: d.width, $height: d.height}));
	            }, function () {
	              defer.resolve(false);
	            });
	          } else if (name === 'duration' && upload.attrGetter('ngfDuration', attr) != null) {
	            upload.mediaDuration(file).then(function (d) {
	              resolveResult(defer, file,
	                attrGetter('ngfDuration', {$file: file, $duration: d}));
	            }, function () {
	              defer.resolve(false);
	            });
	          } else {
	            resolveResult(defer, file,
	              upload.getValidationAttr(attr, scope, name, validationName, file));
	          }
	        });
	      }
	      var deffer = $q.defer();
	      $q.all(promises).then(function (values) {
	        var isValid = true;
	        for (var i = 0; i < values.length; i++) {
	          if (!values[i]) {
	            isValid = false;
	            break;
	          }
	        }
	        ngModel.$ngfValidations.push({name: name, valid: isValid});
	        deffer.resolve(isValid);
	      });
	      return deffer.promise;
	    }
	
	    var deffer = $q.defer();
	    var promises = [];
	
	    promises.push(validateAsync('maxHeight', 'height.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.height <= val;
	      }));
	    promises.push(validateAsync('minHeight', 'height.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.height >= val;
	      }));
	    promises.push(validateAsync('maxWidth', 'width.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.width <= val;
	      }));
	    promises.push(validateAsync('minWidth', 'width.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.width >= val;
	      }));
	    promises.push(validateAsync('dimensions', null, /image/,
	      function (file, val) {
	        return upload.emptyPromise(val);
	      }, function (r) {
	        return r;
	      }));
	    promises.push(validateAsync('ratio', null, /image/,
	      this.imageDimensions, function (d, val) {
	        var split = val.toString().split(','), valid = false;
	        for (var i = 0; i < split.length; i++) {
	          if (Math.abs((d.width / d.height) - upload.ratioToFloat(split[i])) < 0.01) {
	            valid = true;
	          }
	        }
	        return valid;
	      }));
	    promises.push(validateAsync('maxRatio', 'ratio.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return (d.width / d.height) - upload.ratioToFloat(val) < 0.0001;
	      }));
	    promises.push(validateAsync('minRatio', 'ratio.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return (d.width / d.height) - upload.ratioToFloat(val) > -0.0001;
	      }));
	    promises.push(validateAsync('maxDuration', 'duration.max', /audio|video/,
	      this.mediaDuration, function (d, val) {
	        return d <= upload.translateScalars(val);
	      }));
	    promises.push(validateAsync('minDuration', 'duration.min', /audio|video/,
	      this.mediaDuration, function (d, val) {
	        return d >= upload.translateScalars(val);
	      }));
	    promises.push(validateAsync('duration', null, /audio|video/,
	      function (file, val) {
	        return upload.emptyPromise(val);
	      }, function (r) {
	        return r;
	      }));
	
	    promises.push(validateAsync('validateAsyncFn', null, null,
	      function (file, val) {
	        return val;
	      }, function (r) {
	        return r === true || r === null || r === '';
	      }));
	
	    $q.all(promises).then(function () {
	
	      if (runAllValidation) {
	        for (var i = 0; i < files.length; i++) {
	          var file = files[i];
	          if (file.$error) {
	            files.splice(i--, 1);
	          }
	        }
	      }
	
	      runAllValidation = false;
	      validateSync('maxFiles', null, function (file, val, i) {
	        return prevLength + i < val;
	      });
	
	      deffer.resolve({'validFiles': files, 'invalidFiles': invalidFiles});
	    });
	    return deffer.promise;
	  };
	
	  upload.imageDimensions = function (file) {
	    if (file.$ngfWidth && file.$ngfHeight) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve({width: file.$ngfWidth, height: file.$ngfHeight});
	      });
	      return d.promise;
	    }
	    if (file.$ngfDimensionPromise) return file.$ngfDimensionPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('image') !== 0) {
	        deferred.reject('not image');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var img = angular.element('<img>').attr('src', dataUrl)
	          .css('visibility', 'hidden').css('position', 'fixed')
	          .css('max-width', 'none !important').css('max-height', 'none !important');
	
	        function success() {
	          var width = img[0].naturalWidth || img[0].clientWidth;
	          var height = img[0].naturalHeight || img[0].clientHeight;
	          img.remove();
	          file.$ngfWidth = width;
	          file.$ngfHeight = height;
	          deferred.resolve({width: width, height: height});
	        }
	
	        function error() {
	          img.remove();
	          deferred.reject('load error');
	        }
	
	        img.on('load', success);
	        img.on('error', error);
	
	        var secondsCounter = 0;
	        function checkLoadErrorInCaseOfNoCallback() {
	          $timeout(function () {
	            if (img[0].parentNode) {
	              if (img[0].clientWidth) {
	                success();
	              } else if (secondsCounter++ > 10) {
	                error();
	              } else {
	                checkLoadErrorInCaseOfNoCallback();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadErrorInCaseOfNoCallback();
	
	        angular.element(document.getElementsByTagName('body')[0]).append(img);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDimensionPromise = deferred.promise;
	    file.$ngfDimensionPromise['finally'](function () {
	      delete file.$ngfDimensionPromise;
	    });
	    return file.$ngfDimensionPromise;
	  };
	
	  upload.mediaDuration = function (file) {
	    if (file.$ngfDuration) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve(file.$ngfDuration);
	      });
	      return d.promise;
	    }
	    if (file.$ngfDurationPromise) return file.$ngfDurationPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('audio') !== 0 && file.type.indexOf('video') !== 0) {
	        deferred.reject('not media');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var el = angular.element(file.type.indexOf('audio') === 0 ? '<audio>' : '<video>')
	          .attr('src', dataUrl).css('visibility', 'none').css('position', 'fixed');
	
	        function success() {
	          var duration = el[0].duration;
	          file.$ngfDuration = duration;
	          el.remove();
	          deferred.resolve(duration);
	        }
	
	        function error() {
	          el.remove();
	          deferred.reject('load error');
	        }
	
	        el.on('loadedmetadata', success);
	        el.on('error', error);
	        var count = 0;
	
	        function checkLoadError() {
	          $timeout(function () {
	            if (el[0].parentNode) {
	              if (el[0].duration) {
	                success();
	              } else if (count > 10) {
	                error();
	              } else {
	                checkLoadError();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadError();
	
	        angular.element(document.body).append(el);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDurationPromise = deferred.promise;
	    file.$ngfDurationPromise['finally'](function () {
	      delete file.$ngfDurationPromise;
	    });
	    return file.$ngfDurationPromise;
	  };
	  return upload;
	}
	]);
	
	ngFileUpload.service('UploadResize', ['UploadValidate', '$q', function (UploadValidate, $q) {
	  var upload = UploadValidate;
	
	  /**
	   * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
	   * images to fit into a certain area.
	   * Source:  http://stackoverflow.com/a/14731922
	   *
	   * @param {Number} srcWidth Source area width
	   * @param {Number} srcHeight Source area height
	   * @param {Number} maxWidth Nestable area maximum available width
	   * @param {Number} maxHeight Nestable area maximum available height
	   * @return {Object} { width, height }
	   */
	  var calculateAspectRatioFit = function (srcWidth, srcHeight, maxWidth, maxHeight, centerCrop) {
	    var ratio = centerCrop ? Math.max(maxWidth / srcWidth, maxHeight / srcHeight) :
	      Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
	    return {
	      width: srcWidth * ratio, height: srcHeight * ratio,
	      marginX: srcWidth * ratio - maxWidth, marginY: srcHeight * ratio - maxHeight
	    };
	  };
	
	  // Extracted from https://github.com/romelgomez/angular-firebase-image-upload/blob/master/app/scripts/fileUpload.js#L89
	  var resize = function (imagen, width, height, quality, type, ratio, centerCrop, resizeIf) {
	    var deferred = $q.defer();
	    var canvasElement = document.createElement('canvas');
	    var imageElement = document.createElement('img');
	    imageElement.setAttribute('style', 'visibility:hidden;position:fixed;z-index:-100000');
	    document.body.appendChild(imageElement);
	
	    imageElement.onload = function () {
	      var imgWidth = imageElement.width, imgHeight = imageElement.height;
	      imageElement.parentNode.removeChild(imageElement);
	      if (resizeIf != null && resizeIf(imgWidth, imgHeight) === false) {
	        deferred.reject('resizeIf');
	        return;
	      }
	      try {
	        if (ratio) {
	          var ratioFloat = upload.ratioToFloat(ratio);
	          var imgRatio = imgWidth / imgHeight;
	          if (imgRatio < ratioFloat) {
	            width = imgWidth;
	            height = width / ratioFloat;
	          } else {
	            height = imgHeight;
	            width = height * ratioFloat;
	          }
	        }
	        if (!width) {
	          width = imgWidth;
	        }
	        if (!height) {
	          height = imgHeight;
	        }
	        var dimensions = calculateAspectRatioFit(imgWidth, imgHeight, width, height, centerCrop);
	        canvasElement.width = Math.min(dimensions.width, width);
	        canvasElement.height = Math.min(dimensions.height, height);
	        var context = canvasElement.getContext('2d');
	        context.drawImage(imageElement,
	          Math.min(0, -dimensions.marginX / 2), Math.min(0, -dimensions.marginY / 2),
	          dimensions.width, dimensions.height);
	        deferred.resolve(canvasElement.toDataURL(type || 'image/WebP', quality || 0.934));
	      } catch (e) {
	        deferred.reject(e);
	      }
	    };
	    imageElement.onerror = function () {
	      imageElement.parentNode.removeChild(imageElement);
	      deferred.reject();
	    };
	    imageElement.src = imagen;
	    return deferred.promise;
	  };
	
	  upload.dataUrltoBlob = function (dataurl, name, origSize) {
	    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
	      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
	    while (n--) {
	      u8arr[n] = bstr.charCodeAt(n);
	    }
	    var blob = new window.Blob([u8arr], {type: mime});
	    blob.name = name;
	    blob.$ngfOrigSize = origSize;
	    return blob;
	  };
	
	  upload.isResizeSupported = function () {
	    var elem = document.createElement('canvas');
	    return window.atob && elem.getContext && elem.getContext('2d') && window.Blob;
	  };
	
	  if (upload.isResizeSupported()) {
	    // add name getter to the blob constructor prototype
	    Object.defineProperty(window.Blob.prototype, 'name', {
	      get: function () {
	        return this.$ngfName;
	      },
	      set: function (v) {
	        this.$ngfName = v;
	      },
	      configurable: true
	    });
	  }
	
	  upload.resize = function (file, options) {
	    if (file.type.indexOf('image') !== 0) return upload.emptyPromise(file);
	
	    var deferred = $q.defer();
	    upload.dataUrl(file, true).then(function (url) {
	      resize(url, options.width, options.height, options.quality, options.type || file.type,
	        options.ratio, options.centerCrop, options.resizeIf)
	        .then(function (dataUrl) {
	          if (file.type === 'image/jpeg' && options.restoreExif !== false) {
	            try {
	              dataUrl = upload.restoreExif(url, dataUrl);
	            } catch (e) {
	              setTimeout(function () {throw e;}, 1);
	            }
	          }
	          try {
	            var blob = upload.dataUrltoBlob(dataUrl, file.name, file.size);
	            deferred.resolve(blob);
	          } catch (e) {
	            deferred.reject(e);
	          }
	        }, function (r) {
	          if (r === 'resizeIf') {
	            deferred.resolve(file);
	          }
	          deferred.reject(r);
	        });
	    }, function (e) {
	      deferred.reject(e);
	    });
	    return deferred.promise;
	  };
	
	  return upload;
	}]);
	
	(function () {
	  ngFileUpload.directive('ngfDrop', ['$parse', '$timeout', '$window', 'Upload', '$http', '$q',
	    function ($parse, $timeout, $window, Upload, $http, $q) {
	      return {
	        restrict: 'AEC',
	        require: '?ngModel',
	        link: function (scope, elem, attr, ngModel) {
	          linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, Upload, $http, $q);
	        }
	      };
	    }]);
	
	  ngFileUpload.directive('ngfNoFileDrop', function () {
	    return function (scope, elem) {
	      if (dropAvailable()) elem.css('display', 'none');
	    };
	  });
	
	  ngFileUpload.directive('ngfDropAvailable', ['$parse', '$timeout', 'Upload', function ($parse, $timeout, Upload) {
	    return function (scope, elem, attr) {
	      if (dropAvailable()) {
	        var model = $parse(Upload.attrGetter('ngfDropAvailable', attr));
	        $timeout(function () {
	          model(scope);
	          if (model.assign) {
	            model.assign(scope, true);
	          }
	        });
	      }
	    };
	  }]);
	
	  function linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, upload, $http, $q) {
	    var available = dropAvailable();
	
	    var attrGetter = function (name, scope, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    if (attrGetter('dropAvailable')) {
	      $timeout(function () {
	        if (scope[attrGetter('dropAvailable')]) {
	          scope[attrGetter('dropAvailable')].value = available;
	        } else {
	          scope[attrGetter('dropAvailable')] = available;
	        }
	      });
	    }
	    if (!available) {
	      if (attrGetter('ngfHideOnDropNotAvailable', scope) === true) {
	        elem.css('display', 'none');
	      }
	      return;
	    }
	
	    function isDisabled() {
	      return elem.attr('disabled') || attrGetter('ngfDropDisabled', scope);
	    }
	
	    if (attrGetter('ngfSelect') == null) {
	      upload.registerModelChangeValidator(ngModel, attr, scope);
	    }
	
	    var leaveTimeout = null;
	    var stopPropagation = $parse(attrGetter('ngfStopPropagation'));
	    var dragOverDelay = 1;
	    var actualDragOverClass;
	
	    elem[0].addEventListener('dragover', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      // handling dragover events from the Chrome download bar
	      if (navigator.userAgent.indexOf('Chrome') > -1) {
	        var b = evt.dataTransfer.effectAllowed;
	        evt.dataTransfer.dropEffect = ('move' === b || 'linkMove' === b) ? 'move' : 'copy';
	      }
	      $timeout.cancel(leaveTimeout);
	      if (!actualDragOverClass) {
	        actualDragOverClass = 'C';
	        calculateDragOverClass(scope, attr, evt, function (clazz) {
	          actualDragOverClass = clazz;
	          elem.addClass(actualDragOverClass);
	          attrGetter('ngfDrag', scope, {$isDragging: true, $class: actualDragOverClass, $event: evt});
	        });
	      }
	    }, false);
	    elem[0].addEventListener('dragenter', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	    }, false);
	    elem[0].addEventListener('dragleave', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      leaveTimeout = $timeout(function () {
	        if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	        actualDragOverClass = null;
	        attrGetter('ngfDrag', scope, {$isDragging: false, $event: evt});
	      }, dragOverDelay || 100);
	    }, false);
	    elem[0].addEventListener('drop', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	      actualDragOverClass = null;
	      extractFilesAndUpdateModel(evt.dataTransfer, evt, 'dropUrl');
	    }, false);
	    elem[0].addEventListener('paste', function (evt) {
	      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
	        attrGetter('ngfEnableFirefoxPaste', scope)) {
	        evt.preventDefault();
	      }
	      if (isDisabled() || !upload.shouldUpdateOn('paste', attr, scope)) return;
	      extractFilesAndUpdateModel(evt.clipboardData || evt.originalEvent.clipboardData, evt, 'pasteUrl');
	    }, false);
	
	    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
	      attrGetter('ngfEnableFirefoxPaste', scope)) {
	      elem.attr('contenteditable', true);
	      elem.on('keypress', function (e) {
	        if (!e.metaKey && !e.ctrlKey) {
	          e.preventDefault();
	        }
	      });
	    }
	
	    function extractFilesAndUpdateModel(source, evt, updateOnType) {
	      if (!source) return;
	      // html needs to be calculated on the same process otherwise the data will be wiped
	      // after promise resolve or setTimeout.
	      var html;
	      try {
	        html = source && source.getData && source.getData('text/html');
	      } catch (e) {/* Fix IE11 that throw error calling getData */
	      }
	      extractFiles(source.items, source.files, attrGetter('ngfAllowDir', scope) !== false,
	        attrGetter('multiple') || attrGetter('ngfMultiple', scope)).then(function (files) {
	        if (files.length) {
	          updateModel(files, evt);
	        } else {
	          extractFilesFromHtml(updateOnType, html).then(function (files) {
	            updateModel(files, evt);
	          });
	        }
	      });
	    }
	
	    function updateModel(files, evt) {
	      upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
	    }
	
	    function extractFilesFromHtml(updateOn, html) {
	      if (!upload.shouldUpdateOn(updateOn, attr, scope) || typeof html !== 'string') return upload.rejectPromise([]);
	      var urls = [];
	      html.replace(/<(img src|img [^>]* src) *=\"([^\"]*)\"/gi, function (m, n, src) {
	        urls.push(src);
	      });
	      var promises = [], files = [];
	      if (urls.length) {
	        angular.forEach(urls, function (url) {
	          promises.push(upload.urlToBlob(url).then(function (blob) {
	            files.push(blob);
	          }));
	        });
	        var defer = $q.defer();
	        $q.all(promises).then(function () {
	          defer.resolve(files);
	        }, function (e) {
	          defer.reject(e);
	        });
	        return defer.promise;
	      }
	      return upload.emptyPromise();
	    }
	
	    function calculateDragOverClass(scope, attr, evt, callback) {
	      var obj = attrGetter('ngfDragOverClass', scope, {$event: evt}), dClass = 'dragover';
	      if (angular.isString(obj)) {
	        dClass = obj;
	      } else if (obj) {
	        if (obj.delay) dragOverDelay = obj.delay;
	        if (obj.accept || obj.reject) {
	          var items = evt.dataTransfer.items;
	          if (items == null || !items.length) {
	            dClass = obj.accept;
	          } else {
	            var pattern = obj.pattern || attrGetter('ngfPattern', scope, {$event: evt});
	            var len = items.length;
	            while (len--) {
	              if (!upload.validatePattern(items[len], pattern)) {
	                dClass = obj.reject;
	                break;
	              } else {
	                dClass = obj.accept;
	              }
	            }
	          }
	        }
	      }
	      callback(dClass);
	    }
	
	    function extractFiles(items, fileList, allowDir, multiple) {
	      var maxFiles = upload.getValidationAttr(attr, scope, 'maxFiles');
	      if (maxFiles == null) {
	        maxFiles = Number.MAX_VALUE;
	      }
	      var maxTotalSize = upload.getValidationAttr(attr, scope, 'maxTotalSize');
	      if (maxTotalSize == null) {
	        maxTotalSize = Number.MAX_VALUE;
	      }
	      var includeDir = attrGetter('ngfIncludeDir', scope);
	      var files = [], totalSize = 0;
	
	      function traverseFileTree(entry, path) {
	        var defer = $q.defer();
	        if (entry != null) {
	          if (entry.isDirectory) {
	            var promises = [upload.emptyPromise()];
	            if (includeDir) {
	              var file = {type: 'directory'};
	              file.name = file.path = (path || '') + entry.name;
	              files.push(file);
	            }
	            var dirReader = entry.createReader();
	            var entries = [];
	            var readEntries = function () {
	              dirReader.readEntries(function (results) {
	                try {
	                  if (!results.length) {
	                    angular.forEach(entries.slice(0), function (e) {
	                      if (files.length <= maxFiles && totalSize <= maxTotalSize) {
	                        promises.push(traverseFileTree(e, (path ? path : '') + entry.name + '/'));
	                      }
	                    });
	                    $q.all(promises).then(function () {
	                      defer.resolve();
	                    }, function (e) {
	                      defer.reject(e);
	                    });
	                  } else {
	                    entries = entries.concat(Array.prototype.slice.call(results || [], 0));
	                    readEntries();
	                  }
	                } catch (e) {
	                  defer.reject(e);
	                }
	              }, function (e) {
	                defer.reject(e);
	              });
	            };
	            readEntries();
	          } else {
	            entry.file(function (file) {
	              try {
	                file.path = (path ? path : '') + file.name;
	                if (includeDir) {
	                  file = upload.rename(file, file.path);
	                }
	                files.push(file);
	                totalSize += file.size;
	                defer.resolve();
	              } catch (e) {
	                defer.reject(e);
	              }
	            }, function (e) {
	              defer.reject(e);
	            });
	          }
	        }
	        return defer.promise;
	      }
	
	      var promises = [upload.emptyPromise()];
	
	      if (items && items.length > 0 && $window.location.protocol !== 'file:') {
	        for (var i = 0; i < items.length; i++) {
	          if (items[i].webkitGetAsEntry && items[i].webkitGetAsEntry() && items[i].webkitGetAsEntry().isDirectory) {
	            var entry = items[i].webkitGetAsEntry();
	            if (entry.isDirectory && !allowDir) {
	              continue;
	            }
	            if (entry != null) {
	              promises.push(traverseFileTree(entry));
	            }
	          } else {
	            var f = items[i].getAsFile();
	            if (f != null) {
	              files.push(f);
	              totalSize += f.size;
	            }
	          }
	          if (files.length > maxFiles || totalSize > maxTotalSize ||
	            (!multiple && files.length > 0)) break;
	        }
	      } else {
	        if (fileList != null) {
	          for (var j = 0; j < fileList.length; j++) {
	            var file = fileList.item(j);
	            if (file.type || file.size > 0) {
	              files.push(file);
	              totalSize += file.size;
	            }
	            if (files.length > maxFiles || totalSize > maxTotalSize ||
	              (!multiple && files.length > 0)) break;
	          }
	        }
	      }
	
	      var defer = $q.defer();
	      $q.all(promises).then(function () {
	        if (!multiple && !includeDir && files.length) {
	          var i = 0;
	          while (files[i] && files[i].type === 'directory') i++;
	          defer.resolve([files[i]]);
	        } else {
	          defer.resolve(files);
	        }
	      }, function (e) {
	        defer.reject(e);
	      });
	
	      return defer.promise;
	    }
	  }
	
	  function dropAvailable() {
	    var div = document.createElement('div');
	    return ('draggable' in div) && ('ondrop' in div) && !/Edge\/12./i.test(navigator.userAgent);
	  }
	
	})();
	
	// customized version of https://github.com/exif-js/exif-js
	ngFileUpload.service('UploadExif', ['UploadResize', '$q', function (UploadResize, $q) {
	  var upload = UploadResize;
	
	  upload.isExifSupported = function () {
	    return window.FileReader && new FileReader().readAsArrayBuffer && upload.isResizeSupported();
	  };
	
	  function applyTransform(ctx, orientation, width, height) {
	    switch (orientation) {
	      case 2:
	        return ctx.transform(-1, 0, 0, 1, width, 0);
	      case 3:
	        return ctx.transform(-1, 0, 0, -1, width, height);
	      case 4:
	        return ctx.transform(1, 0, 0, -1, 0, height);
	      case 5:
	        return ctx.transform(0, 1, 1, 0, 0, 0);
	      case 6:
	        return ctx.transform(0, 1, -1, 0, height, 0);
	      case 7:
	        return ctx.transform(0, -1, -1, 0, height, width);
	      case 8:
	        return ctx.transform(0, -1, 1, 0, 0, width);
	    }
	  }
	
	  upload.readOrientation = function (file) {
	    var defer = $q.defer();
	    var reader = new FileReader();
	    var slicedFile = file.slice ? file.slice(0, 64 * 1024) : file;
	    reader.readAsArrayBuffer(slicedFile);
	    reader.onerror = function (e) {
	      return defer.reject(e);
	    };
	    reader.onload = function (e) {
	      var result = {orientation: 1};
	      var view = new DataView(this.result);
	      if (view.getUint16(0, false) !== 0xFFD8) return defer.resolve(result);
	
	      var length = view.byteLength,
	        offset = 2;
	      while (offset < length) {
	        var marker = view.getUint16(offset, false);
	        offset += 2;
	        if (marker === 0xFFE1) {
	          if (view.getUint32(offset += 2, false) !== 0x45786966) return defer.resolve(result);
	
	          var little = view.getUint16(offset += 6, false) === 0x4949;
	          offset += view.getUint32(offset + 4, little);
	          var tags = view.getUint16(offset, little);
	          offset += 2;
	          for (var i = 0; i < tags; i++)
	            if (view.getUint16(offset + (i * 12), little) === 0x0112) {
	              var orientation = view.getUint16(offset + (i * 12) + 8, little);
	              if (orientation >= 2 && orientation <= 8) {
	                view.setUint16(offset + (i * 12) + 8, 1, little);
	                result.fixedArrayBuffer = e.target.result;
	              }
	              result.orientation = orientation;
	              return defer.resolve(result);
	            }
	        } else if ((marker & 0xFF00) !== 0xFF00) break;
	        else offset += view.getUint16(offset, false);
	      }
	      return defer.resolve(result);
	    };
	    return defer.promise;
	  };
	
	  function arrayBufferToBase64(buffer) {
	    var binary = '';
	    var bytes = new Uint8Array(buffer);
	    var len = bytes.byteLength;
	    for (var i = 0; i < len; i++) {
	      binary += String.fromCharCode(bytes[i]);
	    }
	    return window.btoa(binary);
	  }
	
	  upload.applyExifRotation = function (file) {
	    if (file.type.indexOf('image/jpeg') !== 0) {
	      return upload.emptyPromise(file);
	    }
	
	    var deferred = $q.defer();
	    upload.readOrientation(file).then(function (result) {
	      if (result.orientation < 2 || result.orientation > 8) {
	        return deferred.resolve(file);
	      }
	      upload.dataUrl(file, true).then(function (url) {
	        var canvas = document.createElement('canvas');
	        var img = document.createElement('img');
	
	        img.onload = function () {
	          try {
	            canvas.width = result.orientation > 4 ? img.height : img.width;
	            canvas.height = result.orientation > 4 ? img.width : img.height;
	            var ctx = canvas.getContext('2d');
	            applyTransform(ctx, result.orientation, img.width, img.height);
	            ctx.drawImage(img, 0, 0);
	            var dataUrl = canvas.toDataURL(file.type || 'image/WebP', 0.934);
	            dataUrl = upload.restoreExif(arrayBufferToBase64(result.fixedArrayBuffer), dataUrl);
	            var blob = upload.dataUrltoBlob(dataUrl, file.name);
	            deferred.resolve(blob);
	          } catch (e) {
	            return deferred.reject(e);
	          }
	        };
	        img.onerror = function () {
	          deferred.reject();
	        };
	        img.src = url;
	      }, function (e) {
	        deferred.reject(e);
	      });
	    }, function (e) {
	      deferred.reject(e);
	    });
	    return deferred.promise;
	  };
	
	  upload.restoreExif = function (orig, resized) {
	    var ExifRestorer = {};
	
	    ExifRestorer.KEY_STR = 'ABCDEFGHIJKLMNOP' +
	      'QRSTUVWXYZabcdef' +
	      'ghijklmnopqrstuv' +
	      'wxyz0123456789+/' +
	      '=';
	
	    ExifRestorer.encode64 = function (input) {
	      var output = '',
	        chr1, chr2, chr3 = '',
	        enc1, enc2, enc3, enc4 = '',
	        i = 0;
	
	      do {
	        chr1 = input[i++];
	        chr2 = input[i++];
	        chr3 = input[i++];
	
	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	        enc4 = chr3 & 63;
	
	        if (isNaN(chr2)) {
	          enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	          enc4 = 64;
	        }
	
	        output = output +
	          this.KEY_STR.charAt(enc1) +
	          this.KEY_STR.charAt(enc2) +
	          this.KEY_STR.charAt(enc3) +
	          this.KEY_STR.charAt(enc4);
	        chr1 = chr2 = chr3 = '';
	        enc1 = enc2 = enc3 = enc4 = '';
	      } while (i < input.length);
	
	      return output;
	    };
	
	    ExifRestorer.restore = function (origFileBase64, resizedFileBase64) {
	      if (origFileBase64.match('data:image/jpeg;base64,')) {
	        origFileBase64 = origFileBase64.replace('data:image/jpeg;base64,', '');
	      }
	
	      var rawImage = this.decode64(origFileBase64);
	      var segments = this.slice2Segments(rawImage);
	
	      var image = this.exifManipulation(resizedFileBase64, segments);
	
	      return 'data:image/jpeg;base64,' + this.encode64(image);
	    };
	
	
	    ExifRestorer.exifManipulation = function (resizedFileBase64, segments) {
	      var exifArray = this.getExifArray(segments),
	        newImageArray = this.insertExif(resizedFileBase64, exifArray);
	      return new Uint8Array(newImageArray);
	    };
	
	
	    ExifRestorer.getExifArray = function (segments) {
	      var seg;
	      for (var x = 0; x < segments.length; x++) {
	        seg = segments[x];
	        if (seg[0] === 255 & seg[1] === 225) //(ff e1)
	        {
	          return seg;
	        }
	      }
	      return [];
	    };
	
	
	    ExifRestorer.insertExif = function (resizedFileBase64, exifArray) {
	      var imageData = resizedFileBase64.replace('data:image/jpeg;base64,', ''),
	        buf = this.decode64(imageData),
	        separatePoint = buf.indexOf(255, 3),
	        mae = buf.slice(0, separatePoint),
	        ato = buf.slice(separatePoint),
	        array = mae;
	
	      array = array.concat(exifArray);
	      array = array.concat(ato);
	      return array;
	    };
	
	
	    ExifRestorer.slice2Segments = function (rawImageArray) {
	      var head = 0,
	        segments = [];
	
	      while (1) {
	        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) {
	          break;
	        }
	        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) {
	          head += 2;
	        }
	        else {
	          var length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3],
	            endPoint = head + length + 2,
	            seg = rawImageArray.slice(head, endPoint);
	          segments.push(seg);
	          head = endPoint;
	        }
	        if (head > rawImageArray.length) {
	          break;
	        }
	      }
	
	      return segments;
	    };
	
	
	    ExifRestorer.decode64 = function (input) {
	      var chr1, chr2, chr3 = '',
	        enc1, enc2, enc3, enc4 = '',
	        i = 0,
	        buf = [];
	
	      // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
	      var base64test = /[^A-Za-z0-9\+\/\=]/g;
	      if (base64test.exec(input)) {
	        console.log('There were invalid base64 characters in the input text.\n' +
	          'Valid base64 characters are A-Z, a-z, 0-9, ' + ', ' / ',and "="\n' +
	          'Expect errors in decoding.');
	      }
	      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
	
	      do {
	        enc1 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc2 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc3 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc4 = this.KEY_STR.indexOf(input.charAt(i++));
	
	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;
	
	        buf.push(chr1);
	
	        if (enc3 !== 64) {
	          buf.push(chr2);
	        }
	        if (enc4 !== 64) {
	          buf.push(chr3);
	        }
	
	        chr1 = chr2 = chr3 = '';
	        enc1 = enc2 = enc3 = enc4 = '';
	
	      } while (i < input.length);
	
	      return buf;
	    };
	
	    return ExifRestorer.restore(orig, resized);  //<= EXIF
	  };
	
	  return upload;
	}]);
	


/***/ }),
/* 125 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })
]);


// WEBPACK FOOTER //
// app.9667a361b72d69d85153.js